(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mounted = new WeakMap();
    const pageLoaded = new Promise((resolve) => {
      if (document.readyState === 'complete') {
        const navigation = performance.getEntriesByType('navigation')[0];
        resolve(navigation?.loadEventEnd || performance.now());
      } else {
        window.addEventListener('load', () => resolve(performance.now()), { once: true });
      }
    });

    const mount = (root) => {
      root.querySelectorAll('[data-prowlet-hero-hover]').forEach((banner) => {
        if (mounted.has(banner)) return;
        const layer = banner.querySelector('.prowlet-hero-image--hover');
        const image = layer?.querySelector('img') || layer;
        if (!image) return;
        const controller = new AbortController();
        const state = { controller, timer: null };
        mounted.set(banner, state);
        const touch = window.matchMedia('(hover: none)');
        let ready = false;
        let loadedAt = null;
        const reveal = () => {
          if (!ready || loadedAt === null || !touch.matches || state.timer !== null) return;
          state.timer = window.setTimeout(() => {
            state.timer = null;
            if (banner.isConnected && touch.matches) banner.classList.add('is-touch-revealed');
          }, Math.max(0, loadedAt + 2000 - performance.now()));
        };
        const markReady = async () => {
          if (!image.naturalWidth) return;
          try { await image.decode(); } catch { return; }
          if (controller.signal.aborted) return;
          ready = true;
          banner.setAttribute('data-prowlet-hero-ready', '');
          reveal();
        };
        if (image.complete) markReady();
        else image.addEventListener('load', markReady, { once: true, signal: controller.signal });
        pageLoaded.then((time) => {
          if (controller.signal.aborted) return;
          loadedAt = time;
          reveal();
        });
        touch.addEventListener('change', reveal, { signal: controller.signal });
      });
    };

    mount(document);
    document.addEventListener('shopify:section:load', (event) => mount(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-prowlet-hero-hover]').forEach((banner) => {
        const state = mounted.get(banner);
        if (!state) return;
        state.controller.abort();
        window.clearTimeout(state.timer);
        mounted.delete(banner);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-garden-tunnel-pdp-v10"] && !Shopify.designMode) return;
  try {
    
function injectGardenTunnelCompactRepair() {
  if (document.getElementById('gt-pdp-section-wildone-repair-20260523')) return;

  const style = document.createElement('style');
  style.id = 'gt-pdp-section-wildone-repair-20260523';
  style.textContent = `
    html body .shopify-section .gt-pdp .gt-pdp__hero { margin-top: 0 !important; padding: 0 40px 48px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__hero-grid { align-items: start !important; display: grid !important; gap: 20px !important; grid-template-columns: 1fr 1fr !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery { display: grid !important; gap: 8px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; min-height: 0 !important; overflow: visible !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 4 / 5 !important; height: auto !important; min-height: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { align-self: stretch !important; display: block !important; min-width: 0 !important; padding: 0 !important; position: relative !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { align-self: start !important; bottom: auto !important; left: auto !important; max-height: none !important; overflow: visible !important; padding: 10px 0 22px !important; position: sticky !important; top: calc(var(--header-height, 88px) + 10px) !important; width: auto !important; z-index: 30 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__breadcrumb, html body .shopify-section .gt-pdp .gt-pdp__eyebrow { align-items: center !important; background: #CCBCA8 !important; border-radius: 3px !important; color: #593518 !important; display: inline-flex !important; font-size: 10px !important; letter-spacing: 0.12em !important; line-height: 1.2 !important; margin: 0 0 10px !important; padding: 5px 12px !important; text-transform: uppercase !important; width: fit-content !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info h1 { font-family: Georgia, "Times New Roman", serif !important; font-size: 30px !important; font-weight: 400 !important; letter-spacing: 0 !important; line-height: 1.05 !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__title-meta-row { align-items: center !important; display: flex !important; flex-wrap: wrap !important; gap: 14px !important; justify-content: flex-start !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__lead-inline { color: rgba(89, 53, 24, 0.78) !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 14px !important; font-style: italic !important; line-height: 1.35 !important; margin: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__reviews-inline, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline * { font-size: 13px !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__price { font-family: Georgia, "Times New Roman", serif !important; font-size: 20px !important; line-height: 1 !important; margin: 0 0 22px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-label { color: rgba(89, 53, 24, 0.68) !important; display: block !important; font-size: 11px !important; letter-spacing: 0.16em !important; line-height: 1.2 !important; margin: 0 0 10px !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-options { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 0 !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn { align-items: center !important; display: flex !important; flex-direction: row !important; gap: 10px !important; justify-content: space-between !important; min-height: 46px !important; padding: 0 14px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn span, html body .shopify-section .gt-pdp .gt-pdp__variant-title { font-size: 14px !important; font-weight: 500 !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn small, html body .shopify-section .gt-pdp .gt-pdp__variant-size { color: rgba(89, 53, 24, 0.68) !important; font-size: 12px !important; line-height: 1.2 !important; margin: 0 !important; text-align: right !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 16px 0 30px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row > * { width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap { min-height: 72px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__button, html body .shopify-section .gt-pdp .shopify-payment-button__button { height: 48px !important; min-height: 48px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add { font-size: 13px !important; letter-spacing: 0.08em !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__more-options { display: block !important; font-size: 11px !important; line-height: 1.3 !important; margin: 10px auto 0 !important; text-align: center !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini { align-items: center !important; column-gap: 18px !important; display: grid !important; grid-template-columns: repeat(3, minmax(0, 1fr)) !important; margin: 0 !important; padding: 16px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item { align-items: center !important; display: grid !important; gap: 0 10px !important; grid-template-columns: 40px minmax(0, 1fr) !important; justify-content: flex-start !important; min-width: 0 !important; padding: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > svg, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > picture, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > img:not(.gt-pdp__trust-icon), html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::before, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::after { content: none !important; display: none !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-icon { display: block !important; flex: 0 0 40px !important; height: 40px !important; margin: 0 !important; object-fit: contain !important; width: 40px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-copy { display: block !important; min-width: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-title { display: block !important; font-size: 10.5px !important; letter-spacing: 0.1em !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-sub { font-size: 11px !important; line-height: 1.35 !important; overflow-wrap: normal !important; white-space: normal !important; word-break: normal !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-block { margin-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item:first-child { border-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item { padding: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item summary { font-size: 14px !important; font-weight: 500 !important; padding: 10px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features { clear: both !important; padding: 0 0 40px !important; position: relative !important; z-index: 1 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-heading { margin-left: auto !important; margin-right: auto !important; padding: 48px 0 32px !important; width: calc(100% - 80px) !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-grid { margin-left: auto !important; margin-right: auto !important; padding: 0 !important; width: calc(100% - 80px) !important; }
    @media (max-width: 900px) { html body .shopify-section .gt-pdp .gt-pdp__hero { padding: 0 0 32px !important; } html body .shopify-section .gt-pdp .gt-pdp__hero-grid { display: block !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery { grid-template-columns: 1fr !important; gap: 16px !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; } html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { max-height: none !important; overflow: visible !important; padding: 0 !important; position: relative !important; top: auto !important; } html body .shopify-section .gt-pdp .gt-pdp__features { padding: 0 0 40px !important; } html body .shopify-section .gt-pdp .gt-pdp__features-heading { padding: 32px 0 28px !important; width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__features-grid { width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini { grid-template-columns: 1fr !important; } }
    @media (max-width: 480px) { html body .shopify-section .gt-pdp .gt-pdp__buy-row, html body .shopify-section .gt-pdp .gt-pdp__variant-options { grid-template-columns: 1fr !important; } }
  `;
  document.head.appendChild(style);
}

function initGardenTunnelPdp(section) {
  if (!section || section.dataset.gtInitialized === '20260523-wildone-structure') return;
  section.dataset.gtInitialized = '20260523-wildone-structure';
  injectGardenTunnelCompactRepair();

  const variantInputs = Array.from(section.querySelectorAll('[data-gt-variant-input]'));
  const priceNodes = Array.from(section.querySelectorAll('[data-gt-price], [data-gt-sticky-price]'));
  const stickyCta = section.querySelector('.gt-pdp__sticky-cta');
  const heroCta = section.querySelector('.gt-pdp__cta-add');
  const recommendationsNode = section.querySelector('.gt-pdp__recommendations');
  const heroGrid = section.querySelector('.gt-pdp__hero-grid');
  const productInfoWrap = section.querySelector('.gt-pdp__product-info-wrap');
  const productInfo = section.querySelector('.gt-pdp__product-info');
  const desktopMedia = window.matchMedia('(min-width: 901px)');
  let relatedFallbackPromise = null;

  const setAccordionDefaults = () => {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    section.querySelectorAll('.gt-pdp__accordion-item').forEach((item) => {
      if (isMobile) {
        item.removeAttribute('open');
      } else if (!item.hasAttribute('data-keep-open')) {
        item.removeAttribute('open');
      }
    });
  };

  const getRelatedGrid = () => section.querySelector('.gt-pdp__related-grid');

  const formatRelatedMoney = (priceCents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        currency: window.Shopify?.currency?.active || 'USD',
        style: 'currency'
      }).format(priceCents / 100);
    } catch (error) {
      return `$${(priceCents / 100).toFixed(2)}`;
    }
  };

  const createRelatedCard = (productData) => {
    const variant = productData.variants?.[0] || {};
    const rawPrice = Number.parseFloat(variant.price || productData.price || '0');
    const priceCents = Math.round(rawPrice * 100);
    const imageData = productData.image || productData.images?.[0];
    const imageSrc = typeof imageData === 'string' ? imageData : imageData?.src;
    const imageAlt = (typeof imageData === 'object' && imageData?.alt) || productData.title || '';
    const card = document.createElement('a');
    const imageWrap = document.createElement('div');
    const title = document.createElement('p');
    const price = document.createElement('p');

    card.className = 'gt-pdp__related-card';
    card.href = `/products/${productData.handle}`;
    card.dataset.priceCents = String(priceCents);
    card.dataset.productHandle = productData.handle;
    card.dataset.relatedOrder = '99';

    imageWrap.className = 'gt-pdp__related-img';
    if (imageSrc) {
      const image = document.createElement('img');
      image.className = 'gt-pdp__image';
      image.loading = 'lazy';
      image.sizes = '(min-width: 901px) 25vw, 50vw';
      image.src = imageSrc;
      image.alt = imageAlt;
      imageWrap.appendChild(image);
    }

    title.className = 'gt-pdp__related-name';
    title.textContent = productData.title || '';

    price.className = 'gt-pdp__related-price';
    price.textContent = formatRelatedMoney(priceCents);

    card.append(imageWrap, title, price);
    return card;
  };

  const sortRelatedProducts = () => {
    const grid = getRelatedGrid();
    if (!grid) return [];

    const seenHandles = new Set([section.dataset.productHandle]);
    const cards = Array.from(grid.querySelectorAll('.gt-pdp__related-card')).filter((card) => {
      const handle = card.dataset.productHandle || card.getAttribute('href');
      if (!handle || seenHandles.has(handle)) {
        card.remove();
        return false;
      }
      seenHandles.add(handle);
      return true;
    });

    const sortedCards = cards.sort((a, b) => {
      const orderDiff = Number(a.dataset.relatedOrder ?? 99) - Number(b.dataset.relatedOrder ?? 99);
      if (orderDiff !== 0) return orderDiff;
      return Number(a.dataset.priceCents || 0) - Number(b.dataset.priceCents || 0);
    });
    sortedCards.forEach((card, index) => {
        if (grid.children[index] !== card) {
          grid.appendChild(card);
        }
        card.hidden = index >= 4;
      });

    return cards.filter((card) => !card.hidden);
  };

  const fillRelatedFallback = () => {
    const grid = getRelatedGrid();
    if (!grid || relatedFallbackPromise) return relatedFallbackPromise;

    const fallbackCollections = (recommendationsNode?.dataset.fallbackCollections || 'cat-furniture')
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean);

    relatedFallbackPromise = (async () => {
      for (const collectionHandle of fallbackCollections) {
        if (sortRelatedProducts().length >= 4) break;

        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=24`, {
          credentials: 'same-origin'
        });
        if (!response.ok) continue;

        const payload = await response.json();
        const products = Array.isArray(payload.products) ? payload.products : [];

        for (const productData of products) {
          const existingHandles = new Set(
            Array.from(grid.querySelectorAll('.gt-pdp__related-card'))
              .map((card) => card.dataset.productHandle || card.getAttribute('href'))
          );

          if (
            !productData.handle ||
            productData.handle === section.dataset.productHandle ||
            existingHandles.has(productData.handle)
          ) {
            continue;
          }

          grid.appendChild(createRelatedCard(productData));
          if (sortRelatedProducts().length >= 4) break;
        }
      }

      sortRelatedProducts();
    })().catch(() => {
      sortRelatedProducts();
    });

    return relatedFallbackPromise;
  };

  const ensureRelatedProducts = () => {
    if (sortRelatedProducts().length < 4) {
      fillRelatedFallback();
    }
  };

  const updateStickyCta = () => {
    if (!stickyCta || !heroCta) return;

    if (!desktopMedia.matches) {
      stickyCta.classList.add('is-visible');
      return;
    }

    const hasPassedHeroCta = heroCta.getBoundingClientRect().bottom <= 0;
    stickyCta.classList.toggle('is-visible', hasPassedHeroCta);
  };

  const resetProductInfoPin = () => {
    if (!productInfo || !productInfoWrap) return;

    productInfo.classList.remove('is-fixed', 'is-bottom');
    productInfo.style.left = '';
    productInfo.style.width = '';
    productInfo.style.removeProperty('--gt-product-info-max-height');
    productInfo.style.removeProperty('--gt-product-info-top');
    productInfoWrap.style.minHeight = '';
  };

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      section.querySelectorAll('.gt-pdp__variant-btn').forEach((label) => {
        label.classList.toggle('is-selected', label.contains(input));
      });

      priceNodes.forEach((node) => {
        node.textContent = input.dataset.price;
      });

    });
  });

  setAccordionDefaults();
  ensureRelatedProducts();

  if (recommendationsNode) {
    new MutationObserver(ensureRelatedProducts).observe(recommendationsNode, { childList: true });
  }

  if (stickyCta && heroCta) {
    new IntersectionObserver(updateStickyCta, { threshold: 0 }).observe(heroCta);
    window.addEventListener('resize', updateStickyCta, { passive: true });
    updateStickyCta();
  }

  if (productInfo && productInfoWrap && heroGrid) {
    resetProductInfoPin();
    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', resetProductInfoPin);
    }
  }

  window.addEventListener('resize', setAccordionDefaults, { passive: true });
}

document.querySelectorAll('.gt-pdp').forEach(initGardenTunnelPdp);
document.addEventListener('shopify:section:load', (event) => {
  initGardenTunnelPdp(event.target.querySelector('.gt-pdp'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-garden-tunnel-pdp-v11"] && !Shopify.designMode) return;
  try {
    
function injectGardenTunnelCompactRepair() {
  if (document.getElementById('gt-pdp-section-wildone-repair-20260523')) return;

  const style = document.createElement('style');
  style.id = 'gt-pdp-section-wildone-repair-20260523';
  style.textContent = `
    html body .shopify-section .gt-pdp .gt-pdp__hero { margin-top: 0 !important; padding: 0 40px 48px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__hero-grid { align-items: start !important; display: grid !important; gap: 20px !important; grid-template-columns: 1fr 1fr !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery { display: grid !important; gap: 8px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; min-height: 0 !important; overflow: visible !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 4 / 5 !important; height: auto !important; min-height: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { align-self: stretch !important; display: block !important; min-width: 0 !important; padding: 0 !important; position: relative !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { align-self: start !important; bottom: auto !important; left: auto !important; max-height: none !important; overflow: visible !important; padding: 10px 0 22px !important; position: sticky !important; top: calc(var(--header-height, 88px) + 10px) !important; width: auto !important; z-index: 30 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__breadcrumb, html body .shopify-section .gt-pdp .gt-pdp__eyebrow { align-items: center !important; background: #CCBCA8 !important; border-radius: 3px !important; color: #593518 !important; display: inline-flex !important; font-size: 10px !important; letter-spacing: 0.12em !important; line-height: 1.2 !important; margin: 0 0 10px !important; padding: 5px 12px !important; text-transform: uppercase !important; width: fit-content !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info h1 { font-family: Georgia, "Times New Roman", serif !important; font-size: 30px !important; font-weight: 400 !important; letter-spacing: 0 !important; line-height: 1.05 !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__title-meta-row { align-items: center !important; display: flex !important; flex-wrap: wrap !important; gap: 14px !important; justify-content: flex-start !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__lead-inline { color: rgba(89, 53, 24, 0.78) !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 14px !important; font-style: italic !important; line-height: 1.35 !important; margin: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__reviews-inline, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline * { font-size: 13px !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__price { font-family: Georgia, "Times New Roman", serif !important; font-size: 20px !important; line-height: 1 !important; margin: 0 0 22px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-label { color: rgba(89, 53, 24, 0.68) !important; display: block !important; font-size: 11px !important; letter-spacing: 0.16em !important; line-height: 1.2 !important; margin: 0 0 10px !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-options { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 0 !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn { align-items: center !important; display: flex !important; flex-direction: row !important; gap: 10px !important; justify-content: space-between !important; min-height: 46px !important; padding: 0 14px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn span, html body .shopify-section .gt-pdp .gt-pdp__variant-title { font-size: 14px !important; font-weight: 500 !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn small, html body .shopify-section .gt-pdp .gt-pdp__variant-size { color: rgba(89, 53, 24, 0.68) !important; font-size: 12px !important; line-height: 1.2 !important; margin: 0 !important; text-align: right !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 16px 0 30px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row > * { width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap { min-height: 72px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__button, html body .shopify-section .gt-pdp .shopify-payment-button__button { height: 48px !important; min-height: 48px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add { font-size: 13px !important; letter-spacing: 0.08em !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__more-options { display: block !important; font-size: 11px !important; line-height: 1.3 !important; margin: 10px auto 0 !important; text-align: center !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini { align-items: center !important; column-gap: 18px !important; display: grid !important; grid-template-columns: repeat(3, minmax(0, 1fr)) !important; margin: 0 !important; padding: 16px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item { align-items: center !important; display: grid !important; gap: 0 10px !important; grid-template-columns: 40px minmax(0, 1fr) !important; justify-content: flex-start !important; min-width: 0 !important; padding: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > svg, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > picture, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > img:not(.gt-pdp__trust-icon), html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::before, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::after { content: none !important; display: none !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-icon { display: block !important; flex: 0 0 40px !important; height: 40px !important; margin: 0 !important; object-fit: contain !important; width: 40px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-copy { display: block !important; min-width: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-title { display: block !important; font-size: 10.5px !important; letter-spacing: 0.1em !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-sub { font-size: 11px !important; line-height: 1.35 !important; overflow-wrap: normal !important; white-space: normal !important; word-break: normal !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-block { margin-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item:first-child { border-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item { padding: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item summary { font-size: 14px !important; font-weight: 500 !important; padding: 10px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features { clear: both !important; padding: 0 0 40px !important; position: relative !important; z-index: 1 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-heading { margin-left: auto !important; margin-right: auto !important; padding: 48px 0 32px !important; width: calc(100% - 80px) !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-grid { margin-left: auto !important; margin-right: auto !important; padding: 0 !important; width: calc(100% - 80px) !important; }
    @media (max-width: 900px) { html body .shopify-section .gt-pdp .gt-pdp__hero { padding: 0 0 32px !important; } html body .shopify-section .gt-pdp .gt-pdp__hero-grid { display: block !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery { grid-template-columns: 1fr !important; gap: 16px !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; } html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { max-height: none !important; overflow: visible !important; padding: 0 !important; position: relative !important; top: auto !important; } html body .shopify-section .gt-pdp .gt-pdp__features { padding: 0 0 40px !important; } html body .shopify-section .gt-pdp .gt-pdp__features-heading { padding: 32px 0 28px !important; width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__features-grid { width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini { grid-template-columns: 1fr !important; } }
    @media (max-width: 480px) { html body .shopify-section .gt-pdp .gt-pdp__buy-row, html body .shopify-section .gt-pdp .gt-pdp__variant-options { grid-template-columns: 1fr !important; } }
  `;
  document.head.appendChild(style);
}

function initGardenTunnelPdp(section) {
  if (!section || section.dataset.gtInitialized === '20260523-wildone-structure') return;
  section.dataset.gtInitialized = '20260523-wildone-structure';
  injectGardenTunnelCompactRepair();

  const variantInputs = Array.from(section.querySelectorAll('[data-gt-variant-input]'));
  const priceNodes = Array.from(section.querySelectorAll('[data-gt-price], [data-gt-sticky-price]'));
  const stickyCta = section.querySelector('.gt-pdp__sticky-cta');
  const heroCta = section.querySelector('.gt-pdp__cta-add');
  const recommendationsNode = section.querySelector('.gt-pdp__recommendations');
  const heroGrid = section.querySelector('.gt-pdp__hero-grid');
  const productInfoWrap = section.querySelector('.gt-pdp__product-info-wrap');
  const productInfo = section.querySelector('.gt-pdp__product-info');
  const desktopMedia = window.matchMedia('(min-width: 901px)');
  let relatedFallbackPromise = null;

  const setAccordionDefaults = () => {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    section.querySelectorAll('.gt-pdp__accordion-item').forEach((item) => {
      if (isMobile) {
        item.removeAttribute('open');
      } else if (!item.hasAttribute('data-keep-open')) {
        item.removeAttribute('open');
      }
    });
  };

  const getRelatedGrid = () => section.querySelector('.gt-pdp__related-grid');

  const formatRelatedMoney = (priceCents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        currency: window.Shopify?.currency?.active || 'USD',
        style: 'currency'
      }).format(priceCents / 100);
    } catch (error) {
      return `$${(priceCents / 100).toFixed(2)}`;
    }
  };

  const createRelatedCard = (productData) => {
    const variant = productData.variants?.[0] || {};
    const rawPrice = Number.parseFloat(variant.price || productData.price || '0');
    const priceCents = Math.round(rawPrice * 100);
    const imageData = productData.image || productData.images?.[0];
    const imageSrc = typeof imageData === 'string' ? imageData : imageData?.src;
    const imageAlt = (typeof imageData === 'object' && imageData?.alt) || productData.title || '';
    const card = document.createElement('a');
    const imageWrap = document.createElement('div');
    const title = document.createElement('p');
    const price = document.createElement('p');

    card.className = 'gt-pdp__related-card';
    card.href = `/products/${productData.handle}`;
    card.dataset.priceCents = String(priceCents);
    card.dataset.productHandle = productData.handle;
    card.dataset.relatedOrder = '99';

    imageWrap.className = 'gt-pdp__related-img';
    if (imageSrc) {
      const image = document.createElement('img');
      image.className = 'gt-pdp__image';
      image.loading = 'lazy';
      image.sizes = '(min-width: 901px) 25vw, 50vw';
      image.src = imageSrc;
      image.alt = imageAlt;
      imageWrap.appendChild(image);
    }

    title.className = 'gt-pdp__related-name';
    title.textContent = productData.title || '';

    price.className = 'gt-pdp__related-price';
    price.textContent = formatRelatedMoney(priceCents);

    card.append(imageWrap, title, price);
    return card;
  };

  const sortRelatedProducts = () => {
    const grid = getRelatedGrid();
    if (!grid) return [];

    const seenHandles = new Set([section.dataset.productHandle]);
    const cards = Array.from(grid.querySelectorAll('.gt-pdp__related-card')).filter((card) => {
      const handle = card.dataset.productHandle || card.getAttribute('href');
      if (!handle || seenHandles.has(handle)) {
        card.remove();
        return false;
      }
      seenHandles.add(handle);
      return true;
    });

    const sortedCards = cards.sort((a, b) => {
      const orderDiff = Number(a.dataset.relatedOrder ?? 99) - Number(b.dataset.relatedOrder ?? 99);
      if (orderDiff !== 0) return orderDiff;
      return Number(a.dataset.priceCents || 0) - Number(b.dataset.priceCents || 0);
    });
    sortedCards.forEach((card, index) => {
        if (grid.children[index] !== card) {
          grid.appendChild(card);
        }
        card.hidden = index >= 4;
      });

    return cards.filter((card) => !card.hidden);
  };

  const fillRelatedFallback = () => {
    const grid = getRelatedGrid();
    if (!grid || relatedFallbackPromise) return relatedFallbackPromise;

    const fallbackCollections = (recommendationsNode?.dataset.fallbackCollections || 'cat-furniture')
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean);

    relatedFallbackPromise = (async () => {
      for (const collectionHandle of fallbackCollections) {
        if (sortRelatedProducts().length >= 4) break;

        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=24`, {
          credentials: 'same-origin'
        });
        if (!response.ok) continue;

        const payload = await response.json();
        const products = Array.isArray(payload.products) ? payload.products : [];

        for (const productData of products) {
          const existingHandles = new Set(
            Array.from(grid.querySelectorAll('.gt-pdp__related-card'))
              .map((card) => card.dataset.productHandle || card.getAttribute('href'))
          );

          if (
            !productData.handle ||
            productData.handle === section.dataset.productHandle ||
            existingHandles.has(productData.handle)
          ) {
            continue;
          }

          grid.appendChild(createRelatedCard(productData));
          if (sortRelatedProducts().length >= 4) break;
        }
      }

      sortRelatedProducts();
    })().catch(() => {
      sortRelatedProducts();
    });

    return relatedFallbackPromise;
  };

  const ensureRelatedProducts = () => {
    if (sortRelatedProducts().length < 4) {
      fillRelatedFallback();
    }
  };

  const updateStickyCta = () => {
    if (!stickyCta || !heroCta) return;

    if (!desktopMedia.matches) {
      stickyCta.classList.add('is-visible');
      return;
    }

    const hasPassedHeroCta = heroCta.getBoundingClientRect().bottom <= 0;
    stickyCta.classList.toggle('is-visible', hasPassedHeroCta);
  };

  const resetProductInfoPin = () => {
    if (!productInfo || !productInfoWrap) return;

    productInfo.classList.remove('is-fixed', 'is-bottom');
    productInfo.style.left = '';
    productInfo.style.width = '';
    productInfo.style.removeProperty('--gt-product-info-max-height');
    productInfo.style.removeProperty('--gt-product-info-top');
    productInfoWrap.style.minHeight = '';
  };

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      section.querySelectorAll('.gt-pdp__variant-btn').forEach((label) => {
        label.classList.toggle('is-selected', label.contains(input));
      });

      priceNodes.forEach((node) => {
        node.textContent = input.dataset.price;
      });

    });
  });

  setAccordionDefaults();
  ensureRelatedProducts();

  if (recommendationsNode) {
    new MutationObserver(ensureRelatedProducts).observe(recommendationsNode, { childList: true });
  }

  if (stickyCta && heroCta) {
    new IntersectionObserver(updateStickyCta, { threshold: 0 }).observe(heroCta);
    window.addEventListener('resize', updateStickyCta, { passive: true });
    updateStickyCta();
  }

  if (productInfo && productInfoWrap && heroGrid) {
    resetProductInfoPin();
    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', resetProductInfoPin);
    }
  }

  window.addEventListener('resize', setAccordionDefaults, { passive: true });
}

document.querySelectorAll('.gt-pdp').forEach(initGardenTunnelPdp);
document.addEventListener('shopify:section:load', (event) => {
  initGardenTunnelPdp(event.target.querySelector('.gt-pdp'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-garden-tunnel-pdp-v12"] && !Shopify.designMode) return;
  try {
    
function injectGardenTunnelCompactRepair() {
  if (document.getElementById('gt-pdp-section-wildone-repair-20260523')) return;

  const style = document.createElement('style');
  style.id = 'gt-pdp-section-wildone-repair-20260523';
  style.textContent = `
    html body .shopify-section .gt-pdp .gt-pdp__hero { margin-top: 0 !important; padding: 0 40px 48px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__hero-grid { align-items: start !important; display: grid !important; gap: 20px !important; grid-template-columns: 1fr 1fr !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery { display: grid !important; gap: 8px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; min-height: 0 !important; overflow: visible !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 4 / 5 !important; height: auto !important; min-height: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { align-self: stretch !important; display: block !important; min-width: 0 !important; padding: 0 !important; position: relative !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { align-self: start !important; bottom: auto !important; left: auto !important; max-height: none !important; overflow: visible !important; padding: 10px 0 22px !important; position: sticky !important; top: calc(var(--header-height, 88px) + 10px) !important; width: auto !important; z-index: 30 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__breadcrumb, html body .shopify-section .gt-pdp .gt-pdp__eyebrow { align-items: center !important; background: #CCBCA8 !important; border-radius: 3px !important; color: #593518 !important; display: inline-flex !important; font-size: 10px !important; letter-spacing: 0.12em !important; line-height: 1.2 !important; margin: 0 0 10px !important; padding: 5px 12px !important; text-transform: uppercase !important; width: fit-content !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info h1 { font-family: Georgia, "Times New Roman", serif !important; font-size: 30px !important; font-weight: 400 !important; letter-spacing: 0 !important; line-height: 1.05 !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__title-meta-row { align-items: center !important; display: flex !important; flex-wrap: wrap !important; gap: 14px !important; justify-content: flex-start !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__lead-inline { color: rgba(89, 53, 24, 0.78) !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 14px !important; font-style: italic !important; line-height: 1.35 !important; margin: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__reviews-inline, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline * { font-size: 13px !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__price { font-family: Georgia, "Times New Roman", serif !important; font-size: 20px !important; line-height: 1 !important; margin: 0 0 22px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-label { color: rgba(89, 53, 24, 0.68) !important; display: block !important; font-size: 11px !important; letter-spacing: 0.16em !important; line-height: 1.2 !important; margin: 0 0 10px !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-options { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 0 !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn { align-items: center !important; display: flex !important; flex-direction: row !important; gap: 10px !important; justify-content: space-between !important; min-height: 46px !important; padding: 0 14px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn span, html body .shopify-section .gt-pdp .gt-pdp__variant-title { font-size: 14px !important; font-weight: 500 !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn small, html body .shopify-section .gt-pdp .gt-pdp__variant-size { color: rgba(89, 53, 24, 0.68) !important; font-size: 12px !important; line-height: 1.2 !important; margin: 0 !important; text-align: right !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 16px 0 30px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row > * { width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap { min-height: 72px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__button, html body .shopify-section .gt-pdp .shopify-payment-button__button { height: 48px !important; min-height: 48px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add { font-size: 13px !important; letter-spacing: 0.08em !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__more-options { display: block !important; font-size: 11px !important; line-height: 1.3 !important; margin: 10px auto 0 !important; text-align: center !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini { align-items: center !important; column-gap: 18px !important; display: grid !important; grid-template-columns: repeat(3, minmax(0, 1fr)) !important; margin: 0 !important; padding: 16px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item { align-items: center !important; display: grid !important; gap: 0 10px !important; grid-template-columns: 40px minmax(0, 1fr) !important; justify-content: flex-start !important; min-width: 0 !important; padding: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > svg, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > picture, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > img:not(.gt-pdp__trust-icon), html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::before, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::after { content: none !important; display: none !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-icon { display: block !important; flex: 0 0 40px !important; height: 40px !important; margin: 0 !important; object-fit: contain !important; width: 40px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-copy { display: block !important; min-width: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-title { display: block !important; font-size: 10.5px !important; letter-spacing: 0.1em !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-sub { font-size: 11px !important; line-height: 1.35 !important; overflow-wrap: normal !important; white-space: normal !important; word-break: normal !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-block { margin-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item:first-child { border-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item { padding: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item summary { font-size: 14px !important; font-weight: 500 !important; padding: 10px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features { clear: both !important; padding: 0 0 40px !important; position: relative !important; z-index: 1 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-heading { margin-left: auto !important; margin-right: auto !important; padding: 48px 0 32px !important; width: calc(100% - 80px) !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-grid { margin-left: auto !important; margin-right: auto !important; padding: 0 !important; width: calc(100% - 80px) !important; }
    @media (max-width: 900px) { html body .shopify-section .gt-pdp .gt-pdp__hero { padding: 0 0 32px !important; } html body .shopify-section .gt-pdp .gt-pdp__hero-grid { display: block !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery { grid-template-columns: 1fr !important; gap: 16px !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; } html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { max-height: none !important; overflow: visible !important; padding: 0 !important; position: relative !important; top: auto !important; } html body .shopify-section .gt-pdp .gt-pdp__features { padding: 0 0 40px !important; } html body .shopify-section .gt-pdp .gt-pdp__features-heading { padding: 32px 0 28px !important; width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__features-grid { width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini { grid-template-columns: 1fr !important; } }
    @media (max-width: 480px) { html body .shopify-section .gt-pdp .gt-pdp__buy-row, html body .shopify-section .gt-pdp .gt-pdp__variant-options { grid-template-columns: 1fr !important; } }
  `;
  document.head.appendChild(style);
}

function initGardenTunnelPdp(section) {
  if (!section || section.dataset.gtInitialized === '20260523-wildone-structure') return;
  section.dataset.gtInitialized = '20260523-wildone-structure';
  injectGardenTunnelCompactRepair();

  const variantInputs = Array.from(section.querySelectorAll('[data-gt-variant-input]'));
  const priceNodes = Array.from(section.querySelectorAll('[data-gt-price], [data-gt-sticky-price]'));
  const stickyCta = section.querySelector('.gt-pdp__sticky-cta');
  const heroCta = section.querySelector('.gt-pdp__cta-add');
  const recommendationsNode = section.querySelector('.gt-pdp__recommendations');
  const heroGrid = section.querySelector('.gt-pdp__hero-grid');
  const productInfoWrap = section.querySelector('.gt-pdp__product-info-wrap');
  const productInfo = section.querySelector('.gt-pdp__product-info');
  const desktopMedia = window.matchMedia('(min-width: 901px)');
  let relatedFallbackPromise = null;

  const setAccordionDefaults = () => {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    section.querySelectorAll('.gt-pdp__accordion-item').forEach((item) => {
      if (isMobile) {
        item.removeAttribute('open');
      } else if (!item.hasAttribute('data-keep-open')) {
        item.removeAttribute('open');
      }
    });
  };

  const getRelatedGrid = () => section.querySelector('.gt-pdp__related-grid');

  const formatRelatedMoney = (priceCents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        currency: window.Shopify?.currency?.active || 'USD',
        style: 'currency'
      }).format(priceCents / 100);
    } catch (error) {
      return `$${(priceCents / 100).toFixed(2)}`;
    }
  };

  const createRelatedCard = (productData) => {
    const variant = productData.variants?.[0] || {};
    const rawPrice = Number.parseFloat(variant.price || productData.price || '0');
    const priceCents = Math.round(rawPrice * 100);
    const imageData = productData.image || productData.images?.[0];
    const imageSrc = typeof imageData === 'string' ? imageData : imageData?.src;
    const imageAlt = (typeof imageData === 'object' && imageData?.alt) || productData.title || '';
    const card = document.createElement('a');
    const imageWrap = document.createElement('div');
    const title = document.createElement('p');
    const price = document.createElement('p');

    card.className = 'gt-pdp__related-card';
    card.href = `/products/${productData.handle}`;
    card.dataset.priceCents = String(priceCents);
    card.dataset.productHandle = productData.handle;
    card.dataset.relatedOrder = '99';

    imageWrap.className = 'gt-pdp__related-img';
    if (imageSrc) {
      const image = document.createElement('img');
      image.className = 'gt-pdp__image';
      image.loading = 'lazy';
      image.sizes = '(min-width: 901px) 25vw, 50vw';
      image.src = imageSrc;
      image.alt = imageAlt;
      imageWrap.appendChild(image);
    }

    title.className = 'gt-pdp__related-name';
    title.textContent = productData.title || '';

    price.className = 'gt-pdp__related-price';
    price.textContent = formatRelatedMoney(priceCents);

    card.append(imageWrap, title, price);
    return card;
  };

  const sortRelatedProducts = () => {
    const grid = getRelatedGrid();
    if (!grid) return [];

    const seenHandles = new Set([section.dataset.productHandle]);
    const cards = Array.from(grid.querySelectorAll('.gt-pdp__related-card')).filter((card) => {
      const handle = card.dataset.productHandle || card.getAttribute('href');
      if (!handle || seenHandles.has(handle)) {
        card.remove();
        return false;
      }
      seenHandles.add(handle);
      return true;
    });

    const sortedCards = cards.sort((a, b) => {
      const orderDiff = Number(a.dataset.relatedOrder ?? 99) - Number(b.dataset.relatedOrder ?? 99);
      if (orderDiff !== 0) return orderDiff;
      return Number(a.dataset.priceCents || 0) - Number(b.dataset.priceCents || 0);
    });
    sortedCards.forEach((card, index) => {
        if (grid.children[index] !== card) {
          grid.appendChild(card);
        }
        card.hidden = index >= 4;
      });

    return cards.filter((card) => !card.hidden);
  };

  const fillRelatedFallback = () => {
    const grid = getRelatedGrid();
    if (!grid || relatedFallbackPromise) return relatedFallbackPromise;

    const fallbackCollections = (recommendationsNode?.dataset.fallbackCollections || 'cat-furniture')
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean);

    relatedFallbackPromise = (async () => {
      for (const collectionHandle of fallbackCollections) {
        if (sortRelatedProducts().length >= 4) break;

        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=24`, {
          credentials: 'same-origin'
        });
        if (!response.ok) continue;

        const payload = await response.json();
        const products = Array.isArray(payload.products) ? payload.products : [];

        for (const productData of products) {
          const existingHandles = new Set(
            Array.from(grid.querySelectorAll('.gt-pdp__related-card'))
              .map((card) => card.dataset.productHandle || card.getAttribute('href'))
          );

          if (
            !productData.handle ||
            productData.handle === section.dataset.productHandle ||
            existingHandles.has(productData.handle)
          ) {
            continue;
          }

          grid.appendChild(createRelatedCard(productData));
          if (sortRelatedProducts().length >= 4) break;
        }
      }

      sortRelatedProducts();
    })().catch(() => {
      sortRelatedProducts();
    });

    return relatedFallbackPromise;
  };

  const ensureRelatedProducts = () => {
    if (sortRelatedProducts().length < 4) {
      fillRelatedFallback();
    }
  };

  const updateStickyCta = () => {
    if (!stickyCta || !heroCta) return;

    if (!desktopMedia.matches) {
      stickyCta.classList.add('is-visible');
      return;
    }

    const hasPassedHeroCta = heroCta.getBoundingClientRect().bottom <= 0;
    stickyCta.classList.toggle('is-visible', hasPassedHeroCta);
  };

  const resetProductInfoPin = () => {
    if (!productInfo || !productInfoWrap) return;

    productInfo.classList.remove('is-fixed', 'is-bottom');
    productInfo.style.left = '';
    productInfo.style.width = '';
    productInfo.style.removeProperty('--gt-product-info-max-height');
    productInfo.style.removeProperty('--gt-product-info-top');
    productInfoWrap.style.minHeight = '';
  };

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      section.querySelectorAll('.gt-pdp__variant-btn').forEach((label) => {
        label.classList.toggle('is-selected', label.contains(input));
      });

      priceNodes.forEach((node) => {
        node.textContent = input.dataset.price;
      });

    });
  });

  setAccordionDefaults();
  ensureRelatedProducts();

  if (recommendationsNode) {
    new MutationObserver(ensureRelatedProducts).observe(recommendationsNode, { childList: true });
  }

  if (stickyCta && heroCta) {
    new IntersectionObserver(updateStickyCta, { threshold: 0 }).observe(heroCta);
    window.addEventListener('resize', updateStickyCta, { passive: true });
    updateStickyCta();
  }

  if (productInfo && productInfoWrap && heroGrid) {
    resetProductInfoPin();
    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', resetProductInfoPin);
    }
  }

  window.addEventListener('resize', setAccordionDefaults, { passive: true });
}

document.querySelectorAll('.gt-pdp').forEach(initGardenTunnelPdp);
document.addEventListener('shopify:section:load', (event) => {
  initGardenTunnelPdp(event.target.querySelector('.gt-pdp'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-garden-tunnel-pdp-v13"] && !Shopify.designMode) return;
  try {
    
function injectGardenTunnelCompactRepair() {
  if (document.getElementById('gt-pdp-section-wildone-repair-20260523')) return;

  const style = document.createElement('style');
  style.id = 'gt-pdp-section-wildone-repair-20260523';
  style.textContent = `
    html body .shopify-section .gt-pdp .gt-pdp__hero { margin-top: 0 !important; padding: 0 40px 48px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__hero-grid { align-items: start !important; display: grid !important; gap: 20px !important; grid-template-columns: 1fr 1fr !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery { display: grid !important; gap: 8px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; min-height: 0 !important; overflow: visible !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 4 / 5 !important; height: auto !important; min-height: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { align-self: stretch !important; display: block !important; min-width: 0 !important; padding: 0 !important; position: relative !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { align-self: start !important; bottom: auto !important; left: auto !important; max-height: none !important; overflow: visible !important; padding: 10px 0 22px !important; position: sticky !important; top: calc(var(--header-height, 88px) + 10px) !important; width: auto !important; z-index: 30 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__breadcrumb, html body .shopify-section .gt-pdp .gt-pdp__eyebrow { align-items: center !important; background: #CCBCA8 !important; border-radius: 3px !important; color: #593518 !important; display: inline-flex !important; font-size: 10px !important; letter-spacing: 0.12em !important; line-height: 1.2 !important; margin: 0 0 10px !important; padding: 5px 12px !important; text-transform: uppercase !important; width: fit-content !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info h1 { font-family: Georgia, "Times New Roman", serif !important; font-size: 30px !important; font-weight: 400 !important; letter-spacing: 0 !important; line-height: 1.05 !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__title-meta-row { align-items: center !important; display: flex !important; flex-wrap: wrap !important; gap: 14px !important; justify-content: flex-start !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__lead-inline { color: rgba(89, 53, 24, 0.78) !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 14px !important; font-style: italic !important; line-height: 1.35 !important; margin: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__reviews-inline, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline * { font-size: 13px !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__price { font-family: Georgia, "Times New Roman", serif !important; font-size: 20px !important; line-height: 1 !important; margin: 0 0 22px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-label { color: rgba(89, 53, 24, 0.68) !important; display: block !important; font-size: 11px !important; letter-spacing: 0.16em !important; line-height: 1.2 !important; margin: 0 0 10px !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-options { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 0 !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn { align-items: center !important; display: flex !important; flex-direction: row !important; gap: 10px !important; justify-content: space-between !important; min-height: 46px !important; padding: 0 14px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn span, html body .shopify-section .gt-pdp .gt-pdp__variant-title { font-size: 14px !important; font-weight: 500 !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn small, html body .shopify-section .gt-pdp .gt-pdp__variant-size { color: rgba(89, 53, 24, 0.68) !important; font-size: 12px !important; line-height: 1.2 !important; margin: 0 !important; text-align: right !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 16px 0 30px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row > * { width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap { min-height: 72px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__button, html body .shopify-section .gt-pdp .shopify-payment-button__button { height: 48px !important; min-height: 48px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add { font-size: 13px !important; letter-spacing: 0.08em !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__more-options { display: block !important; font-size: 11px !important; line-height: 1.3 !important; margin: 10px auto 0 !important; text-align: center !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini { align-items: center !important; column-gap: 18px !important; display: grid !important; grid-template-columns: repeat(3, minmax(0, 1fr)) !important; margin: 0 !important; padding: 16px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item { align-items: center !important; display: grid !important; gap: 0 10px !important; grid-template-columns: 40px minmax(0, 1fr) !important; justify-content: flex-start !important; min-width: 0 !important; padding: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > svg, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > picture, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > img:not(.gt-pdp__trust-icon), html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::before, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::after { content: none !important; display: none !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-icon { display: block !important; flex: 0 0 40px !important; height: 40px !important; margin: 0 !important; object-fit: contain !important; width: 40px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-copy { display: block !important; min-width: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-title { display: block !important; font-size: 10.5px !important; letter-spacing: 0.1em !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-sub { font-size: 11px !important; line-height: 1.35 !important; overflow-wrap: normal !important; white-space: normal !important; word-break: normal !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-block { margin-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item:first-child { border-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item { padding: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item summary { font-size: 14px !important; font-weight: 500 !important; padding: 10px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features { clear: both !important; padding: 0 0 40px !important; position: relative !important; z-index: 1 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-heading { margin-left: auto !important; margin-right: auto !important; padding: 48px 0 32px !important; width: calc(100% - 80px) !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-grid { margin-left: auto !important; margin-right: auto !important; padding: 0 !important; width: calc(100% - 80px) !important; }
    @media (max-width: 900px) { html body .shopify-section .gt-pdp .gt-pdp__hero { padding: 0 0 32px !important; } html body .shopify-section .gt-pdp .gt-pdp__hero-grid { display: block !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery { grid-template-columns: 1fr !important; gap: 16px !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; } html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { max-height: none !important; overflow: visible !important; padding: 0 !important; position: relative !important; top: auto !important; } html body .shopify-section .gt-pdp .gt-pdp__features { padding: 0 0 40px !important; } html body .shopify-section .gt-pdp .gt-pdp__features-heading { padding: 32px 0 28px !important; width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__features-grid { width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini { grid-template-columns: 1fr !important; } }
    @media (max-width: 480px) { html body .shopify-section .gt-pdp .gt-pdp__buy-row, html body .shopify-section .gt-pdp .gt-pdp__variant-options { grid-template-columns: 1fr !important; } }
  `;
  document.head.appendChild(style);
}

function initGardenTunnelPdp(section) {
  if (!section || section.dataset.gtInitialized === '20260523-wildone-structure') return;
  section.dataset.gtInitialized = '20260523-wildone-structure';
  injectGardenTunnelCompactRepair();

  const variantInputs = Array.from(section.querySelectorAll('[data-gt-variant-input]'));
  const priceNodes = Array.from(section.querySelectorAll('[data-gt-price], [data-gt-sticky-price]'));
  const stickyCta = section.querySelector('.gt-pdp__sticky-cta');
  const heroCta = section.querySelector('.gt-pdp__cta-add');
  const recommendationsNode = section.querySelector('.gt-pdp__recommendations');
  const heroGrid = section.querySelector('.gt-pdp__hero-grid');
  const productInfoWrap = section.querySelector('.gt-pdp__product-info-wrap');
  const productInfo = section.querySelector('.gt-pdp__product-info');
  const desktopMedia = window.matchMedia('(min-width: 901px)');
  let relatedFallbackPromise = null;

  const setAccordionDefaults = () => {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    section.querySelectorAll('.gt-pdp__accordion-item').forEach((item) => {
      if (isMobile) {
        item.removeAttribute('open');
      } else if (!item.hasAttribute('data-keep-open')) {
        item.removeAttribute('open');
      }
    });
  };

  const getRelatedGrid = () => section.querySelector('.gt-pdp__related-grid');

  const formatRelatedMoney = (priceCents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        currency: window.Shopify?.currency?.active || 'USD',
        style: 'currency'
      }).format(priceCents / 100);
    } catch (error) {
      return `$${(priceCents / 100).toFixed(2)}`;
    }
  };

  const createRelatedCard = (productData) => {
    const variant = productData.variants?.[0] || {};
    const rawPrice = Number.parseFloat(variant.price || productData.price || '0');
    const priceCents = Math.round(rawPrice * 100);
    const imageData = productData.image || productData.images?.[0];
    const imageSrc = typeof imageData === 'string' ? imageData : imageData?.src;
    const imageAlt = (typeof imageData === 'object' && imageData?.alt) || productData.title || '';
    const card = document.createElement('a');
    const imageWrap = document.createElement('div');
    const title = document.createElement('p');
    const price = document.createElement('p');

    card.className = 'gt-pdp__related-card';
    card.href = `/products/${productData.handle}`;
    card.dataset.priceCents = String(priceCents);
    card.dataset.productHandle = productData.handle;
    card.dataset.relatedOrder = '99';

    imageWrap.className = 'gt-pdp__related-img';
    if (imageSrc) {
      const image = document.createElement('img');
      image.className = 'gt-pdp__image';
      image.loading = 'lazy';
      image.sizes = '(min-width: 901px) 25vw, 50vw';
      image.src = imageSrc;
      image.alt = imageAlt;
      imageWrap.appendChild(image);
    }

    title.className = 'gt-pdp__related-name';
    title.textContent = productData.title || '';

    price.className = 'gt-pdp__related-price';
    price.textContent = formatRelatedMoney(priceCents);

    card.append(imageWrap, title, price);
    return card;
  };

  const sortRelatedProducts = () => {
    const grid = getRelatedGrid();
    if (!grid) return [];

    const seenHandles = new Set([section.dataset.productHandle]);
    const cards = Array.from(grid.querySelectorAll('.gt-pdp__related-card')).filter((card) => {
      const handle = card.dataset.productHandle || card.getAttribute('href');
      if (!handle || seenHandles.has(handle)) {
        card.remove();
        return false;
      }
      seenHandles.add(handle);
      return true;
    });

    const sortedCards = cards.sort((a, b) => {
      const orderDiff = Number(a.dataset.relatedOrder ?? 99) - Number(b.dataset.relatedOrder ?? 99);
      if (orderDiff !== 0) return orderDiff;
      return Number(a.dataset.priceCents || 0) - Number(b.dataset.priceCents || 0);
    });
    sortedCards.forEach((card, index) => {
        if (grid.children[index] !== card) {
          grid.appendChild(card);
        }
        card.hidden = index >= 4;
      });

    return cards.filter((card) => !card.hidden);
  };

  const fillRelatedFallback = () => {
    const grid = getRelatedGrid();
    if (!grid || relatedFallbackPromise) return relatedFallbackPromise;

    const fallbackCollections = (recommendationsNode?.dataset.fallbackCollections || 'cat-furniture')
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean);

    relatedFallbackPromise = (async () => {
      for (const collectionHandle of fallbackCollections) {
        if (sortRelatedProducts().length >= 4) break;

        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=24`, {
          credentials: 'same-origin'
        });
        if (!response.ok) continue;

        const payload = await response.json();
        const products = Array.isArray(payload.products) ? payload.products : [];

        for (const productData of products) {
          const existingHandles = new Set(
            Array.from(grid.querySelectorAll('.gt-pdp__related-card'))
              .map((card) => card.dataset.productHandle || card.getAttribute('href'))
          );

          if (
            !productData.handle ||
            productData.handle === section.dataset.productHandle ||
            existingHandles.has(productData.handle)
          ) {
            continue;
          }

          grid.appendChild(createRelatedCard(productData));
          if (sortRelatedProducts().length >= 4) break;
        }
      }

      sortRelatedProducts();
    })().catch(() => {
      sortRelatedProducts();
    });

    return relatedFallbackPromise;
  };

  const ensureRelatedProducts = () => {
    if (sortRelatedProducts().length < 4) {
      fillRelatedFallback();
    }
  };

  const updateStickyCta = () => {
    if (!stickyCta || !heroCta) return;

    if (!desktopMedia.matches) {
      stickyCta.classList.add('is-visible');
      return;
    }

    const hasPassedHeroCta = heroCta.getBoundingClientRect().bottom <= 0;
    stickyCta.classList.toggle('is-visible', hasPassedHeroCta);
  };

  const resetProductInfoPin = () => {
    if (!productInfo || !productInfoWrap) return;

    productInfo.classList.remove('is-fixed', 'is-bottom');
    productInfo.style.left = '';
    productInfo.style.width = '';
    productInfo.style.removeProperty('--gt-product-info-max-height');
    productInfo.style.removeProperty('--gt-product-info-top');
    productInfoWrap.style.minHeight = '';
  };

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      section.querySelectorAll('.gt-pdp__variant-btn').forEach((label) => {
        label.classList.toggle('is-selected', label.contains(input));
      });

      priceNodes.forEach((node) => {
        node.textContent = input.dataset.price;
      });

    });
  });

  setAccordionDefaults();
  ensureRelatedProducts();

  if (recommendationsNode) {
    new MutationObserver(ensureRelatedProducts).observe(recommendationsNode, { childList: true });
  }

  if (stickyCta && heroCta) {
    new IntersectionObserver(updateStickyCta, { threshold: 0 }).observe(heroCta);
    window.addEventListener('resize', updateStickyCta, { passive: true });
    updateStickyCta();
  }

  if (productInfo && productInfoWrap && heroGrid) {
    resetProductInfoPin();
    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', resetProductInfoPin);
    }
  }

  window.addEventListener('resize', setAccordionDefaults, { passive: true });
}

document.querySelectorAll('.gt-pdp').forEach(initGardenTunnelPdp);
document.addEventListener('shopify:section:load', (event) => {
  initGardenTunnelPdp(event.target.querySelector('.gt-pdp'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-garden-tunnel-pdp-v14"] && !Shopify.designMode) return;
  try {
    
function injectGardenTunnelCompactRepair() {
  if (document.getElementById('gt-pdp-section-wildone-repair-20260523')) return;

  const style = document.createElement('style');
  style.id = 'gt-pdp-section-wildone-repair-20260523';
  style.textContent = `
    html body .shopify-section .gt-pdp .gt-pdp__hero { margin-top: 0 !important; padding: 0 40px 48px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__hero-grid { align-items: start !important; display: grid !important; gap: 20px !important; grid-template-columns: 1fr 1fr !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery { display: grid !important; gap: 8px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; min-height: 0 !important; overflow: visible !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 4 / 5 !important; height: auto !important; min-height: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { align-self: stretch !important; display: block !important; min-width: 0 !important; padding: 0 !important; position: relative !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { align-self: start !important; bottom: auto !important; left: auto !important; max-height: none !important; overflow: visible !important; padding: 10px 0 22px !important; position: sticky !important; top: calc(var(--header-height, 88px) + 10px) !important; width: auto !important; z-index: 30 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__breadcrumb, html body .shopify-section .gt-pdp .gt-pdp__eyebrow { align-items: center !important; background: #CCBCA8 !important; border-radius: 3px !important; color: #593518 !important; display: inline-flex !important; font-size: 10px !important; letter-spacing: 0.12em !important; line-height: 1.2 !important; margin: 0 0 10px !important; padding: 5px 12px !important; text-transform: uppercase !important; width: fit-content !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info h1 { font-family: Georgia, "Times New Roman", serif !important; font-size: 30px !important; font-weight: 400 !important; letter-spacing: 0 !important; line-height: 1.05 !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__title-meta-row { align-items: center !important; display: flex !important; flex-wrap: wrap !important; gap: 14px !important; justify-content: flex-start !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__lead-inline { color: rgba(89, 53, 24, 0.78) !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 14px !important; font-style: italic !important; line-height: 1.35 !important; margin: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__reviews-inline, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline * { font-size: 13px !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__price { font-family: Georgia, "Times New Roman", serif !important; font-size: 20px !important; line-height: 1 !important; margin: 0 0 22px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-label { color: rgba(89, 53, 24, 0.68) !important; display: block !important; font-size: 11px !important; letter-spacing: 0.16em !important; line-height: 1.2 !important; margin: 0 0 10px !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-options { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 0 !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn { align-items: center !important; display: flex !important; flex-direction: row !important; gap: 10px !important; justify-content: space-between !important; min-height: 46px !important; padding: 0 14px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn span, html body .shopify-section .gt-pdp .gt-pdp__variant-title { font-size: 14px !important; font-weight: 500 !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn small, html body .shopify-section .gt-pdp .gt-pdp__variant-size { color: rgba(89, 53, 24, 0.68) !important; font-size: 12px !important; line-height: 1.2 !important; margin: 0 !important; text-align: right !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 16px 0 30px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row > * { width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap { min-height: 72px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__button, html body .shopify-section .gt-pdp .shopify-payment-button__button { height: 48px !important; min-height: 48px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add { font-size: 13px !important; letter-spacing: 0.08em !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__more-options { display: block !important; font-size: 11px !important; line-height: 1.3 !important; margin: 10px auto 0 !important; text-align: center !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini { align-items: center !important; column-gap: 18px !important; display: grid !important; grid-template-columns: repeat(3, minmax(0, 1fr)) !important; margin: 0 !important; padding: 16px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item { align-items: center !important; display: grid !important; gap: 0 10px !important; grid-template-columns: 40px minmax(0, 1fr) !important; justify-content: flex-start !important; min-width: 0 !important; padding: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > svg, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > picture, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > img:not(.gt-pdp__trust-icon), html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::before, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::after { content: none !important; display: none !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-icon { display: block !important; flex: 0 0 40px !important; height: 40px !important; margin: 0 !important; object-fit: contain !important; width: 40px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-copy { display: block !important; min-width: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-title { display: block !important; font-size: 10.5px !important; letter-spacing: 0.1em !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-sub { font-size: 11px !important; line-height: 1.35 !important; overflow-wrap: normal !important; white-space: normal !important; word-break: normal !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-block { margin-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item:first-child { border-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item { padding: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item summary { font-size: 14px !important; font-weight: 500 !important; padding: 10px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features { clear: both !important; padding: 0 0 40px !important; position: relative !important; z-index: 1 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-heading { margin-left: auto !important; margin-right: auto !important; padding: 48px 0 32px !important; width: calc(100% - 80px) !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-grid { margin-left: auto !important; margin-right: auto !important; padding: 0 !important; width: calc(100% - 80px) !important; }
    @media (max-width: 900px) { html body .shopify-section .gt-pdp .gt-pdp__hero { padding: 0 0 32px !important; } html body .shopify-section .gt-pdp .gt-pdp__hero-grid { display: block !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery { grid-template-columns: 1fr !important; gap: 16px !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; } html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { max-height: none !important; overflow: visible !important; padding: 0 !important; position: relative !important; top: auto !important; } html body .shopify-section .gt-pdp .gt-pdp__features { padding: 0 0 40px !important; } html body .shopify-section .gt-pdp .gt-pdp__features-heading { padding: 32px 0 28px !important; width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__features-grid { width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini { grid-template-columns: 1fr !important; } }
    @media (max-width: 480px) { html body .shopify-section .gt-pdp .gt-pdp__buy-row, html body .shopify-section .gt-pdp .gt-pdp__variant-options { grid-template-columns: 1fr !important; } }
  `;
  document.head.appendChild(style);
}

function initGardenTunnelPdp(section) {
  if (!section || section.dataset.gtInitialized === '20260523-wildone-structure') return;
  section.dataset.gtInitialized = '20260523-wildone-structure';
  injectGardenTunnelCompactRepair();

  const variantInputs = Array.from(section.querySelectorAll('[data-gt-variant-input]'));
  const priceNodes = Array.from(section.querySelectorAll('[data-gt-price], [data-gt-sticky-price]'));
  const stickyCta = section.querySelector('.gt-pdp__sticky-cta');
  const heroCta = section.querySelector('.gt-pdp__cta-add');
  const recommendationsNode = section.querySelector('.gt-pdp__recommendations');
  const heroGrid = section.querySelector('.gt-pdp__hero-grid');
  const productInfoWrap = section.querySelector('.gt-pdp__product-info-wrap');
  const productInfo = section.querySelector('.gt-pdp__product-info');
  const desktopMedia = window.matchMedia('(min-width: 901px)');
  let relatedFallbackPromise = null;

  const setAccordionDefaults = () => {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    section.querySelectorAll('.gt-pdp__accordion-item').forEach((item) => {
      if (isMobile) {
        item.removeAttribute('open');
      } else if (!item.hasAttribute('data-keep-open')) {
        item.removeAttribute('open');
      }
    });
  };

  const getRelatedGrid = () => section.querySelector('.gt-pdp__related-grid');

  const formatRelatedMoney = (priceCents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        currency: window.Shopify?.currency?.active || 'USD',
        style: 'currency'
      }).format(priceCents / 100);
    } catch (error) {
      return `$${(priceCents / 100).toFixed(2)}`;
    }
  };

  const createRelatedCard = (productData) => {
    const variant = productData.variants?.[0] || {};
    const rawPrice = Number.parseFloat(variant.price || productData.price || '0');
    const priceCents = Math.round(rawPrice * 100);
    const imageData = productData.image || productData.images?.[0];
    const imageSrc = typeof imageData === 'string' ? imageData : imageData?.src;
    const imageAlt = (typeof imageData === 'object' && imageData?.alt) || productData.title || '';
    const card = document.createElement('a');
    const imageWrap = document.createElement('div');
    const title = document.createElement('p');
    const price = document.createElement('p');

    card.className = 'gt-pdp__related-card';
    card.href = `/products/${productData.handle}`;
    card.dataset.priceCents = String(priceCents);
    card.dataset.productHandle = productData.handle;
    card.dataset.relatedOrder = '99';

    imageWrap.className = 'gt-pdp__related-img';
    if (imageSrc) {
      const image = document.createElement('img');
      image.className = 'gt-pdp__image';
      image.loading = 'lazy';
      image.sizes = '(min-width: 901px) 25vw, 50vw';
      image.src = imageSrc;
      image.alt = imageAlt;
      imageWrap.appendChild(image);
    }

    title.className = 'gt-pdp__related-name';
    title.textContent = productData.title || '';

    price.className = 'gt-pdp__related-price';
    price.textContent = formatRelatedMoney(priceCents);

    card.append(imageWrap, title, price);
    return card;
  };

  const sortRelatedProducts = () => {
    const grid = getRelatedGrid();
    if (!grid) return [];

    const seenHandles = new Set([section.dataset.productHandle]);
    const cards = Array.from(grid.querySelectorAll('.gt-pdp__related-card')).filter((card) => {
      const handle = card.dataset.productHandle || card.getAttribute('href');
      if (!handle || seenHandles.has(handle)) {
        card.remove();
        return false;
      }
      seenHandles.add(handle);
      return true;
    });

    const sortedCards = cards.sort((a, b) => {
      const orderDiff = Number(a.dataset.relatedOrder ?? 99) - Number(b.dataset.relatedOrder ?? 99);
      if (orderDiff !== 0) return orderDiff;
      return Number(a.dataset.priceCents || 0) - Number(b.dataset.priceCents || 0);
    });
    sortedCards.forEach((card, index) => {
        if (grid.children[index] !== card) {
          grid.appendChild(card);
        }
        card.hidden = index >= 4;
      });

    return cards.filter((card) => !card.hidden);
  };

  const fillRelatedFallback = () => {
    const grid = getRelatedGrid();
    if (!grid || relatedFallbackPromise) return relatedFallbackPromise;

    const fallbackCollections = (recommendationsNode?.dataset.fallbackCollections || 'cat-furniture')
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean);

    relatedFallbackPromise = (async () => {
      for (const collectionHandle of fallbackCollections) {
        if (sortRelatedProducts().length >= 4) break;

        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=24`, {
          credentials: 'same-origin'
        });
        if (!response.ok) continue;

        const payload = await response.json();
        const products = Array.isArray(payload.products) ? payload.products : [];

        for (const productData of products) {
          const existingHandles = new Set(
            Array.from(grid.querySelectorAll('.gt-pdp__related-card'))
              .map((card) => card.dataset.productHandle || card.getAttribute('href'))
          );

          if (
            !productData.handle ||
            productData.handle === section.dataset.productHandle ||
            existingHandles.has(productData.handle)
          ) {
            continue;
          }

          grid.appendChild(createRelatedCard(productData));
          if (sortRelatedProducts().length >= 4) break;
        }
      }

      sortRelatedProducts();
    })().catch(() => {
      sortRelatedProducts();
    });

    return relatedFallbackPromise;
  };

  const ensureRelatedProducts = () => {
    if (sortRelatedProducts().length < 4) {
      fillRelatedFallback();
    }
  };

  const updateStickyCta = () => {
    if (!stickyCta || !heroCta) return;

    if (!desktopMedia.matches) {
      stickyCta.classList.add('is-visible');
      return;
    }

    const hasPassedHeroCta = heroCta.getBoundingClientRect().bottom <= 0;
    stickyCta.classList.toggle('is-visible', hasPassedHeroCta);
  };

  const resetProductInfoPin = () => {
    if (!productInfo || !productInfoWrap) return;

    productInfo.classList.remove('is-fixed', 'is-bottom');
    productInfo.style.left = '';
    productInfo.style.width = '';
    productInfo.style.removeProperty('--gt-product-info-max-height');
    productInfo.style.removeProperty('--gt-product-info-top');
    productInfoWrap.style.minHeight = '';
  };

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      section.querySelectorAll('.gt-pdp__variant-btn').forEach((label) => {
        label.classList.toggle('is-selected', label.contains(input));
      });

      priceNodes.forEach((node) => {
        node.textContent = input.dataset.price;
      });

    });
  });

  setAccordionDefaults();
  ensureRelatedProducts();

  if (recommendationsNode) {
    new MutationObserver(ensureRelatedProducts).observe(recommendationsNode, { childList: true });
  }

  if (stickyCta && heroCta) {
    new IntersectionObserver(updateStickyCta, { threshold: 0 }).observe(heroCta);
    window.addEventListener('resize', updateStickyCta, { passive: true });
    updateStickyCta();
  }

  if (productInfo && productInfoWrap && heroGrid) {
    resetProductInfoPin();
    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', resetProductInfoPin);
    }
  }

  window.addEventListener('resize', setAccordionDefaults, { passive: true });
}

document.querySelectorAll('.gt-pdp').forEach(initGardenTunnelPdp);
document.addEventListener('shopify:section:load', (event) => {
  initGardenTunnelPdp(event.target.querySelector('.gt-pdp'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-garden-tunnel-pdp-v15"] && !Shopify.designMode) return;
  try {
    
function injectGardenTunnelCompactRepair() {
  if (document.getElementById('gt-pdp-section-wildone-repair-20260523')) return;

  const style = document.createElement('style');
  style.id = 'gt-pdp-section-wildone-repair-20260523';
  style.textContent = `
    html body .shopify-section .gt-pdp .gt-pdp__hero { margin-top: 0 !important; padding: 0 40px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__hero-grid { align-items: start !important; display: grid !important; gap: 20px !important; grid-template-columns: 1fr 1fr !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery { display: grid !important; gap: 8px !important; grid-template-columns: 1fr !important; min-height: 0 !important; overflow: visible !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; height: auto !important; min-height: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { align-self: stretch !important; display: block !important; min-width: 0 !important; padding: 15px 0 0 !important; position: relative !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { align-self: start !important; bottom: auto !important; left: auto !important; max-height: none !important; overflow: visible !important; padding: 0 0 28px !important; position: sticky !important; top: calc(var(--header-height, 88px) + 15px) !important; width: auto !important; z-index: 30 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__breadcrumb, html body .shopify-section .gt-pdp .gt-pdp__eyebrow { align-items: center !important; background: #CCBCA8 !important; border-radius: 3px !important; color: #593518 !important; display: inline-flex !important; font-size: 10px !important; letter-spacing: 0.12em !important; line-height: 1.2 !important; margin: 0 0 10px !important; padding: 5px 12px !important; text-transform: uppercase !important; width: fit-content !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info h1 { font-family: Georgia, "Times New Roman", serif !important; font-size: 30px !important; font-weight: 400 !important; letter-spacing: 0 !important; line-height: 1.05 !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__title-meta-row { align-items: center !important; display: flex !important; flex-wrap: wrap !important; gap: 10px !important; justify-content: flex-start !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__lead-inline { color: rgba(89, 53, 24, 0.78) !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 14px !important; font-style: italic !important; line-height: 1.35 !important; margin: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__reviews-inline, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline * { font-size: 13px !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__price { align-items: baseline !important; display: inline-flex !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 20px !important; gap: 9px !important; line-height: 1 !important; margin: 0 0 22px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__promo-line { color: rgba(89, 53, 24, 0.68) !important; font-family: var(--font-body) !important; font-size: 13px !important; line-height: 1.35 !important; margin: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-label { color: rgba(89, 53, 24, 0.68) !important; display: block !important; font-size: 11px !important; letter-spacing: 0.16em !important; line-height: 1.2 !important; margin: 0 0 10px !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-options { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 0 !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn { align-items: center !important; display: flex !important; flex-direction: row !important; gap: 10px !important; justify-content: space-between !important; min-height: 46px !important; padding: 0 14px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn span, html body .shopify-section .gt-pdp .gt-pdp__variant-title { font-size: 14px !important; font-weight: 500 !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn small, html body .shopify-section .gt-pdp .gt-pdp__variant-size { color: rgba(89, 53, 24, 0.68) !important; font-size: 12px !important; line-height: 1.2 !important; margin: 0 !important; text-align: right !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 16px 0 10px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row > * { width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap { min-height: 72px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__button, html body .shopify-section .gt-pdp .shopify-payment-button__button { height: 48px !important; min-height: 48px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add { font-size: 13px !important; letter-spacing: 0.08em !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__more-options { display: block !important; font-size: 11px !important; line-height: 1.3 !important; margin: 10px auto 0 !important; text-align: center !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini { align-items: center !important; column-gap: 30px !important; display: grid !important; grid-template-columns: repeat(3, max-content) !important; justify-content: space-between !important; margin: 0 !important; padding: 16px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item { align-items: center !important; display: grid !important; gap: 0 14px !important; grid-template-columns: 45px max-content !important; justify-content: flex-start !important; min-width: 0 !important; padding: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:nth-child(n + 2) { grid-template-columns: 35px max-content !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > svg, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > picture, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::before, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::after { content: none !important; display: none !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > img, html body .shopify-section .gt-pdp .gt-pdp__trust-icon { display: block !important; flex: 0 0 35px !important; height: 35px !important; margin: 0 !important; object-fit: contain !important; width: 35px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:first-child > img, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:first-child .gt-pdp__trust-icon { flex-basis: 45px !important; height: 45px !important; width: 45px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-copy { display: block !important; min-width: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-title { display: block !important; font-size: 10.5px !important; letter-spacing: 0.1em !important; line-height: 1.2 !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-sub { font-size: 11px !important; line-height: 1.35 !important; overflow-wrap: normal !important; white-space: normal !important; word-break: normal !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-block { margin-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item:first-child { border-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item { padding: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item summary { font-size: 14px !important; font-weight: 500 !important; padding: 10px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features { clear: both !important; padding: 0 0 40px !important; position: relative !important; z-index: 1 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-heading { margin-left: auto !important; margin-right: auto !important; padding: 40px 0 32px !important; width: calc(100% - 80px) !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-grid { margin-left: auto !important; margin-right: auto !important; padding: 0 !important; width: calc(100% - 80px) !important; }
    @media (max-width: 900px) { html body .shopify-section .gt-pdp .gt-pdp__hero { padding: 0 0 32px !important; } html body .shopify-section .gt-pdp .gt-pdp__hero-grid { display: block !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery { grid-template-columns: 1fr !important; gap: 16px !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; } html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { padding: 32px 24px 32px !important; } html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { max-height: none !important; overflow: visible !important; padding: 0 !important; position: relative !important; top: auto !important; } html body .shopify-section .gt-pdp .gt-pdp__features { padding: 0 0 40px !important; } html body .shopify-section .gt-pdp .gt-pdp__features-heading { padding: 68px 0 28px !important; width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__features-grid { width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini { grid-template-columns: 1fr !important; justify-content: stretch !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item { grid-template-columns: 45px minmax(0, 1fr) !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:nth-child(n + 2) { grid-template-columns: 35px minmax(0, 1fr) !important; } }
    @media (max-width: 480px) { html body .shopify-section .gt-pdp .gt-pdp__buy-row, html body .shopify-section .gt-pdp .gt-pdp__variant-options { grid-template-columns: 1fr !important; } }
    @media (max-width: 900px) {
      html body .shopify-section .gt-pdp .gt-pdp__hero { padding: 0 0 28px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__hero-grid { display: flex !important; flex-direction: column !important; gap: 0 !important; grid-template-columns: none !important; position: relative !important; }
      html body .shopify-section .gt-pdp .gt-pdp__gallery { display: flex !important; gap: 0 !important; grid-template-columns: none !important; margin: 0 !important; order: 2 !important; overflow-x: auto !important; overflow-y: hidden !important; padding: 0 !important; position: relative !important; scroll-snap-type: x mandatory !important; scrollbar-width: none !important; width: 100% !important; -webkit-overflow-scrolling: touch !important; }
      html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; flex: 0 0 100% !important; min-height: 0 !important; scroll-snap-align: start !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__gallery-arrow { align-items: center !important; background: transparent !important; border: 0 !important; border-radius: 0 !important; color: rgba(44, 24, 16, 0.42) !important; display: flex !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 34px !important; font-weight: 400 !important; height: 52px !important; justify-content: center !important; line-height: 1 !important; padding: 0 !important; position: absolute !important; text-shadow: 0 1px 3px rgba(250, 247, 242, 0.8) !important; top: 50% !important; transform: translateY(-50%) !important; width: 36px !important; z-index: 6 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__gallery-arrow--prev { left: 8px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__gallery-arrow--next { right: 8px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { order: 1 !important; padding: 14px 24px 14px !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__mobile-purchase-wrap { order: 3 !important; padding: 18px 24px 22px !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__breadcrumb, html body .shopify-section .gt-pdp .gt-pdp__eyebrow { margin: 0 0 8px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__title-meta-row { align-items: center !important; display: flex !important; flex-wrap: nowrap !important; gap: 6px !important; margin: 0 0 14px !important; overflow: visible !important; }
      html body .shopify-section .gt-pdp .gt-pdp__lead-inline { flex: 1 1 auto !important; font-size: 11.5px !important; line-height: 1.25 !important; min-width: 0 !important; white-space: nowrap !important; }
      html body .shopify-section .gt-pdp .gt-pdp__reviews-inline { flex: 0 0 auto !important; gap: 4px !important; white-space: nowrap !important; }
      html body .shopify-section .gt-pdp .gt-pdp__reviews-inline, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline * { font-size: 10.5px !important; line-height: 1 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__buy-row, html body .shopify-section .gt-pdp .gt-pdp__variant-options { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__cta-add, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap, html body .shopify-section .gt-pdp .shopify-payment-button, html body .shopify-section .gt-pdp .shopify-payment-button__button { height: 52px !important; min-height: 52px !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button { height: auto !important; min-height: 74px !important; overflow: visible !important; }
      html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__more-options { margin: 8px auto 14px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__trust-mini { align-items: start !important; display: grid !important; gap: 0 !important; grid-template-columns: repeat(3, minmax(0, 1fr)) !important; justify-content: stretch !important; margin: 4px -24px 0 !important; padding: 18px 10px 20px !important; width: calc(100% + 48px) !important; }
      html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:nth-child(n + 2) { align-items: center !important; display: flex !important; flex-direction: column !important; gap: 8px !important; grid-template-columns: none !important; justify-content: flex-start !important; min-width: 0 !important; padding: 0 !important; text-align: center !important; }
      html body .shopify-section .gt-pdp .gt-pdp__trust-title { font-size: 13px !important; letter-spacing: 0.04em !important; line-height: 1.15 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__trust-sub { font-size: 12px !important; letter-spacing: 0 !important; line-height: 1.2 !important; white-space: nowrap !important; }
      html body .shopify-section .gt-pdp .gt-pdp__ugc { margin-top: 40px !important; padding-bottom: 28px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__features-heading { padding: 34px 0 24px !important; }
    }
    @media (max-width: 480px) {
      html body .shopify-section .gt-pdp .gt-pdp__buy-row,
      html body .shopify-section .gt-pdp .gt-pdp__variant-options { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
    }
  `;
  document.head.appendChild(style);
}

function injectGardenTunnelMobileReviewLayout() {
  document.getElementById('gt-pdp-mobile-review-layout-20260606')?.remove();

  const style = document.createElement('style');
  style.id = 'gt-pdp-mobile-review-layout-20260606';
  style.textContent = `
    @media screen and (max-width: 989px) {
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme .gt-pdp__jm-header { align-items: center !important; margin-bottom: 22px !important; text-align: center !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme .gt-pdp__section-title { margin-left: auto !important; margin-right: auto !important; text-align: center !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header { display: flex !important; flex-direction: column !important; gap: 0 !important; width: 100% !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header > .jm-cluster { display: contents !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header > .jm-cluster > .jm-stack--space-200 { align-items: center !important; display: flex !important; flex-direction: column !important; order: 1 !important; width: 100% !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header > .jm-cluster > .jm-stack--space-200 > .jm-cluster,
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-average-rating-display,
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-average-rating-display > .jm-cluster { align-items: center !important; display: flex !important; flex-direction: row !important; flex-wrap: nowrap !important; justify-content: center !important; width: 100% !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-average-rating-display { transform: none !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-average-rating-display > .jm-cluster { gap: 8px !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-average-rating-display .jm-text:first-child { font-size: 22px !important; line-height: 1 !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-average-rating-display .jm-text:first-child::after { display: inline-block !important; font-size: 22px !important; letter-spacing: 0.03em !important; line-height: 1 !important; margin: 0 0 0 7px !important; transform: translateY(1px) !important; vertical-align: baseline !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-average-rating-display .jm-text:last-child { align-self: center !important; font-size: 13px !important; letter-spacing: 0 !important; line-height: 1.25 !important; margin-top: 0 !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .gt-pdp__jm-histogram { margin: 18px auto 0 !important; max-width: 330px !important; min-width: 0 !important; width: 100% !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .gt-pdp__jm-histogram-row { gap: 4px 7px !important; grid-template-columns: 14px 13px minmax(0, 1fr) 22px !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header .jm-media-preview { margin: 24px 0 0 !important; max-width: none !important; order: 2 !important; width: 100% !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header .jm-media-grid,
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header .jm-media-grid__container { width: 100% !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header .jm-media-grid__container { display: grid !important; gap: 6px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; justify-content: stretch !important; margin: 0 !important; max-width: none !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header .jm-media-grid__item.jm-media-grid__item,
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header .jm-media-grid__image-container.jm-media-grid__image-container { aspect-ratio: 1 / 1 !important; flex: none !important; height: auto !important; max-height: none !important; max-width: none !important; min-height: 0 !important; min-width: 0 !important; position: relative !important; width: 100% !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header .jm-media-grid__item:nth-child(n + 3) { display: none !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header .jm-media-grid__item::before { background: rgba(250, 247, 242, 0.52) !important; bottom: 0 !important; content: "" !important; position: absolute !important; top: 0 !important; width: 38px !important; z-index: 3 !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header .jm-media-grid__item::after { color: rgba(44, 24, 16, 0.82) !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 30px !important; font-weight: 400 !important; line-height: 1 !important; position: absolute !important; top: 50% !important; transform: translateY(-50%) !important; z-index: 4 !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header .jm-media-grid__item:first-child::before { left: 0 !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header .jm-media-grid__item:first-child::after { content: "‹" !important; left: 13px !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header .jm-media-grid__item:nth-child(2)::before { right: 0 !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget__header .jm-media-grid__item:nth-child(2)::after { content: "›" !important; right: 13px !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget-minimal-header__filter-container { margin-top: 14px !important; order: 3 !important; width: 100% !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget-minimal-header__button-and-filters { align-items: center !important; display: flex !important; flex-direction: row !important; flex-wrap: nowrap !important; gap: 8px !important; justify-content: space-between !important; width: 100% !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget-minimal-header__action-buttons { display: block !important; flex: 1 1 auto !important; min-width: 0 !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget-minimal-header__action-buttons > .jm-stack,
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-action-buttons__button { width: 100% !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-action-buttons__button { min-height: 36px !important; min-width: 0 !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-review-widget-minimal-header__filters,
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-filters,
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-filters__buttons { align-items: center !important; display: flex !important; flex: 0 0 auto !important; flex-direction: row !important; flex-wrap: nowrap !important; gap: 8px !important; width: auto !important; }
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-custom-answer-filter,
      html body #MainContent .shopify-section .gt-pdp.gt-pdp .gt-pdp__judgeme.gt-pdp__judgeme #judgeme_product_reviews .jm-sort-filter.jm-sort-filter { height: 36px !important; min-height: 36px !important; width: 40px !important; }
    }
  `;
  (document.body || document.head).appendChild(style);
}

function initGardenTunnelPdp(section) {
  injectGardenTunnelMobileReviewLayout();

  if (!section || section.dataset.gtInitialized === '20260524-gallery-video-arrow-repair') return;
  section.dataset.gtInitialized = '20260524-gallery-video-arrow-repair';
  injectGardenTunnelCompactRepair();
  injectGardenTunnelMobileReviewLayout();

  const variantInputs = Array.from(section.querySelectorAll('[data-gt-variant-input]'));
  const priceNodes = Array.from(section.querySelectorAll('[data-gt-price], [data-gt-sticky-price]'));
  const stickyCta = section.querySelector('.gt-pdp__sticky-cta');
  const heroCta = section.querySelector('.gt-pdp__cta-add');
  const stickySentinel = section.querySelector('[data-gt-sticky-sentinel]');
  const recommendationsNode = section.querySelector('.gt-pdp__recommendations');
  const heroGrid = section.querySelector('.gt-pdp__hero-grid');
  const productInfoWrap = section.querySelector('.gt-pdp__product-info-wrap');
  const productInfo = section.querySelector('.gt-pdp__product-info');
  const desktopMedia = window.matchMedia('(min-width: 901px)');
  let relatedFallbackPromise = null;
  let heroCtaTriggerBottom = heroCta ? window.scrollY + heroCta.getBoundingClientRect().bottom : 0;

  const captureHeroCtaTrigger = () => {
    if (!heroCta || window.scrollY > 8) return;
    heroCtaTriggerBottom = window.scrollY + heroCta.getBoundingClientRect().bottom;
  };

  const formatJudgeDate = (value) => {
    if (!value) return '';

    const parts = value.slice(0, 10).split('-');
    if (parts.length !== 3) return value;

    const [year, month, day] = parts;
    const format = window.jdgmSettings?.review_date_format || 'mm/dd/yyyy';

    if (format === 'dd/mm/yyyy') return `${day}/${month}/${year}`;
    if (format === 'yyyy-mm-dd') return `${year}-${month}-${day}`;
    return `${month}/${day}/${year}`;
  };

  const finalizeJudgeMeFallback = () => {
    const widget = section.querySelector('.gt-pdp__judge-widget');
    if (!widget) return;

    widget.querySelectorAll('.jdgm-rev__timestamp.jdgm-spinner[data-content]').forEach((timestamp) => {
      timestamp.textContent = formatJudgeDate(timestamp.dataset.content);
      timestamp.classList.remove('jdgm-spinner');
    });

    widget.querySelectorAll('.jdgm-rev__pic-img[data-src]').forEach((image) => {
      if (!image.getAttribute('src')) {
        image.setAttribute('src', image.dataset.src);
      }
      image.closest('.jdgm-rev__pic-link')?.classList.remove('jdgm--loading');
    });

    widget.querySelectorAll('.jdgm-rev-widg__paginate-spinner-wrapper').forEach((spinner) => {
      spinner.style.display = 'none';
    });
  };

  const ensureJudgeMeWrapper = () => {
    const host = section.querySelector('.gt-pdp__judge-widget');
    if (!host) return null;

    let wrapper = host.querySelector('#judgeme_product_reviews');
    const legacyWidget = host.querySelector(':scope > .jdgm-rev-widg');

    if (!wrapper && legacyWidget) {
      wrapper = document.createElement('div');
      wrapper.id = 'judgeme_product_reviews';
      wrapper.className = 'jdgm-widget jdgm-review-widget';
      wrapper.dataset.id = String(window.ShopifyAnalytics?.meta?.product?.id || '');
      wrapper.dataset.productTitle = window.ShopifyAnalytics?.meta?.product?.name || '';
      host.insertBefore(wrapper, legacyWidget);
      wrapper.appendChild(legacyWidget);
    }

    if (wrapper) {
      wrapper.classList.add('jdgm-widget', 'jdgm-review-widget');
      if (!wrapper.dataset.id && window.ShopifyAnalytics?.meta?.product?.id) {
        wrapper.dataset.id = String(window.ShopifyAnalytics.meta.product.id);
      }
    }

    return wrapper;
  };

  const loadJudgeMeScript = (path) => new Promise((resolve) => {
    const judgeMe = window.jdgm;
    if (!judgeMe?.loadScript || !judgeMe.CDN_HOST) {
      resolve(false);
      return;
    }

    const url = judgeMe.CDN_HOST + path;
    const requested = judgeMe.loadScript.requestedUrls || [];
    if (requested.includes(url)) {
      resolve(true);
      return;
    }

    judgeMe.loadScript(url, () => resolve(true));
  });

  const runJudgeMeSetup = () => {
    const host = section.querySelector('.gt-pdp__judge-widget');
    const judgeMe = window.jdgm;

    if (host && judgeMe?.$ && judgeMe.initializeWidgets) {
      try {
        judgeMe.initializeWidgets(judgeMe.$(host));
        judgeMe.customizeReviews?.();
      } catch (error) {
        // Keep the PDP visible if Judge.me rejects a media payload.
      }
    }

    finalizeJudgeMeFallback();
  };

  const initJudgeMeWidget = () => {
    const wrapper = ensureJudgeMeWrapper();
    finalizeJudgeMeFallback();

    if (!wrapper || !window.jdgm) return false;

    if (window.jdgm.$ && window.jdgm.initializeWidgets) {
      runJudgeMeSetup();
      return true;
    }

    if (!window.jdgm.loadScript || !window.jdgm.CDN_HOST) return false;

    if (window.__gtPdpJudgeMeLegacyLoaded) {
      runJudgeMeSetup();
      return true;
    }

    if (!window.__gtPdpJudgeMeLegacyLoading) {
      window.__gtPdpJudgeMeLegacyLoading = loadJudgeMeScript('widget/base.js')
        .then(() => loadJudgeMeScript('widget/common.js'))
        .then(() => loadJudgeMeScript('widget/main.js'))
        .then(() => {
          window.__gtPdpJudgeMeLegacyLoaded = true;
          runJudgeMeSetup();
        })
        .catch(finalizeJudgeMeFallback)
        .finally(() => {
          window.__gtPdpJudgeMeLegacyLoading = null;
        });
    } else {
      window.__gtPdpJudgeMeLegacyLoading.then(runJudgeMeSetup);
    }

    return true;
  };

  const scheduleJudgeMeWidget = () => {
    if (initJudgeMeWidget()) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (initJudgeMeWidget() || attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 500);
  };

  const setAccordionDefaults = () => {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    section.querySelectorAll('.gt-pdp__accordion-item').forEach((item) => {
      if (isMobile) {
        item.removeAttribute('open');
      } else if (!item.hasAttribute('data-keep-open')) {
        item.removeAttribute('open');
      }
    });
  };

  const getRelatedGrid = () => section.querySelector('.gt-pdp__related-grid');

  const formatRelatedMoney = (priceCents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        currency: window.Shopify?.currency?.active || 'USD',
        style: 'currency'
      }).format(priceCents / 100);
    } catch (error) {
      return `$${(priceCents / 100).toFixed(2)}`;
    }
  };

  const MONA_LISA_HANDLE = 'mona-lisa-cat-scratcher-bed';

  const getMonaLisaFullSetVariant = (variants = []) =>
    variants.find((variant) => {
      const title = String(variant.title || '').toLowerCase();
      return title.includes('full set') || (title.includes('frame') && title.includes('scratcher'));
    });

  const getRelatedPrice = (productData) => {
    const isMonaLisa = productData.handle === MONA_LISA_HANDLE;
    const variant = isMonaLisa
      ? getMonaLisaFullSetVariant(productData.variants) || productData.variants?.[0] || {}
      : productData.variants?.[0] || {};
    const rawPrice = Number.parseFloat(variant.price || productData.price || (isMonaLisa ? '159.00' : '0'));
    const priceCents = Math.round(rawPrice * 100);

    return {
      cents: priceCents || (isMonaLisa ? 15900 : 0),
      label: isMonaLisa
        ? `Full Set — ${formatRelatedMoney(priceCents || 15900)}`
        : formatRelatedMoney(priceCents)
    };
  };

  const normalizeMonaLisaRelatedCard = (card) => {
    if (card.dataset.productHandle !== MONA_LISA_HANDLE) return;
    card.dataset.priceCents = '15900';
    const price = card.querySelector('.gt-pdp__related-price');
    if (price && !price.textContent.includes('Full Set')) {
      price.textContent = `Full Set — ${formatRelatedMoney(15900)}`;
    }
  };

  const createRelatedCard = (productData) => {
    const relatedPrice = getRelatedPrice(productData);
    const imageData = productData.image || productData.images?.[0];
    const hoverImageData = productData.images?.[1];
    const imageSrc = typeof imageData === 'string' ? imageData : imageData?.src;
    const hoverImageSrc = typeof hoverImageData === 'string' ? hoverImageData : hoverImageData?.src;
    const imageAlt = (typeof imageData === 'object' && imageData?.alt) || productData.title || '';
    const card = document.createElement('a');
    const imageWrap = document.createElement('div');
    const title = document.createElement('p');
    const price = document.createElement('p');

    card.className = 'gt-pdp__related-card';
    card.href = `/products/${productData.handle}`;
    card.dataset.priceCents = String(relatedPrice.cents);
    card.dataset.productHandle = productData.handle;
    card.dataset.relatedOrder = '99';

    imageWrap.className = 'gt-pdp__related-img';
    if (imageSrc) {
      const image = document.createElement('img');
      image.className = 'gt-pdp__image gt-pdp__related-primary-image';
      image.loading = 'lazy';
      image.sizes = '(min-width: 901px) 25vw, 50vw';
      image.src = imageSrc;
      image.alt = imageAlt;
      imageWrap.appendChild(image);

      if (hoverImageSrc && hoverImageSrc !== imageSrc) {
        const hoverImage = document.createElement('img');
        hoverImage.className = 'gt-pdp__image gt-pdp__related-hover-image';
        hoverImage.loading = 'lazy';
        hoverImage.sizes = '(min-width: 901px) 25vw, 50vw';
        hoverImage.src = hoverImageSrc;
        hoverImage.alt = '';
        imageWrap.appendChild(hoverImage);
      }
    }

    title.className = 'gt-pdp__related-name';
    title.textContent = productData.title || '';

    price.className = 'gt-pdp__related-price';
    price.textContent = relatedPrice.label;

    card.append(imageWrap, title, price);
    return card;
  };

  const sortRelatedProducts = () => {
    const grid = getRelatedGrid();
    if (!grid) return [];

    const seenHandles = new Set([section.dataset.productHandle]);
    const cards = Array.from(grid.querySelectorAll('.gt-pdp__related-card')).filter((card) => {
      const handle = card.dataset.productHandle || card.getAttribute('href');
      if (!handle || seenHandles.has(handle)) {
        card.remove();
        return false;
      }
      seenHandles.add(handle);
      return true;
    });
    cards.forEach(normalizeMonaLisaRelatedCard);

    const sortedCards = cards.sort((a, b) => {
      const orderDiff = Number(a.dataset.relatedOrder ?? 99) - Number(b.dataset.relatedOrder ?? 99);
      if (orderDiff !== 0) return orderDiff;
      return Number(a.dataset.priceCents || 0) - Number(b.dataset.priceCents || 0);
    });
    sortedCards.forEach((card, index) => {
        if (grid.children[index] !== card) {
          grid.appendChild(card);
        }
        card.hidden = index >= 4;
      });

    return cards.filter((card) => !card.hidden);
  };

  const fillRelatedFallback = () => {
    const grid = getRelatedGrid();
    if (!grid || relatedFallbackPromise) return relatedFallbackPromise;

    const fallbackCollections = (recommendationsNode?.dataset.fallbackCollections || 'cat-furniture')
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean);

    relatedFallbackPromise = (async () => {
      for (const collectionHandle of fallbackCollections) {
        if (sortRelatedProducts().length >= 4) break;

        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=24`, {
          credentials: 'same-origin'
        });
        if (!response.ok) continue;

        const payload = await response.json();
        const products = Array.isArray(payload.products) ? payload.products : [];

        for (const productData of products) {
          const existingHandles = new Set(
            Array.from(grid.querySelectorAll('.gt-pdp__related-card'))
              .map((card) => card.dataset.productHandle || card.getAttribute('href'))
          );

          if (
            !productData.handle ||
            productData.handle === section.dataset.productHandle ||
            existingHandles.has(productData.handle)
          ) {
            continue;
          }

          grid.appendChild(createRelatedCard(productData));
          if (sortRelatedProducts().length >= 4) break;
        }
      }

      sortRelatedProducts();
    })().catch(() => {
      sortRelatedProducts();
    });

    return relatedFallbackPromise;
  };

  const ensureRelatedProducts = () => {
    if (sortRelatedProducts().length < 4) {
      fillRelatedFallback();
    }
  };

  const updateStickyCta = (entry) => {
    if (!stickyCta || !heroCta) return;

    if (!desktopMedia.matches) {
      stickyCta.classList.add('is-visible');
      return;
    }

    const maybeEntry = Array.isArray(entry) ? entry[0] : entry;
    const sentinelEntry = maybeEntry && 'isIntersecting' in maybeEntry ? maybeEntry : null;
    const hasPassedHeroCta = sentinelEntry
      ? !sentinelEntry.isIntersecting && sentinelEntry.boundingClientRect.bottom <= 0
      : window.scrollY >= heroCtaTriggerBottom;
    stickyCta.classList.toggle('is-visible', hasPassedHeroCta);
  };

  const resetProductInfoPin = () => {
    if (!productInfo || !productInfoWrap) return;

    productInfo.classList.remove('is-fixed', 'is-bottom');
    productInfo.style.left = '';
    productInfo.style.width = '';
    productInfo.style.removeProperty('--gt-product-info-max-height');
    productInfo.style.removeProperty('--gt-product-info-top');
    productInfoWrap.style.minHeight = '';
  };

  const lockMobileGallery = () => {
    if (!window.matchMedia('(max-width: 900px)').matches) return;

    if (heroGrid) {
      heroGrid.style.setProperty('display', 'flex', 'important');
      heroGrid.style.setProperty('flex-direction', 'column', 'important');
      heroGrid.style.setProperty('gap', '0', 'important');
      heroGrid.style.setProperty('grid-template-columns', 'none', 'important');
      heroGrid.style.setProperty('position', 'relative', 'important');
    }

    if (productInfoWrap) {
      productInfoWrap.style.setProperty('order', '1', 'important');
      productInfoWrap.style.setProperty('padding', '14px 24px 14px', 'important');
      productInfoWrap.style.setProperty('width', '100%', 'important');
    }

    const gallery = section.querySelector('.gt-pdp__gallery');
    if (gallery) {
      gallery.style.setProperty('display', 'flex', 'important');
      gallery.style.setProperty('gap', '0', 'important');
      gallery.style.setProperty('grid-template-columns', 'none', 'important');
      gallery.style.setProperty('order', '2', 'important');
      gallery.style.setProperty('overflow-x', 'auto', 'important');
      gallery.style.setProperty('overflow-y', 'hidden', 'important');
      gallery.style.setProperty('padding', '0', 'important');
      gallery.style.setProperty('position', 'relative', 'important');
      gallery.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
      gallery.style.setProperty('width', '100%', 'important');
      gallery.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
    }

    if (heroGrid && productInfo && gallery) {
      let purchaseWrap = section.querySelector('.gt-pdp__mobile-purchase-wrap');
      if (!purchaseWrap) {
        purchaseWrap = document.createElement('div');
        purchaseWrap.className = 'gt-pdp__mobile-purchase-wrap';
        gallery.insertAdjacentElement('afterend', purchaseWrap);
      } else if (purchaseWrap.previousElementSibling !== gallery) {
        gallery.insertAdjacentElement('afterend', purchaseWrap);
      }

      ['.gt-pdp__form', '.gt-pdp__trust-mini', '.gt-pdp__accordion-block'].forEach((selector) => {
        const node = section.querySelector(selector);
        if (node && node.parentElement !== purchaseWrap) purchaseWrap.appendChild(node);
      });

      purchaseWrap.style.setProperty('order', '3', 'important');
      purchaseWrap.style.setProperty('padding', '18px 24px 22px', 'important');
      purchaseWrap.style.setProperty('width', '100%', 'important');
    }

    section.querySelectorAll('.gt-pdp__gallery-frame, .gt-pdp__gallery-img').forEach((frame) => {
      frame.style.setProperty('aspect-ratio', '1 / 1', 'important');
      frame.style.setProperty('flex', '0 0 100%', 'important');
      frame.style.setProperty('min-height', '0', 'important');
      frame.style.setProperty('scroll-snap-align', 'start', 'important');
      frame.style.setProperty('width', '100%', 'important');
    });

    if (heroGrid && gallery && heroGrid.dataset.gtMobileArrowsReady !== 'true') {
      gallery.querySelectorAll('.gt-pdp__gallery-arrow').forEach((button) => button.remove());

      const makeArrow = (modifier, label, text, direction) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `gt-pdp__gallery-arrow gt-pdp__gallery-arrow--${modifier}`;
        button.setAttribute('aria-label', label);
        button.textContent = text;
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          gallery.scrollBy({
            left: direction * gallery.clientWidth,
            behavior: 'smooth'
          });
        });
        return button;
      };

      gallery.appendChild(makeArrow('prev', 'Previous product image', '‹', -1));
      gallery.appendChild(makeArrow('next', 'Next product image', '›', 1));
      heroGrid.dataset.gtMobileArrowsReady = 'true';
    }
  };

  const playUgcVideos = () => {
    section.querySelectorAll('.gt-pdp__ugc-video').forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'auto');
      if (video.readyState === 0) video.load();
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    });
  };

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      section.querySelectorAll('.gt-pdp__variant-btn').forEach((label) => {
        label.classList.toggle('is-selected', label.contains(input));
      });

      priceNodes.forEach((node) => {
        node.textContent = input.dataset.price;
      });

    });
  });

  section.querySelectorAll('.gt-pdp__variant-btn').forEach((label) => {
    if (label.dataset.gtVariantClickReady === 'true') return;
    label.dataset.gtVariantClickReady = 'true';

    label.addEventListener('click', (event) => {
      const input = label.querySelector('[data-gt-variant-input]');
      if (!input || input.disabled) return;

      event.preventDefault();
      event.stopPropagation();

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      section.querySelectorAll('.gt-pdp__variant-btn').forEach((option) => {
        option.classList.toggle('is-selected', option === label);
      });

      priceNodes.forEach((node) => {
        node.textContent = input.dataset.price;
      });
    }, true);
  });

  setAccordionDefaults();
  lockMobileGallery();
  playUgcVideos();
  requestAnimationFrame(lockMobileGallery);
  setTimeout(lockMobileGallery, 300);
  setTimeout(lockMobileGallery, 1200);
  setTimeout(lockMobileGallery, 3000);
  setTimeout(lockMobileGallery, 6000);
  setTimeout(playUgcVideos, 300);
  setTimeout(playUgcVideos, 1200);
  ensureRelatedProducts();
  scheduleJudgeMeWidget();

  if (recommendationsNode) {
    new MutationObserver(ensureRelatedProducts).observe(recommendationsNode, { childList: true });
  }

  if (stickyCta && heroCta) {
    const stickyTrigger = stickySentinel || heroCta;
    captureHeroCtaTrigger();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => updateStickyCta(entries[0]), { threshold: 0 }).observe(stickyTrigger);
    }
    window.addEventListener('scroll', updateStickyCta, { passive: true });
    window.addEventListener('resize', () => {
      captureHeroCtaTrigger();
      updateStickyCta();
    }, { passive: true });
    updateStickyCta();
  }

  if (productInfo && productInfoWrap && heroGrid) {
    resetProductInfoPin();
    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', resetProductInfoPin);
    }
  }

  window.addEventListener('resize', setAccordionDefaults, { passive: true });
  window.addEventListener('resize', lockMobileGallery, { passive: true });
  document.addEventListener('touchstart', playUgcVideos, { once: true, passive: true });
  document.addEventListener('click', playUgcVideos, { once: true });
  document.addEventListener('jdgm.finishLoadingCore', scheduleJudgeMeWidget, { once: true });
  document.addEventListener('jdgm.doneSetup', finalizeJudgeMeFallback);
}

injectGardenTunnelMobileReviewLayout();
document.querySelectorAll('.gt-pdp').forEach(initGardenTunnelPdp);
document.addEventListener('shopify:section:load', (event) => {
  initGardenTunnelPdp(event.target.querySelector('.gt-pdp'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-garden-tunnel-pdp-v16"] && !Shopify.designMode) return;
  try {
    
function injectGardenTunnelCompactRepair() {
  if (document.getElementById('gt-pdp-section-wildone-repair-20260523')) return;

  const style = document.createElement('style');
  style.id = 'gt-pdp-section-wildone-repair-20260523';
  style.textContent = `
    html body .shopify-section .gt-pdp .gt-pdp__hero { margin-top: 0 !important; padding: 0 40px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__hero-grid { align-items: start !important; display: grid !important; gap: 20px !important; grid-template-columns: 1fr 1fr !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery { display: grid !important; gap: 8px !important; grid-template-columns: 1fr !important; min-height: 0 !important; overflow: visible !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; height: auto !important; min-height: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { align-self: stretch !important; display: block !important; min-width: 0 !important; padding: 15px 0 0 !important; position: relative !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { align-self: start !important; bottom: auto !important; left: auto !important; max-height: none !important; overflow: visible !important; padding: 0 0 28px !important; position: sticky !important; top: calc(var(--header-height, 88px) + 15px) !important; width: auto !important; z-index: 30 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__breadcrumb, html body .shopify-section .gt-pdp .gt-pdp__eyebrow { align-items: center !important; background: #CCBCA8 !important; border-radius: 3px !important; color: #593518 !important; display: inline-flex !important; font-size: 10px !important; letter-spacing: 0.12em !important; line-height: 1.2 !important; margin: 0 0 10px !important; padding: 5px 12px !important; text-transform: uppercase !important; width: fit-content !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info h1 { font-family: Georgia, "Times New Roman", serif !important; font-size: 30px !important; font-weight: 400 !important; letter-spacing: 0 !important; line-height: 1.05 !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__title-meta-row { align-items: center !important; display: flex !important; flex-wrap: wrap !important; gap: 10px !important; justify-content: flex-start !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__lead-inline { color: rgba(89, 53, 24, 0.78) !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 14px !important; font-style: italic !important; line-height: 1.35 !important; margin: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__reviews-inline, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline * { font-size: 13px !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__price { font-family: Georgia, "Times New Roman", serif !important; font-size: 20px !important; line-height: 1 !important; margin: 0 0 22px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-label { color: rgba(89, 53, 24, 0.68) !important; display: block !important; font-size: 11px !important; letter-spacing: 0.16em !important; line-height: 1.2 !important; margin: 0 0 10px !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-options { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 0 !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn { align-items: center !important; display: flex !important; flex-direction: row !important; gap: 10px !important; justify-content: space-between !important; min-height: 46px !important; padding: 0 14px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn span, html body .shopify-section .gt-pdp .gt-pdp__variant-title { font-size: 14px !important; font-weight: 500 !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn small, html body .shopify-section .gt-pdp .gt-pdp__variant-size { color: rgba(89, 53, 24, 0.68) !important; font-size: 12px !important; line-height: 1.2 !important; margin: 0 !important; text-align: right !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 16px 0 10px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row > * { width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap { min-height: 72px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__button, html body .shopify-section .gt-pdp .shopify-payment-button__button { height: 48px !important; min-height: 48px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add { font-size: 13px !important; letter-spacing: 0.08em !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__more-options { display: block !important; font-size: 11px !important; line-height: 1.3 !important; margin: 10px auto 0 !important; text-align: center !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini { align-items: center !important; column-gap: 30px !important; display: grid !important; grid-template-columns: repeat(3, max-content) !important; justify-content: space-between !important; margin: 0 !important; padding: 16px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item { align-items: center !important; display: grid !important; gap: 0 14px !important; grid-template-columns: 45px max-content !important; justify-content: flex-start !important; min-width: 0 !important; padding: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:nth-child(n + 2) { grid-template-columns: 35px max-content !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > svg, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > picture, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::before, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::after { content: none !important; display: none !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > img, html body .shopify-section .gt-pdp .gt-pdp__trust-icon { display: block !important; flex: 0 0 35px !important; height: 35px !important; margin: 0 !important; object-fit: contain !important; width: 35px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:first-child > img, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:first-child .gt-pdp__trust-icon { flex-basis: 45px !important; height: 45px !important; width: 45px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-copy { display: block !important; min-width: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-title { display: block !important; font-size: 10.5px !important; letter-spacing: 0.1em !important; line-height: 1.2 !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-sub { font-size: 11px !important; line-height: 1.35 !important; overflow-wrap: normal !important; white-space: normal !important; word-break: normal !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-block { margin-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item:first-child { border-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item { padding: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item summary { font-size: 14px !important; font-weight: 500 !important; padding: 10px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features { clear: both !important; padding: 0 0 40px !important; position: relative !important; z-index: 1 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-heading { margin-left: auto !important; margin-right: auto !important; padding: 40px 0 32px !important; width: calc(100% - 80px) !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-grid { margin-left: auto !important; margin-right: auto !important; padding: 0 !important; width: calc(100% - 80px) !important; }
    @media (max-width: 900px) { html body .shopify-section .gt-pdp .gt-pdp__hero { padding: 0 !important; } html body .shopify-section .gt-pdp .gt-pdp__hero-grid { display: block !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery { grid-template-columns: 1fr !important; gap: 16px !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; } html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { padding: 32px 24px 32px !important; } html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { max-height: none !important; overflow: visible !important; padding: 0 !important; position: relative !important; top: auto !important; } html body .shopify-section .gt-pdp .gt-pdp__features { padding: 0 0 40px !important; } html body .shopify-section .gt-pdp .gt-pdp__features-heading { padding: 20px 0 28px !important; width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__features-grid { width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini { grid-template-columns: 1fr !important; justify-content: stretch !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item { grid-template-columns: 40px minmax(0, 1fr) !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:nth-child(n + 2) { grid-template-columns: 40px minmax(0, 1fr) !important; } }
    @media (max-width: 480px) { html body .shopify-section .gt-pdp .gt-pdp__buy-row, html body .shopify-section .gt-pdp .gt-pdp__variant-options { grid-template-columns: 1fr !important; } }
    @media (max-width: 900px) {
      html body .shopify-section .gt-pdp .gt-pdp__hero { padding: 0 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__hero-grid { display: flex !important; flex-direction: column !important; gap: 0 !important; grid-template-columns: none !important; position: relative !important; }
      html body .shopify-section .gt-pdp .gt-pdp__gallery { display: flex !important; gap: 0 !important; grid-template-columns: none !important; margin: 0 !important; order: 2 !important; overflow-x: auto !important; overflow-y: hidden !important; padding: 0 !important; position: relative !important; scroll-snap-type: x mandatory !important; scrollbar-width: none !important; width: 100% !important; -webkit-overflow-scrolling: touch !important; }
      html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; flex: 0 0 100% !important; min-height: 0 !important; position: relative !important; scroll-snap-align: start !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__gallery-arrow { align-items: center !important; background: transparent !important; border: 0 !important; border-radius: 0 !important; color: rgba(44, 24, 16, 0.42) !important; display: flex !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 34px !important; font-weight: 400 !important; height: 52px !important; justify-content: center !important; line-height: 1 !important; padding: 0 !important; position: absolute !important; text-shadow: 0 1px 3px rgba(250, 247, 242, 0.8) !important; top: 50% !important; transform: translateY(-50%) !important; width: 36px !important; z-index: 6 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__gallery-arrow--prev { left: 8px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__gallery-arrow--next { right: 8px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { order: 1 !important; padding: 8px 24px 8px !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__mobile-purchase-wrap { order: 3 !important; padding: 18px 24px 0 !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__breadcrumb, html body .shopify-section .gt-pdp .gt-pdp__eyebrow { margin: 0 0 6px !important; padding: 5px 12px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__title-meta-row { align-items: center !important; display: flex !important; flex-wrap: nowrap !important; gap: 6px !important; margin: 0 0 8px !important; overflow: visible !important; }
      html body .shopify-section .gt-pdp .gt-pdp__lead-inline { flex: 1 1 auto !important; font-size: 14.5px !important; line-height: 1.25 !important; min-width: 0 !important; white-space: nowrap !important; }
      html body .shopify-section .gt-pdp .gt-pdp__price-row { align-items: center !important; display: flex !important; gap: 10px !important; justify-content: flex-start !important; margin: 0 0 10px !important; min-height: 30px !important; white-space: nowrap !important; }
      html body .shopify-section .gt-pdp .gt-pdp__reviews-inline { align-items: center !important; display: inline-flex !important; flex: 0 0 auto !important; gap: 4px !important; height: 30px !important; justify-content: flex-start !important; line-height: 1 !important; min-height: 30px !important; white-space: nowrap !important; }
      html body .shopify-section .gt-pdp .gt-pdp__reviews-inline .jdgm-prev-badge, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline .jdgm-prev-badge__stars, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline .jdgm-prev-badge__text { align-items: center !important; display: inline-flex !important; gap: 4px !important; height: 30px !important; line-height: 30px !important; min-height: 30px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__reviews-inline, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline * { font-size: 13px !important; line-height: 1 !important; margin-bottom: 0 !important; margin-top: 0 !important; vertical-align: middle !important; }
      html body .shopify-section .gt-pdp .gt-pdp__price { align-items: center !important; display: inline-flex !important; line-height: 1 !important; margin: 0 !important; min-height: 30px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__buy-row, html body .shopify-section .gt-pdp .gt-pdp__variant-options { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__cta-add, html body .shopify-section .gt-pdp .product-form__submit, html body .shopify-section .gt-pdp button[name='add'], html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap, html body .shopify-section .gt-pdp .shopify-payment-button, html body .shopify-section .gt-pdp .shopify-payment-button__button { height: 50px !important; min-height: 50px !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button { height: auto !important; min-height: 72px !important; overflow: visible !important; }
      html body .shopify-section .gt-pdp .gt-pdp__variant-btn { height: 50px !important; min-height: 50px !important; padding: 0 12px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__variant-btn:not(.is-selected):not(.is-disabled) { border: 1px solid rgba(89, 53, 24, 0.28) !important; }
      html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__more-options { margin: 8px auto 11px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__trust-mini { align-items: start !important; display: grid !important; gap: 0 !important; grid-template-columns: repeat(3, max-content) !important; justify-content: space-between !important; margin: 4px 0 0 !important; padding: 18px 0 20px !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:nth-child(n + 2) { align-items: center !important; display: flex !important; flex-direction: column !important; gap: 8px !important; grid-template-columns: none !important; justify-content: flex-start !important; min-width: 0 !important; padding: 0 !important; text-align: center !important; width: auto !important; }
      html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > img, html body .shopify-section .gt-pdp .gt-pdp__trust-icon { flex: 0 0 35px !important; height: 35px !important; margin: 5px auto !important; object-fit: contain !important; width: 35px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:first-child > img, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:first-child .gt-pdp__trust-icon { flex: 0 0 45px !important; height: 45px !important; margin: 0 auto !important; max-height: 45px !important; max-width: 45px !important; transform: none !important; width: 45px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__trust-title { font-size: 9.5px !important; font-weight: 650 !important; letter-spacing: 0.04em !important; line-height: 1.15 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__trust-sub { font-size: 10px !important; letter-spacing: 0 !important; line-height: 1.2 !important; white-space: nowrap !important; }
      html body .shopify-section .gt-pdp .gt-pdp__mobile-purchase-wrap { padding-bottom: 0 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__accordion-block { margin-bottom: 0 !important; padding-bottom: 0 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__accordion-item:last-child { margin-bottom: 0 !important; padding-bottom: 0 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__ugc { margin: 20px 0 0 !important; padding-top: 0 !important; padding-bottom: 28px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__ugc .gt-pdp__section-title { margin-top: 0 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__features-heading { padding: 20px 0 24px !important; }
    }
    @media (max-width: 480px) {
      html body .shopify-section .gt-pdp .gt-pdp__buy-row,
      html body .shopify-section .gt-pdp .gt-pdp__variant-options { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
    }
  `;
  document.head.appendChild(style);
}

function initGardenTunnelPdp(section) {
  if (!section || section.dataset.gtInitialized === '20260524-gallery-video-arrow-repair') return;
  section.dataset.gtInitialized = '20260524-gallery-video-arrow-repair';
  injectGardenTunnelCompactRepair();

  const variantInputs = Array.from(section.querySelectorAll('[data-gt-variant-input]'));
  const priceNodes = Array.from(section.querySelectorAll('[data-gt-price], [data-gt-sticky-price]'));
  const stickyCta = section.querySelector('.gt-pdp__sticky-cta');
  const heroCta = section.querySelector('.gt-pdp__cta-add');
  const recommendationsNode = section.querySelector('.gt-pdp__recommendations');
  const heroGrid = section.querySelector('.gt-pdp__hero-grid');
  const productInfoWrap = section.querySelector('.gt-pdp__product-info-wrap');
  const productInfo = section.querySelector('.gt-pdp__product-info');
  const desktopMedia = window.matchMedia('(min-width: 901px)');
  let relatedFallbackPromise = null;

  const formatJudgeDate = (value) => {
    if (!value) return '';

    const parts = value.slice(0, 10).split('-');
    if (parts.length !== 3) return value;

    const [year, month, day] = parts;
    const format = window.jdgmSettings?.review_date_format || 'mm/dd/yyyy';

    if (format === 'dd/mm/yyyy') return `${day}/${month}/${year}`;
    if (format === 'yyyy-mm-dd') return `${year}-${month}-${day}`;
    return `${month}/${day}/${year}`;
  };

  const parseReviewCount = (text) => {
    const match = String(text || '').match(/(\d+)/);
    return match ? Number.parseInt(match[1], 10) : 0;
  };

  const inferReviewHistogram = (widget, averageRating, totalCount) => {
    const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    const reviewStars = Array.from(widget.querySelectorAll('.jm-review-item .jm-star-rating[aria-label]'));

    reviewStars.forEach((star) => {
      const match = star.getAttribute('aria-label')?.match(/([1-5])\s+out/i);
      const rating = match ? Number.parseInt(match[1], 10) : 0;
      if (rating >= 1 && rating <= 5) counts[rating] += 1;
    });

    const visibleCount = Object.values(counts).reduce((sum, value) => sum + value, 0);
    let remainingCount = Math.max(0, totalCount - visibleCount);
    let remainingScore = Math.max(
      0,
      Math.round(averageRating * totalCount) -
        Object.entries(counts).reduce((sum, [rating, count]) => sum + Number(rating) * count, 0)
    );

    while (remainingCount > 0) {
      const inferredRating = Math.min(5, Math.max(1, Math.round(remainingScore / remainingCount) || 5));
      counts[inferredRating] += 1;
      remainingScore -= inferredRating;
      remainingCount -= 1;
    }

    return counts;
  };

  const enhanceJudgeMeReviewSurface = () => {
    const widget = section.querySelector('#judgeme_product_reviews');
    if (!widget) return;

    const ratingDisplay = widget.querySelector('.jm-average-rating-display');
    const scoreNode = ratingDisplay?.querySelector('.jm-text:first-child');
    const countNode = ratingDisplay?.querySelector('.jm-text:last-child');
    const averageRating = Number.parseFloat(scoreNode?.textContent || '0') || 0;
    const totalCount = parseReviewCount(countNode?.textContent);

    if (countNode && totalCount > 0) {
      const desiredCountText = `Based on ${totalCount} ${totalCount === 1 ? 'review' : 'reviews'}`;
      if (countNode.textContent.trim() !== desiredCountText) {
        countNode.textContent = desiredCountText;
      }
    }

    if (ratingDisplay && averageRating > 0 && totalCount > 0) {
      const ratingRow = ratingDisplay.closest('.jm-cluster') || ratingDisplay;
      const summaryStack = ratingRow.parentElement;
      if (summaryStack) {
        const counts = inferReviewHistogram(widget, averageRating, totalCount);
        const signature = `${averageRating}|${totalCount}|${[5, 4, 3, 2, 1].map((rating) => counts[rating]).join(',')}`;
        let histogram = summaryStack.querySelector(':scope > .gt-pdp__jm-histogram');

        if (!histogram) {
          histogram = document.createElement('div');
          histogram.className = 'gt-pdp__jm-histogram';
          histogram.setAttribute('aria-hidden', 'true');
          ratingRow.insertAdjacentElement('afterend', histogram);
        }

        if (histogram.dataset.signature !== signature) {
          histogram.dataset.signature = signature;
          histogram.innerHTML = [5, 4, 3, 2, 1].map((rating) => {
            const count = counts[rating] || 0;
            const width = totalCount > 0 ? Math.round((count / totalCount) * 100) : 0;
            return `
              <div class="gt-pdp__jm-histogram-row">
                <span class="gt-pdp__jm-histogram-rating">${rating}</span>
                <span class="gt-pdp__jm-histogram-star">★</span>
                <span class="gt-pdp__jm-histogram-track"><span class="gt-pdp__jm-histogram-fill" style="--gt-jm-bar: ${width}%"></span></span>
                <span class="gt-pdp__jm-histogram-count">${count}</span>
              </div>
            `;
          }).join('');
        }
      }
    }
  };

  const finalizeJudgeMeFallback = () => {
    const widget = section.querySelector('.gt-pdp__judge-widget');
    if (!widget) return;

    widget.querySelectorAll('.jdgm-rev__timestamp.jdgm-spinner[data-content]').forEach((timestamp) => {
      timestamp.textContent = formatJudgeDate(timestamp.dataset.content);
      timestamp.classList.remove('jdgm-spinner');
    });

    widget.querySelectorAll('.jdgm-rev__pic-img[data-src]').forEach((image) => {
      if (!image.getAttribute('src')) {
        image.setAttribute('src', image.dataset.src);
      }
      image.closest('.jdgm-rev__pic-link')?.classList.remove('jdgm--loading');
    });

    widget.querySelectorAll('.jdgm-rev-widg__paginate-spinner-wrapper').forEach((spinner) => {
      spinner.style.display = 'none';
    });

    enhanceJudgeMeReviewSurface();
  };

  const ensureJudgeMeWrapper = () => {
    const host = section.querySelector('.gt-pdp__judge-widget');
    if (!host) return null;

    let wrapper = host.querySelector('#judgeme_product_reviews');
    const legacyWidget = host.querySelector(':scope > .jdgm-rev-widg');

    if (!wrapper && legacyWidget) {
      wrapper = document.createElement('div');
      wrapper.id = 'judgeme_product_reviews';
      wrapper.className = 'jdgm-widget jdgm-review-widget';
      wrapper.dataset.id = String(window.ShopifyAnalytics?.meta?.product?.id || '');
      wrapper.dataset.productTitle = window.ShopifyAnalytics?.meta?.product?.name || '';
      host.insertBefore(wrapper, legacyWidget);
      wrapper.appendChild(legacyWidget);
    }

    if (wrapper) {
      wrapper.classList.add('jdgm-widget', 'jdgm-review-widget');
      if (!wrapper.dataset.id && window.ShopifyAnalytics?.meta?.product?.id) {
        wrapper.dataset.id = String(window.ShopifyAnalytics.meta.product.id);
      }
    }

    return wrapper;
  };

  const loadJudgeMeScript = (path) => new Promise((resolve) => {
    const judgeMe = window.jdgm;
    if (!judgeMe?.loadScript || !judgeMe.CDN_HOST) {
      resolve(false);
      return;
    }

    const url = judgeMe.CDN_HOST + path;
    const requested = judgeMe.loadScript.requestedUrls || [];
    if (requested.includes(url)) {
      resolve(true);
      return;
    }

    judgeMe.loadScript(url, () => resolve(true));
  });

  const runJudgeMeSetup = () => {
    const host = section.querySelector('.gt-pdp__judge-widget');
    const judgeMe = window.jdgm;

    if (host && judgeMe?.$ && judgeMe.initializeWidgets) {
      try {
        judgeMe.initializeWidgets(judgeMe.$(host));
        judgeMe.customizeReviews?.();
      } catch (error) {
        // Keep the PDP visible if Judge.me rejects a media payload.
      }
    }

    finalizeJudgeMeFallback();
  };

  const initJudgeMeWidget = () => {
    const wrapper = ensureJudgeMeWrapper();
    finalizeJudgeMeFallback();

    if (!wrapper || !window.jdgm) return false;

    if (window.jdgm.$ && window.jdgm.initializeWidgets) {
      runJudgeMeSetup();
      return true;
    }

    if (!window.jdgm.loadScript || !window.jdgm.CDN_HOST) return false;

    if (window.__gtPdpJudgeMeLegacyLoaded) {
      runJudgeMeSetup();
      return true;
    }

    if (!window.__gtPdpJudgeMeLegacyLoading) {
      window.__gtPdpJudgeMeLegacyLoading = loadJudgeMeScript('widget/base.js')
        .then(() => loadJudgeMeScript('widget/common.js'))
        .then(() => loadJudgeMeScript('widget/main.js'))
        .then(() => {
          window.__gtPdpJudgeMeLegacyLoaded = true;
          runJudgeMeSetup();
        })
        .catch(finalizeJudgeMeFallback)
        .finally(() => {
          window.__gtPdpJudgeMeLegacyLoading = null;
        });
    } else {
      window.__gtPdpJudgeMeLegacyLoading.then(runJudgeMeSetup);
    }

    return true;
  };

  const scheduleJudgeMeWidget = () => {
    if (initJudgeMeWidget()) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (initJudgeMeWidget() || attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 500);
  };

  const setAccordionDefaults = () => {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    section.querySelectorAll('.gt-pdp__accordion-item').forEach((item) => {
      if (isMobile) {
        item.removeAttribute('open');
      } else if (!item.hasAttribute('data-keep-open')) {
        item.removeAttribute('open');
      }
    });
  };

  const getRelatedGrid = () => section.querySelector('.gt-pdp__related-grid');

  const formatRelatedMoney = (priceCents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        currency: window.Shopify?.currency?.active || 'USD',
        style: 'currency'
      }).format(priceCents / 100);
    } catch (error) {
      return `$${(priceCents / 100).toFixed(2)}`;
    }
  };

  const MONA_LISA_HANDLE = 'mona-lisa-cat-scratcher-bed';

  const getMonaLisaFullSetVariant = (variants = []) =>
    variants.find((variant) => {
      const title = String(variant.title || '').toLowerCase();
      return title.includes('full set') || (title.includes('frame') && title.includes('scratcher'));
    });

  const getRelatedPrice = (productData) => {
    const isMonaLisa = productData.handle === MONA_LISA_HANDLE;
    const variant = isMonaLisa
      ? getMonaLisaFullSetVariant(productData.variants) || productData.variants?.[0] || {}
      : productData.variants?.[0] || {};
    const rawPrice = Number.parseFloat(variant.price || productData.price || (isMonaLisa ? '159.00' : '0'));
    const priceCents = Math.round(rawPrice * 100);

    return {
      cents: priceCents || (isMonaLisa ? 15900 : 0),
      label: isMonaLisa
        ? `Full Set — ${formatRelatedMoney(priceCents || 15900)}`
        : formatRelatedMoney(priceCents)
    };
  };

  const normalizeMonaLisaRelatedCard = (card) => {
    if (card.dataset.productHandle !== MONA_LISA_HANDLE) return;
    card.dataset.priceCents = '15900';
    const price = card.querySelector('.gt-pdp__related-price');
    if (price && !price.textContent.includes('Full Set')) {
      price.textContent = `Full Set — ${formatRelatedMoney(15900)}`;
    }
  };

  const createRelatedCard = (productData) => {
    const relatedPrice = getRelatedPrice(productData);
    const imageData = productData.image || productData.images?.[0];
    const hoverImageData = productData.images?.[1];
    const imageSrc = typeof imageData === 'string' ? imageData : imageData?.src;
    const hoverImageSrc = typeof hoverImageData === 'string' ? hoverImageData : hoverImageData?.src;
    const imageAlt = (typeof imageData === 'object' && imageData?.alt) || productData.title || '';
    const card = document.createElement('a');
    const imageWrap = document.createElement('div');
    const title = document.createElement('p');
    const price = document.createElement('p');

    card.className = 'gt-pdp__related-card';
    card.href = `/products/${productData.handle}`;
    card.dataset.priceCents = String(relatedPrice.cents);
    card.dataset.productHandle = productData.handle;
    card.dataset.relatedOrder = '99';

    imageWrap.className = 'gt-pdp__related-img';
    if (imageSrc) {
      const image = document.createElement('img');
      image.className = 'gt-pdp__image gt-pdp__related-primary-image';
      image.loading = 'lazy';
      image.sizes = '(min-width: 901px) 25vw, 50vw';
      image.src = imageSrc;
      image.alt = imageAlt;
      imageWrap.appendChild(image);

      if (hoverImageSrc && hoverImageSrc !== imageSrc) {
        const hoverImage = document.createElement('img');
        hoverImage.className = 'gt-pdp__image gt-pdp__related-hover-image';
        hoverImage.loading = 'lazy';
        hoverImage.sizes = '(min-width: 901px) 25vw, 50vw';
        hoverImage.src = hoverImageSrc;
        hoverImage.alt = '';
        imageWrap.appendChild(hoverImage);
      }
    }

    title.className = 'gt-pdp__related-name';
    title.textContent = productData.title || '';

    price.className = 'gt-pdp__related-price';
    price.textContent = relatedPrice.label;

    card.append(imageWrap, title, price);
    return card;
  };

  const sortRelatedProducts = () => {
    const grid = getRelatedGrid();
    if (!grid) return [];

    const seenHandles = new Set([section.dataset.productHandle]);
    const cards = Array.from(grid.querySelectorAll('.gt-pdp__related-card')).filter((card) => {
      const handle = card.dataset.productHandle || card.getAttribute('href');
      if (!handle || seenHandles.has(handle)) {
        card.remove();
        return false;
      }
      seenHandles.add(handle);
      return true;
    });
    cards.forEach(normalizeMonaLisaRelatedCard);

    const sortedCards = cards.sort((a, b) => {
      const orderDiff = Number(a.dataset.relatedOrder ?? 99) - Number(b.dataset.relatedOrder ?? 99);
      if (orderDiff !== 0) return orderDiff;
      return Number(a.dataset.priceCents || 0) - Number(b.dataset.priceCents || 0);
    });
    sortedCards.forEach((card, index) => {
        if (grid.children[index] !== card) {
          grid.appendChild(card);
        }
        card.hidden = index >= 4;
      });

    return cards.filter((card) => !card.hidden);
  };

  const fillRelatedFallback = () => {
    const grid = getRelatedGrid();
    if (!grid || relatedFallbackPromise) return relatedFallbackPromise;

    const fallbackCollections = (recommendationsNode?.dataset.fallbackCollections || 'cat-furniture')
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean);

    relatedFallbackPromise = (async () => {
      for (const collectionHandle of fallbackCollections) {
        if (sortRelatedProducts().length >= 4) break;

        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=24`, {
          credentials: 'same-origin'
        });
        if (!response.ok) continue;

        const payload = await response.json();
        const products = Array.isArray(payload.products) ? payload.products : [];

        for (const productData of products) {
          const existingHandles = new Set(
            Array.from(grid.querySelectorAll('.gt-pdp__related-card'))
              .map((card) => card.dataset.productHandle || card.getAttribute('href'))
          );

          if (
            !productData.handle ||
            productData.handle === section.dataset.productHandle ||
            existingHandles.has(productData.handle)
          ) {
            continue;
          }

          grid.appendChild(createRelatedCard(productData));
          if (sortRelatedProducts().length >= 4) break;
        }
      }

      sortRelatedProducts();
    })().catch(() => {
      sortRelatedProducts();
    });

    return relatedFallbackPromise;
  };

  const ensureRelatedProducts = () => {
    if (sortRelatedProducts().length < 4) {
      fillRelatedFallback();
    }
  };

  const updateStickyCta = () => {
    if (!stickyCta || !heroCta) return;

    if (!desktopMedia.matches) {
      stickyCta.classList.add('is-visible');
      return;
    }

    const hasPassedHeroCta = heroCta.getBoundingClientRect().bottom <= 0;
    stickyCta.classList.toggle('is-visible', hasPassedHeroCta);
  };

  const resetProductInfoPin = () => {
    if (!productInfo || !productInfoWrap) return;

    productInfo.classList.remove('is-fixed', 'is-bottom');
    productInfo.style.left = '';
    productInfo.style.width = '';
    productInfo.style.removeProperty('--gt-product-info-max-height');
    productInfo.style.removeProperty('--gt-product-info-top');
    productInfoWrap.style.minHeight = '';
  };

  const lockMobileGallery = () => {
    if (!window.matchMedia('(max-width: 900px)').matches) return;

    if (heroGrid) {
      heroGrid.style.setProperty('display', 'flex', 'important');
      heroGrid.style.setProperty('flex-direction', 'column', 'important');
      heroGrid.style.setProperty('gap', '0', 'important');
      heroGrid.style.setProperty('grid-template-columns', 'none', 'important');
      heroGrid.style.setProperty('position', 'relative', 'important');
    }

    if (productInfoWrap) {
      productInfoWrap.style.setProperty('order', '1', 'important');
      productInfoWrap.style.setProperty('padding', '8px 24px 8px', 'important');
      productInfoWrap.style.setProperty('width', '100%', 'important');
    }

    const price = section.querySelector('.gt-pdp__price');
    const reviews = section.querySelector('.gt-pdp__reviews-inline');
    if (price && reviews) {
      let priceRow = section.querySelector('.gt-pdp__price-row');
      if (!priceRow) {
        priceRow = document.createElement('div');
        priceRow.className = 'gt-pdp__price-row';
        price.insertAdjacentElement('beforebegin', priceRow);
      }
      if (price.parentElement !== priceRow) priceRow.appendChild(price);
      if (reviews.parentElement !== priceRow) priceRow.appendChild(reviews);
    }

    const gallery = section.querySelector('.gt-pdp__gallery');
    if (gallery) {
      gallery.style.setProperty('display', 'flex', 'important');
      gallery.style.setProperty('gap', '0', 'important');
      gallery.style.setProperty('grid-template-columns', 'none', 'important');
      gallery.style.setProperty('order', '2', 'important');
      gallery.style.setProperty('overflow-x', 'auto', 'important');
      gallery.style.setProperty('overflow-y', 'hidden', 'important');
      gallery.style.setProperty('padding', '0', 'important');
      gallery.style.setProperty('position', 'relative', 'important');
      gallery.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
      gallery.style.setProperty('width', '100%', 'important');
      gallery.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
    }

    if (heroGrid && productInfo && gallery) {
      let purchaseWrap = section.querySelector('.gt-pdp__mobile-purchase-wrap');
      if (!purchaseWrap) {
        purchaseWrap = document.createElement('div');
        purchaseWrap.className = 'gt-pdp__mobile-purchase-wrap';
        gallery.insertAdjacentElement('afterend', purchaseWrap);
      } else if (purchaseWrap.previousElementSibling !== gallery) {
        gallery.insertAdjacentElement('afterend', purchaseWrap);
      }

      ['.gt-pdp__form', '.gt-pdp__trust-mini', '.gt-pdp__accordion-block'].forEach((selector) => {
        const node = section.querySelector(selector);
        if (node && node.parentElement !== purchaseWrap) purchaseWrap.appendChild(node);
      });

      purchaseWrap.style.setProperty('order', '3', 'important');
      purchaseWrap.style.setProperty('padding', '18px 24px 0', 'important');
      purchaseWrap.style.setProperty('width', '100%', 'important');
    }

    section.querySelectorAll('.gt-pdp__gallery-frame, .gt-pdp__gallery-img').forEach((frame) => {
      frame.style.setProperty('aspect-ratio', '1 / 1', 'important');
      frame.style.setProperty('flex', '0 0 100%', 'important');
      frame.style.setProperty('min-height', '0', 'important');
      frame.style.setProperty('position', 'relative', 'important');
      frame.style.setProperty('scroll-snap-align', 'start', 'important');
      frame.style.setProperty('width', '100%', 'important');
    });

    if (heroGrid && gallery) {
      gallery.querySelectorAll('.gt-pdp__gallery-arrow').forEach((button) => button.remove());

      const buildLoopingGallery = () => {
        const loopVersion = '20260606-v36';
        const getFrames = () => Array.from(gallery.children)
          .filter((frame) => frame.matches('.gt-pdp__gallery-frame, .gt-pdp__gallery-img'));
        const getLoopMetrics = () => {
          const frames = getFrames();
          const originalCount = frames.filter((frame) => !frame.classList.contains('gt-pdp__gallery-clone')).length;
          const width = gallery.clientWidth || frames[0]?.clientWidth || 0;
          if (!width || originalCount < 2) return null;

          const lastIndex = frames.length - 1;
          const hasLeadingClone = frames[0]?.classList.contains('gt-pdp__gallery-clone');
          const hasTrailingClone = frames[lastIndex]?.classList.contains('gt-pdp__gallery-clone');
          return {
            width,
            lastIndex,
            firstOriginalIndex: hasLeadingClone ? 1 : 0,
            lastOriginalIndex: hasTrailingClone ? lastIndex - 1 : lastIndex,
            hasLeadingClone,
            hasTrailingClone
          };
        };
        const resetToFirstOriginal = () => {
          if (gallery.dataset.gtLoopUserInteracted === 'true') return;
          const metrics = getLoopMetrics();
          if (!metrics) return;
          gallery.scrollTo({ left: metrics.firstOriginalIndex * metrics.width, behavior: 'auto' });
        };

        if (gallery.dataset.gtLoopInteractionReady !== loopVersion) {
          gallery.dataset.gtLoopInteractionReady = loopVersion;
          ['touchstart', 'pointerdown', 'mousedown'].forEach((eventName) => {
            gallery.addEventListener(eventName, () => {
              gallery.dataset.gtLoopUserInteracted = 'true';
            }, { passive: true });
          });
        }

        if (gallery.dataset.gtMobileLoopReady !== loopVersion) {
          gallery.querySelectorAll('.gt-pdp__gallery-clone').forEach((clone) => clone.remove());

          const originals = Array.from(gallery.children)
            .filter((frame) => frame.matches('.gt-pdp__gallery-frame, .gt-pdp__gallery-img') && !frame.classList.contains('gt-pdp__gallery-clone'));

          if (originals.length > 1) {
            const firstClone = originals[0].cloneNode(true);
            const lastClone = originals[originals.length - 1].cloneNode(true);

            firstClone.classList.add('gt-pdp__gallery-clone');
            lastClone.classList.add('gt-pdp__gallery-clone');
            firstClone.setAttribute('aria-hidden', 'true');
            lastClone.setAttribute('aria-hidden', 'true');
            firstClone.dataset.gtClone = 'first';
            lastClone.dataset.gtClone = 'last';

            gallery.insertBefore(lastClone, originals[0]);
            gallery.appendChild(firstClone);
            gallery.dataset.gtMobileLoopReady = loopVersion;
            gallery.dataset.gtMobileFinalLoopReady = loopVersion;
            gallery.dataset.gtRouteLoopReady = loopVersion;
            requestAnimationFrame(resetToFirstOriginal);
            window.setTimeout(resetToFirstOriginal, 120);
            window.setTimeout(resetToFirstOriginal, 500);
          }
        }

        if (gallery.dataset.gtLoopScrollReady !== loopVersion) {
          gallery.dataset.gtLoopScrollReady = loopVersion;
          let loopTimer = null;
          gallery.addEventListener('scroll', () => {
            window.clearTimeout(loopTimer);
            loopTimer = window.setTimeout(() => {
              const metrics = getLoopMetrics();
              if (!metrics) return;

              const index = Math.round(gallery.scrollLeft / metrics.width);
              const userInteracted = gallery.dataset.gtLoopUserInteracted === 'true';
              if (metrics.hasLeadingClone && index <= 0) {
                gallery.scrollTo({
                  left: (userInteracted ? metrics.lastOriginalIndex : metrics.firstOriginalIndex) * metrics.width,
                  behavior: 'auto'
                });
              } else if (metrics.hasTrailingClone && index >= metrics.lastIndex) {
                gallery.scrollTo({ left: metrics.firstOriginalIndex * metrics.width, behavior: 'auto' });
              }
            }, 90);
          }, { passive: true });
        }
      };

      buildLoopingGallery();

      const repairMobileGalleryOrder = () => {
        if (!window.matchMedia('(max-width: 900px)').matches) return;

        const assetBase = Array.from(document.scripts)
          .map((script) => script.src || '')
          .find((src) => src.includes('/assets/global.js'))
          ?.replace(/global\.js.*$/, '') || '';
        const galleryItems = [
          {
            asset: 'garden-tunnel-gallery-01-cats-playing-20260524.png',
            alt: 'Two cats playing on and inside the Garden Tunnel Den'
          },
          {
            asset: 'garden-tunnel-gallery-02-product-angle-20260524.png',
            alt: 'Garden Tunnel Den product angle showing the green top and brown felt walls'
          },
          {
            asset: 'garden-tunnel-gallery-03-ragdoll-20260524.png',
            alt: 'Ragdoll cat sitting beside the Garden Tunnel Den'
          },
          {
            asset: 'garden-tunnel-gallery-04-product-front-20260524.png',
            alt: 'Garden Tunnel Den front view with rounded doorway and flower cutouts'
          }
        ];

        gallery.querySelectorAll('.gt-pdp__gallery-clone').forEach((clone) => clone.remove());

        let frames = Array.from(gallery.children)
          .filter((frame) => frame.matches('.gt-pdp__gallery-frame, .gt-pdp__gallery-img'));
        while (frames.length < galleryItems.length && frames[0]) {
          const frame = frames[0].cloneNode(true);
          gallery.appendChild(frame);
          frames.push(frame);
        }
        frames.slice(galleryItems.length).forEach((frame) => frame.remove());
        frames = frames.slice(0, galleryItems.length);

        frames.forEach((frame, index) => {
          const item = galleryItems[index];
          frame.classList.remove('gt-pdp__gallery-clone');
          frame.removeAttribute('aria-hidden');
          delete frame.dataset.gtClone;
          frame.querySelectorAll('video').forEach((video) => video.remove());
          let image = frame.querySelector('img');
          if (!image) {
            image = document.createElement('img');
            frame.appendChild(image);
          }
          image.className = `${image.className || ''} gt-pdp__image`.trim();
          image.removeAttribute('srcset');
          image.src = `${assetBase}${item.asset}`;
          image.alt = item.alt;
          image.loading = index === 0 ? 'eager' : 'lazy';
          if (index > 0) image.decoding = 'async';
          image.sizes = '(min-width: 1200px) 48vw, (min-width: 901px) 50vw, 100vw';
          image.width = 1254;
          image.height = 1254;
        });

        gallery.dataset.gtMobileLoopReady = '';
        gallery.dataset.gtMobileFinalLoopReady = '';
        gallery.dataset.gtRouteLoopReady = '';
        if (gallery.dataset.gtLoopUserInteracted !== 'true') {
          gallery.dataset.gtLoopUserInteracted = '';
        }
        buildLoopingGallery();
      };

      window.addEventListener('load', repairMobileGalleryOrder, { once: true });
      window.setTimeout(repairMobileGalleryOrder, 600);
      window.setTimeout(repairMobileGalleryOrder, 1600);

      const makeArrow = (modifier, label, text, direction) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `gt-pdp__gallery-arrow gt-pdp__gallery-arrow--${modifier}`;
        button.setAttribute('aria-label', label);
        button.textContent = text;
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          gallery.dataset.gtLoopUserInteracted = 'true';
          const width = gallery.clientWidth || 1;
          const currentIndex = Math.round(gallery.scrollLeft / width);
          gallery.scrollTo({
            left: (currentIndex + direction) * width,
            behavior: 'smooth'
          });
        });
        return button;
      };

      Array.from(gallery.children)
        .filter((frame) => frame.matches('.gt-pdp__gallery-frame, .gt-pdp__gallery-img'))
        .forEach((frame) => {
          frame.style.setProperty('position', 'relative', 'important');
          frame.appendChild(makeArrow('prev', 'Previous product image', '‹', -1));
          frame.appendChild(makeArrow('next', 'Next product image', '›', 1));
          frame.dataset.gtMobileArrowsReady = '20260604-v33';
        });
      heroGrid.dataset.gtMobileArrowsReady = '20260604-v33';
    }
  };

  const playUgcVideos = () => {
    section.querySelectorAll('.gt-pdp__ugc-video').forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'auto');
      if (video.readyState === 0) video.load();
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    });
  };

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      section.querySelectorAll('.gt-pdp__variant-btn').forEach((label) => {
        label.classList.toggle('is-selected', label.contains(input));
      });

      priceNodes.forEach((node) => {
        node.textContent = input.dataset.price;
      });

    });
  });

  section.querySelectorAll('.gt-pdp__variant-btn').forEach((label) => {
    if (label.dataset.gtVariantClickReady === 'true') return;
    label.dataset.gtVariantClickReady = 'true';

    label.addEventListener('click', (event) => {
      const input = label.querySelector('[data-gt-variant-input]');
      if (!input || input.disabled) return;

      event.preventDefault();
      event.stopPropagation();

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      section.querySelectorAll('.gt-pdp__variant-btn').forEach((option) => {
        option.classList.toggle('is-selected', option === label);
      });

      priceNodes.forEach((node) => {
        node.textContent = input.dataset.price;
      });
    }, true);
  });

  setAccordionDefaults();
  lockMobileGallery();
  playUgcVideos();
  requestAnimationFrame(lockMobileGallery);
  setTimeout(lockMobileGallery, 300);
  setTimeout(lockMobileGallery, 1200);
  setTimeout(lockMobileGallery, 3000);
  setTimeout(lockMobileGallery, 6000);
  setTimeout(playUgcVideos, 300);
  setTimeout(playUgcVideos, 1200);
  ensureRelatedProducts();
  scheduleJudgeMeWidget();
  enhanceJudgeMeReviewSurface();
  setTimeout(enhanceJudgeMeReviewSurface, 800);
  setTimeout(enhanceJudgeMeReviewSurface, 2000);
  setTimeout(enhanceJudgeMeReviewSurface, 5000);

  const judgeWidgetHost = section.querySelector('.gt-pdp__judge-widget');
  if (judgeWidgetHost && judgeWidgetHost.dataset.gtReviewEnhancerReady !== '20260604') {
    judgeWidgetHost.dataset.gtReviewEnhancerReady = '20260604';
    let judgeMeEnhanceTimer = null;
    new MutationObserver(() => {
      window.clearTimeout(judgeMeEnhanceTimer);
      judgeMeEnhanceTimer = window.setTimeout(enhanceJudgeMeReviewSurface, 80);
    }).observe(judgeWidgetHost, { childList: true, characterData: true, subtree: true });
  }

  if (recommendationsNode) {
    new MutationObserver(ensureRelatedProducts).observe(recommendationsNode, { childList: true });
  }

  if (stickyCta && heroCta) {
    new IntersectionObserver(updateStickyCta, { threshold: 0 }).observe(heroCta);
    window.addEventListener('resize', updateStickyCta, { passive: true });
    updateStickyCta();
  }

  if (productInfo && productInfoWrap && heroGrid) {
    resetProductInfoPin();
    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', resetProductInfoPin);
    }
  }

  window.addEventListener('resize', setAccordionDefaults, { passive: true });
  window.addEventListener('resize', lockMobileGallery, { passive: true });
  document.addEventListener('touchstart', playUgcVideos, { once: true, passive: true });
  document.addEventListener('click', playUgcVideos, { once: true });
  document.addEventListener('jdgm.finishLoadingCore', scheduleJudgeMeWidget, { once: true });
  document.addEventListener('jdgm.doneSetup', finalizeJudgeMeFallback);
}

document.querySelectorAll('.gt-pdp').forEach(initGardenTunnelPdp);
document.addEventListener('shopify:section:load', (event) => {
  initGardenTunnelPdp(event.target.querySelector('.gt-pdp'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-garden-tunnel-pdp-v5"] && !Shopify.designMode) return;
  try {
    
function injectGardenTunnelCompactRepair() {
  if (document.getElementById('gt-pdp-section-wildone-repair-20260523')) return;

  const style = document.createElement('style');
  style.id = 'gt-pdp-section-wildone-repair-20260523';
  style.textContent = `
    html body .shopify-section .gt-pdp .gt-pdp__hero { margin-top: 0 !important; padding: 0 40px 48px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__hero-grid { align-items: start !important; display: grid !important; gap: 20px !important; grid-template-columns: 1fr 1fr !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery { display: grid !important; gap: 8px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; min-height: 0 !important; overflow: visible !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 4 / 5 !important; height: auto !important; min-height: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { align-self: stretch !important; display: block !important; min-width: 0 !important; padding: 0 !important; position: relative !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { align-self: start !important; bottom: auto !important; left: auto !important; max-height: none !important; overflow: visible !important; padding: 10px 0 22px !important; position: sticky !important; top: calc(var(--header-height, 88px) + 10px) !important; width: auto !important; z-index: 30 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__breadcrumb, html body .shopify-section .gt-pdp .gt-pdp__eyebrow { align-items: center !important; background: #CCBCA8 !important; border-radius: 3px !important; color: #593518 !important; display: inline-flex !important; font-size: 10px !important; letter-spacing: 0.12em !important; line-height: 1.2 !important; margin: 0 0 10px !important; padding: 5px 12px !important; text-transform: uppercase !important; width: fit-content !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info h1 { font-family: Georgia, "Times New Roman", serif !important; font-size: 30px !important; font-weight: 400 !important; letter-spacing: 0 !important; line-height: 1.05 !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__title-meta-row { align-items: center !important; display: flex !important; flex-wrap: wrap !important; gap: 14px !important; justify-content: flex-start !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__lead-inline { color: rgba(89, 53, 24, 0.78) !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 14px !important; font-style: italic !important; line-height: 1.35 !important; margin: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__reviews-inline, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline * { font-size: 13px !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__price { font-family: Georgia, "Times New Roman", serif !important; font-size: 20px !important; line-height: 1 !important; margin: 0 0 22px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-label { color: rgba(89, 53, 24, 0.68) !important; display: block !important; font-size: 11px !important; letter-spacing: 0.16em !important; line-height: 1.2 !important; margin: 0 0 10px !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-options { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 0 !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn { align-items: center !important; display: flex !important; flex-direction: row !important; gap: 10px !important; justify-content: space-between !important; min-height: 46px !important; padding: 0 14px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn span, html body .shopify-section .gt-pdp .gt-pdp__variant-title { font-size: 14px !important; font-weight: 500 !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn small, html body .shopify-section .gt-pdp .gt-pdp__variant-size { color: rgba(89, 53, 24, 0.68) !important; font-size: 12px !important; line-height: 1.2 !important; margin: 0 !important; text-align: right !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 16px 0 30px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row > * { width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap { min-height: 72px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__button, html body .shopify-section .gt-pdp .shopify-payment-button__button { height: 48px !important; min-height: 48px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add { font-size: 13px !important; letter-spacing: 0.08em !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__more-options { display: block !important; font-size: 11px !important; line-height: 1.3 !important; margin: 10px auto 0 !important; text-align: center !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini { align-items: center !important; column-gap: 18px !important; display: grid !important; grid-template-columns: repeat(3, minmax(0, 1fr)) !important; margin: 0 !important; padding: 16px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item { align-items: center !important; display: grid !important; gap: 0 10px !important; grid-template-columns: 40px minmax(0, 1fr) !important; justify-content: flex-start !important; min-width: 0 !important; padding: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > svg, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > picture, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > img:not(.gt-pdp__trust-icon), html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::before, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::after { content: none !important; display: none !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-icon { display: block !important; flex: 0 0 40px !important; height: 40px !important; margin: 0 !important; object-fit: contain !important; width: 40px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-copy { display: block !important; min-width: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-title { display: block !important; font-size: 10.5px !important; letter-spacing: 0.1em !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-sub { font-size: 11px !important; line-height: 1.35 !important; overflow-wrap: normal !important; white-space: normal !important; word-break: normal !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-block { margin-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item:first-child { border-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item { padding: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item summary { font-size: 14px !important; font-weight: 500 !important; padding: 10px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features { clear: both !important; padding: 0 0 40px !important; position: relative !important; z-index: 1 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-heading { margin-left: auto !important; margin-right: auto !important; padding: 48px 0 32px !important; width: calc(100% - 80px) !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-grid { margin-left: auto !important; margin-right: auto !important; padding: 0 !important; width: calc(100% - 80px) !important; }
    @media (max-width: 900px) { html body .shopify-section .gt-pdp .gt-pdp__hero { padding: 0 0 32px !important; } html body .shopify-section .gt-pdp .gt-pdp__hero-grid { display: block !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery { grid-template-columns: 1fr !important; gap: 16px !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; } html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { max-height: none !important; overflow: visible !important; padding: 0 !important; position: relative !important; top: auto !important; } html body .shopify-section .gt-pdp .gt-pdp__features { padding: 0 0 40px !important; } html body .shopify-section .gt-pdp .gt-pdp__features-heading { padding: 32px 0 28px !important; width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__features-grid { width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini { grid-template-columns: 1fr !important; } }
    @media (max-width: 480px) { html body .shopify-section .gt-pdp .gt-pdp__buy-row, html body .shopify-section .gt-pdp .gt-pdp__variant-options { grid-template-columns: 1fr !important; } }
  `;
  document.head.appendChild(style);
}

function initGardenTunnelPdp(section) {
  if (!section || section.dataset.gtInitialized === '20260523-wildone-structure') return;
  section.dataset.gtInitialized = '20260523-wildone-structure';
  injectGardenTunnelCompactRepair();

  const variantInputs = Array.from(section.querySelectorAll('[data-gt-variant-input]'));
  const priceNodes = Array.from(section.querySelectorAll('[data-gt-price], [data-gt-sticky-price]'));
  const stickyCta = section.querySelector('.gt-pdp__sticky-cta');
  const heroCta = section.querySelector('.gt-pdp__cta-add');
  const recommendationsNode = section.querySelector('.gt-pdp__recommendations');
  const heroGrid = section.querySelector('.gt-pdp__hero-grid');
  const productInfoWrap = section.querySelector('.gt-pdp__product-info-wrap');
  const productInfo = section.querySelector('.gt-pdp__product-info');
  const desktopMedia = window.matchMedia('(min-width: 901px)');
  let relatedFallbackPromise = null;

  const setAccordionDefaults = () => {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    section.querySelectorAll('.gt-pdp__accordion-item').forEach((item) => {
      if (isMobile) {
        item.removeAttribute('open');
      } else if (!item.hasAttribute('data-keep-open')) {
        item.removeAttribute('open');
      }
    });
  };

  const getRelatedGrid = () => section.querySelector('.gt-pdp__related-grid');

  const formatRelatedMoney = (priceCents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        currency: window.Shopify?.currency?.active || 'USD',
        style: 'currency'
      }).format(priceCents / 100);
    } catch (error) {
      return `$${(priceCents / 100).toFixed(2)}`;
    }
  };

  const createRelatedCard = (productData) => {
    const variant = productData.variants?.[0] || {};
    const rawPrice = Number.parseFloat(variant.price || productData.price || '0');
    const priceCents = Math.round(rawPrice * 100);
    const imageData = productData.image || productData.images?.[0];
    const imageSrc = typeof imageData === 'string' ? imageData : imageData?.src;
    const imageAlt = (typeof imageData === 'object' && imageData?.alt) || productData.title || '';
    const card = document.createElement('a');
    const imageWrap = document.createElement('div');
    const title = document.createElement('p');
    const price = document.createElement('p');

    card.className = 'gt-pdp__related-card';
    card.href = `/products/${productData.handle}`;
    card.dataset.priceCents = String(priceCents);
    card.dataset.productHandle = productData.handle;
    card.dataset.relatedOrder = '99';

    imageWrap.className = 'gt-pdp__related-img';
    if (imageSrc) {
      const image = document.createElement('img');
      image.className = 'gt-pdp__image';
      image.loading = 'lazy';
      image.sizes = '(min-width: 901px) 25vw, 50vw';
      image.src = imageSrc;
      image.alt = imageAlt;
      imageWrap.appendChild(image);
    }

    title.className = 'gt-pdp__related-name';
    title.textContent = productData.title || '';

    price.className = 'gt-pdp__related-price';
    price.textContent = formatRelatedMoney(priceCents);

    card.append(imageWrap, title, price);
    return card;
  };

  const sortRelatedProducts = () => {
    const grid = getRelatedGrid();
    if (!grid) return [];

    const seenHandles = new Set([section.dataset.productHandle]);
    const cards = Array.from(grid.querySelectorAll('.gt-pdp__related-card')).filter((card) => {
      const handle = card.dataset.productHandle || card.getAttribute('href');
      if (!handle || seenHandles.has(handle)) {
        card.remove();
        return false;
      }
      seenHandles.add(handle);
      return true;
    });

    const sortedCards = cards.sort((a, b) => {
      const orderDiff = Number(a.dataset.relatedOrder ?? 99) - Number(b.dataset.relatedOrder ?? 99);
      if (orderDiff !== 0) return orderDiff;
      return Number(a.dataset.priceCents || 0) - Number(b.dataset.priceCents || 0);
    });
    sortedCards.forEach((card, index) => {
        if (grid.children[index] !== card) {
          grid.appendChild(card);
        }
        card.hidden = index >= 4;
      });

    return cards.filter((card) => !card.hidden);
  };

  const fillRelatedFallback = () => {
    const grid = getRelatedGrid();
    if (!grid || relatedFallbackPromise) return relatedFallbackPromise;

    const fallbackCollections = (recommendationsNode?.dataset.fallbackCollections || 'cat-furniture')
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean);

    relatedFallbackPromise = (async () => {
      for (const collectionHandle of fallbackCollections) {
        if (sortRelatedProducts().length >= 4) break;

        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=24`, {
          credentials: 'same-origin'
        });
        if (!response.ok) continue;

        const payload = await response.json();
        const products = Array.isArray(payload.products) ? payload.products : [];

        for (const productData of products) {
          const existingHandles = new Set(
            Array.from(grid.querySelectorAll('.gt-pdp__related-card'))
              .map((card) => card.dataset.productHandle || card.getAttribute('href'))
          );

          if (
            !productData.handle ||
            productData.handle === section.dataset.productHandle ||
            existingHandles.has(productData.handle)
          ) {
            continue;
          }

          grid.appendChild(createRelatedCard(productData));
          if (sortRelatedProducts().length >= 4) break;
        }
      }

      sortRelatedProducts();
    })().catch(() => {
      sortRelatedProducts();
    });

    return relatedFallbackPromise;
  };

  const ensureRelatedProducts = () => {
    if (sortRelatedProducts().length < 4) {
      fillRelatedFallback();
    }
  };

  const updateStickyCta = () => {
    if (!stickyCta || !heroCta) return;

    if (!desktopMedia.matches) {
      stickyCta.classList.add('is-visible');
      return;
    }

    const hasPassedHeroCta = heroCta.getBoundingClientRect().bottom <= 0;
    stickyCta.classList.toggle('is-visible', hasPassedHeroCta);
  };

  const resetProductInfoPin = () => {
    if (!productInfo || !productInfoWrap) return;

    productInfo.classList.remove('is-fixed', 'is-bottom');
    productInfo.style.left = '';
    productInfo.style.width = '';
    productInfo.style.removeProperty('--gt-product-info-max-height');
    productInfo.style.removeProperty('--gt-product-info-top');
    productInfoWrap.style.minHeight = '';
  };

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      section.querySelectorAll('.gt-pdp__variant-btn').forEach((label) => {
        label.classList.toggle('is-selected', label.contains(input));
      });

      priceNodes.forEach((node) => {
        node.textContent = input.dataset.price;
      });

    });
  });

  setAccordionDefaults();
  ensureRelatedProducts();

  if (recommendationsNode) {
    new MutationObserver(ensureRelatedProducts).observe(recommendationsNode, { childList: true });
  }

  if (stickyCta && heroCta) {
    new IntersectionObserver(updateStickyCta, { threshold: 0 }).observe(heroCta);
    window.addEventListener('resize', updateStickyCta, { passive: true });
    updateStickyCta();
  }

  if (productInfo && productInfoWrap && heroGrid) {
    resetProductInfoPin();
    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', resetProductInfoPin);
    }
  }

  window.addEventListener('resize', setAccordionDefaults, { passive: true });
}

document.querySelectorAll('.gt-pdp').forEach(initGardenTunnelPdp);
document.addEventListener('shopify:section:load', (event) => {
  initGardenTunnelPdp(event.target.querySelector('.gt-pdp'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-garden-tunnel-pdp-v6"] && !Shopify.designMode) return;
  try {
    
function injectGardenTunnelCompactRepair() {
  if (document.getElementById('gt-pdp-section-wildone-repair-20260523')) return;

  const style = document.createElement('style');
  style.id = 'gt-pdp-section-wildone-repair-20260523';
  style.textContent = `
    html body .shopify-section .gt-pdp .gt-pdp__hero { margin-top: 0 !important; padding: 0 40px 48px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__hero-grid { align-items: start !important; display: grid !important; gap: 20px !important; grid-template-columns: 1fr 1fr !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery { display: grid !important; gap: 8px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; min-height: 0 !important; overflow: visible !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 4 / 5 !important; height: auto !important; min-height: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { align-self: stretch !important; display: block !important; min-width: 0 !important; padding: 0 !important; position: relative !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { align-self: start !important; bottom: auto !important; left: auto !important; max-height: none !important; overflow: visible !important; padding: 10px 0 22px !important; position: sticky !important; top: calc(var(--header-height, 88px) + 10px) !important; width: auto !important; z-index: 30 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__breadcrumb, html body .shopify-section .gt-pdp .gt-pdp__eyebrow { align-items: center !important; background: #CCBCA8 !important; border-radius: 3px !important; color: #593518 !important; display: inline-flex !important; font-size: 10px !important; letter-spacing: 0.12em !important; line-height: 1.2 !important; margin: 0 0 10px !important; padding: 5px 12px !important; text-transform: uppercase !important; width: fit-content !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info h1 { font-family: Georgia, "Times New Roman", serif !important; font-size: 30px !important; font-weight: 400 !important; letter-spacing: 0 !important; line-height: 1.05 !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__title-meta-row { align-items: center !important; display: flex !important; flex-wrap: wrap !important; gap: 14px !important; justify-content: flex-start !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__lead-inline { color: rgba(89, 53, 24, 0.78) !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 14px !important; font-style: italic !important; line-height: 1.35 !important; margin: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__reviews-inline, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline * { font-size: 13px !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__price { font-family: Georgia, "Times New Roman", serif !important; font-size: 20px !important; line-height: 1 !important; margin: 0 0 22px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-label { color: rgba(89, 53, 24, 0.68) !important; display: block !important; font-size: 11px !important; letter-spacing: 0.16em !important; line-height: 1.2 !important; margin: 0 0 10px !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-options { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 0 !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn { align-items: center !important; display: flex !important; flex-direction: row !important; gap: 10px !important; justify-content: space-between !important; min-height: 46px !important; padding: 0 14px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn span, html body .shopify-section .gt-pdp .gt-pdp__variant-title { font-size: 14px !important; font-weight: 500 !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn small, html body .shopify-section .gt-pdp .gt-pdp__variant-size { color: rgba(89, 53, 24, 0.68) !important; font-size: 12px !important; line-height: 1.2 !important; margin: 0 !important; text-align: right !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 16px 0 30px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row > * { width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap { min-height: 72px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__button, html body .shopify-section .gt-pdp .shopify-payment-button__button { height: 48px !important; min-height: 48px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add { font-size: 13px !important; letter-spacing: 0.08em !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__more-options { display: block !important; font-size: 11px !important; line-height: 1.3 !important; margin: 10px auto 0 !important; text-align: center !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini { align-items: center !important; column-gap: 18px !important; display: grid !important; grid-template-columns: repeat(3, minmax(0, 1fr)) !important; margin: 0 !important; padding: 16px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item { align-items: center !important; display: grid !important; gap: 0 10px !important; grid-template-columns: 40px minmax(0, 1fr) !important; justify-content: flex-start !important; min-width: 0 !important; padding: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > svg, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > picture, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > img:not(.gt-pdp__trust-icon), html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::before, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::after { content: none !important; display: none !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-icon { display: block !important; flex: 0 0 40px !important; height: 40px !important; margin: 0 !important; object-fit: contain !important; width: 40px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-copy { display: block !important; min-width: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-title { display: block !important; font-size: 10.5px !important; letter-spacing: 0.1em !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-sub { font-size: 11px !important; line-height: 1.35 !important; overflow-wrap: normal !important; white-space: normal !important; word-break: normal !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-block { margin-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item:first-child { border-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item { padding: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item summary { font-size: 14px !important; font-weight: 500 !important; padding: 10px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features { clear: both !important; padding: 0 0 40px !important; position: relative !important; z-index: 1 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-heading { margin-left: auto !important; margin-right: auto !important; padding: 48px 0 32px !important; width: calc(100% - 80px) !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-grid { margin-left: auto !important; margin-right: auto !important; padding: 0 !important; width: calc(100% - 80px) !important; }
    @media (max-width: 900px) { html body .shopify-section .gt-pdp .gt-pdp__hero { padding: 0 0 32px !important; } html body .shopify-section .gt-pdp .gt-pdp__hero-grid { display: block !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery { grid-template-columns: 1fr !important; gap: 16px !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; } html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { max-height: none !important; overflow: visible !important; padding: 0 !important; position: relative !important; top: auto !important; } html body .shopify-section .gt-pdp .gt-pdp__features { padding: 0 0 40px !important; } html body .shopify-section .gt-pdp .gt-pdp__features-heading { padding: 32px 0 28px !important; width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__features-grid { width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini { grid-template-columns: 1fr !important; } }
    @media (max-width: 480px) { html body .shopify-section .gt-pdp .gt-pdp__buy-row, html body .shopify-section .gt-pdp .gt-pdp__variant-options { grid-template-columns: 1fr !important; } }
  `;
  document.head.appendChild(style);
}

function initGardenTunnelPdp(section) {
  if (!section || section.dataset.gtInitialized === '20260523-wildone-structure') return;
  section.dataset.gtInitialized = '20260523-wildone-structure';
  injectGardenTunnelCompactRepair();

  const variantInputs = Array.from(section.querySelectorAll('[data-gt-variant-input]'));
  const priceNodes = Array.from(section.querySelectorAll('[data-gt-price], [data-gt-sticky-price]'));
  const stickyCta = section.querySelector('.gt-pdp__sticky-cta');
  const heroCta = section.querySelector('.gt-pdp__cta-add');
  const recommendationsNode = section.querySelector('.gt-pdp__recommendations');
  const heroGrid = section.querySelector('.gt-pdp__hero-grid');
  const productInfoWrap = section.querySelector('.gt-pdp__product-info-wrap');
  const productInfo = section.querySelector('.gt-pdp__product-info');
  const desktopMedia = window.matchMedia('(min-width: 901px)');
  let relatedFallbackPromise = null;

  const setAccordionDefaults = () => {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    section.querySelectorAll('.gt-pdp__accordion-item').forEach((item) => {
      if (isMobile) {
        item.removeAttribute('open');
      } else if (!item.hasAttribute('data-keep-open')) {
        item.removeAttribute('open');
      }
    });
  };

  const getRelatedGrid = () => section.querySelector('.gt-pdp__related-grid');

  const formatRelatedMoney = (priceCents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        currency: window.Shopify?.currency?.active || 'USD',
        style: 'currency'
      }).format(priceCents / 100);
    } catch (error) {
      return `$${(priceCents / 100).toFixed(2)}`;
    }
  };

  const createRelatedCard = (productData) => {
    const variant = productData.variants?.[0] || {};
    const rawPrice = Number.parseFloat(variant.price || productData.price || '0');
    const priceCents = Math.round(rawPrice * 100);
    const imageData = productData.image || productData.images?.[0];
    const imageSrc = typeof imageData === 'string' ? imageData : imageData?.src;
    const imageAlt = (typeof imageData === 'object' && imageData?.alt) || productData.title || '';
    const card = document.createElement('a');
    const imageWrap = document.createElement('div');
    const title = document.createElement('p');
    const price = document.createElement('p');

    card.className = 'gt-pdp__related-card';
    card.href = `/products/${productData.handle}`;
    card.dataset.priceCents = String(priceCents);
    card.dataset.productHandle = productData.handle;
    card.dataset.relatedOrder = '99';

    imageWrap.className = 'gt-pdp__related-img';
    if (imageSrc) {
      const image = document.createElement('img');
      image.className = 'gt-pdp__image';
      image.loading = 'lazy';
      image.sizes = '(min-width: 901px) 25vw, 50vw';
      image.src = imageSrc;
      image.alt = imageAlt;
      imageWrap.appendChild(image);
    }

    title.className = 'gt-pdp__related-name';
    title.textContent = productData.title || '';

    price.className = 'gt-pdp__related-price';
    price.textContent = formatRelatedMoney(priceCents);

    card.append(imageWrap, title, price);
    return card;
  };

  const sortRelatedProducts = () => {
    const grid = getRelatedGrid();
    if (!grid) return [];

    const seenHandles = new Set([section.dataset.productHandle]);
    const cards = Array.from(grid.querySelectorAll('.gt-pdp__related-card')).filter((card) => {
      const handle = card.dataset.productHandle || card.getAttribute('href');
      if (!handle || seenHandles.has(handle)) {
        card.remove();
        return false;
      }
      seenHandles.add(handle);
      return true;
    });

    const sortedCards = cards.sort((a, b) => {
      const orderDiff = Number(a.dataset.relatedOrder ?? 99) - Number(b.dataset.relatedOrder ?? 99);
      if (orderDiff !== 0) return orderDiff;
      return Number(a.dataset.priceCents || 0) - Number(b.dataset.priceCents || 0);
    });
    sortedCards.forEach((card, index) => {
        if (grid.children[index] !== card) {
          grid.appendChild(card);
        }
        card.hidden = index >= 4;
      });

    return cards.filter((card) => !card.hidden);
  };

  const fillRelatedFallback = () => {
    const grid = getRelatedGrid();
    if (!grid || relatedFallbackPromise) return relatedFallbackPromise;

    const fallbackCollections = (recommendationsNode?.dataset.fallbackCollections || 'cat-furniture')
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean);

    relatedFallbackPromise = (async () => {
      for (const collectionHandle of fallbackCollections) {
        if (sortRelatedProducts().length >= 4) break;

        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=24`, {
          credentials: 'same-origin'
        });
        if (!response.ok) continue;

        const payload = await response.json();
        const products = Array.isArray(payload.products) ? payload.products : [];

        for (const productData of products) {
          const existingHandles = new Set(
            Array.from(grid.querySelectorAll('.gt-pdp__related-card'))
              .map((card) => card.dataset.productHandle || card.getAttribute('href'))
          );

          if (
            !productData.handle ||
            productData.handle === section.dataset.productHandle ||
            existingHandles.has(productData.handle)
          ) {
            continue;
          }

          grid.appendChild(createRelatedCard(productData));
          if (sortRelatedProducts().length >= 4) break;
        }
      }

      sortRelatedProducts();
    })().catch(() => {
      sortRelatedProducts();
    });

    return relatedFallbackPromise;
  };

  const ensureRelatedProducts = () => {
    if (sortRelatedProducts().length < 4) {
      fillRelatedFallback();
    }
  };

  const updateStickyCta = () => {
    if (!stickyCta || !heroCta) return;

    if (!desktopMedia.matches) {
      stickyCta.classList.add('is-visible');
      return;
    }

    const hasPassedHeroCta = heroCta.getBoundingClientRect().bottom <= 0;
    stickyCta.classList.toggle('is-visible', hasPassedHeroCta);
  };

  const resetProductInfoPin = () => {
    if (!productInfo || !productInfoWrap) return;

    productInfo.classList.remove('is-fixed', 'is-bottom');
    productInfo.style.left = '';
    productInfo.style.width = '';
    productInfo.style.removeProperty('--gt-product-info-max-height');
    productInfo.style.removeProperty('--gt-product-info-top');
    productInfoWrap.style.minHeight = '';
  };

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      section.querySelectorAll('.gt-pdp__variant-btn').forEach((label) => {
        label.classList.toggle('is-selected', label.contains(input));
      });

      priceNodes.forEach((node) => {
        node.textContent = input.dataset.price;
      });

    });
  });

  setAccordionDefaults();
  ensureRelatedProducts();

  if (recommendationsNode) {
    new MutationObserver(ensureRelatedProducts).observe(recommendationsNode, { childList: true });
  }

  if (stickyCta && heroCta) {
    new IntersectionObserver(updateStickyCta, { threshold: 0 }).observe(heroCta);
    window.addEventListener('resize', updateStickyCta, { passive: true });
    updateStickyCta();
  }

  if (productInfo && productInfoWrap && heroGrid) {
    resetProductInfoPin();
    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', resetProductInfoPin);
    }
  }

  window.addEventListener('resize', setAccordionDefaults, { passive: true });
}

document.querySelectorAll('.gt-pdp').forEach(initGardenTunnelPdp);
document.addEventListener('shopify:section:load', (event) => {
  initGardenTunnelPdp(event.target.querySelector('.gt-pdp'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-garden-tunnel-pdp-v8"] && !Shopify.designMode) return;
  try {
    
function injectGardenTunnelCompactRepair() {
  if (document.getElementById('gt-pdp-section-wildone-repair-20260523')) return;

  const style = document.createElement('style');
  style.id = 'gt-pdp-section-wildone-repair-20260523';
  style.textContent = `
    html body .shopify-section .gt-pdp .gt-pdp__hero { margin-top: 0 !important; padding: 0 40px 48px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__hero-grid { align-items: start !important; display: grid !important; gap: 20px !important; grid-template-columns: 1fr 1fr !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery { display: grid !important; gap: 8px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; min-height: 0 !important; overflow: visible !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 4 / 5 !important; height: auto !important; min-height: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { align-self: stretch !important; display: block !important; min-width: 0 !important; padding: 0 !important; position: relative !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { align-self: start !important; bottom: auto !important; left: auto !important; max-height: none !important; overflow: visible !important; padding: 10px 0 22px !important; position: sticky !important; top: calc(var(--header-height, 88px) + 10px) !important; width: auto !important; z-index: 30 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__breadcrumb, html body .shopify-section .gt-pdp .gt-pdp__eyebrow { align-items: center !important; background: #CCBCA8 !important; border-radius: 3px !important; color: #593518 !important; display: inline-flex !important; font-size: 10px !important; letter-spacing: 0.12em !important; line-height: 1.2 !important; margin: 0 0 10px !important; padding: 5px 12px !important; text-transform: uppercase !important; width: fit-content !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info h1 { font-family: Georgia, "Times New Roman", serif !important; font-size: 30px !important; font-weight: 400 !important; letter-spacing: 0 !important; line-height: 1.05 !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__title-meta-row { align-items: center !important; display: flex !important; flex-wrap: wrap !important; gap: 14px !important; justify-content: flex-start !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__lead-inline { color: rgba(89, 53, 24, 0.78) !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 14px !important; font-style: italic !important; line-height: 1.35 !important; margin: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__reviews-inline, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline * { font-size: 13px !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__price { font-family: Georgia, "Times New Roman", serif !important; font-size: 20px !important; line-height: 1 !important; margin: 0 0 22px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-label { color: rgba(89, 53, 24, 0.68) !important; display: block !important; font-size: 11px !important; letter-spacing: 0.16em !important; line-height: 1.2 !important; margin: 0 0 10px !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-options { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 0 !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn { align-items: center !important; display: flex !important; flex-direction: row !important; gap: 10px !important; justify-content: space-between !important; min-height: 46px !important; padding: 0 14px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn span, html body .shopify-section .gt-pdp .gt-pdp__variant-title { font-size: 14px !important; font-weight: 500 !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn small, html body .shopify-section .gt-pdp .gt-pdp__variant-size { color: rgba(89, 53, 24, 0.68) !important; font-size: 12px !important; line-height: 1.2 !important; margin: 0 !important; text-align: right !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 16px 0 30px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row > * { width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap { min-height: 72px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__button, html body .shopify-section .gt-pdp .shopify-payment-button__button { height: 48px !important; min-height: 48px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add { font-size: 13px !important; letter-spacing: 0.08em !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__more-options { display: block !important; font-size: 11px !important; line-height: 1.3 !important; margin: 10px auto 0 !important; text-align: center !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini { align-items: center !important; column-gap: 18px !important; display: grid !important; grid-template-columns: repeat(3, minmax(0, 1fr)) !important; margin: 0 !important; padding: 16px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item { align-items: center !important; display: grid !important; gap: 0 10px !important; grid-template-columns: 40px minmax(0, 1fr) !important; justify-content: flex-start !important; min-width: 0 !important; padding: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > svg, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > picture, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > img:not(.gt-pdp__trust-icon), html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::before, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::after { content: none !important; display: none !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-icon { display: block !important; flex: 0 0 40px !important; height: 40px !important; margin: 0 !important; object-fit: contain !important; width: 40px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-copy { display: block !important; min-width: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-title { display: block !important; font-size: 10.5px !important; letter-spacing: 0.1em !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-sub { font-size: 11px !important; line-height: 1.35 !important; overflow-wrap: normal !important; white-space: normal !important; word-break: normal !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-block { margin-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item:first-child { border-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item { padding: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item summary { font-size: 14px !important; font-weight: 500 !important; padding: 10px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features { clear: both !important; padding: 0 0 40px !important; position: relative !important; z-index: 1 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-heading { margin-left: auto !important; margin-right: auto !important; padding: 48px 0 32px !important; width: calc(100% - 80px) !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-grid { margin-left: auto !important; margin-right: auto !important; padding: 0 !important; width: calc(100% - 80px) !important; }
    @media (max-width: 900px) { html body .shopify-section .gt-pdp .gt-pdp__hero { padding: 0 0 32px !important; } html body .shopify-section .gt-pdp .gt-pdp__hero-grid { display: block !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery { grid-template-columns: 1fr !important; gap: 16px !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; } html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { max-height: none !important; overflow: visible !important; padding: 0 !important; position: relative !important; top: auto !important; } html body .shopify-section .gt-pdp .gt-pdp__features { padding: 0 0 40px !important; } html body .shopify-section .gt-pdp .gt-pdp__features-heading { padding: 32px 0 28px !important; width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__features-grid { width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini { grid-template-columns: 1fr !important; } }
    @media (max-width: 480px) { html body .shopify-section .gt-pdp .gt-pdp__buy-row, html body .shopify-section .gt-pdp .gt-pdp__variant-options { grid-template-columns: 1fr !important; } }
  `;
  document.head.appendChild(style);
}

function initGardenTunnelPdp(section) {
  if (!section || section.dataset.gtInitialized === '20260523-wildone-structure') return;
  section.dataset.gtInitialized = '20260523-wildone-structure';
  injectGardenTunnelCompactRepair();

  const variantInputs = Array.from(section.querySelectorAll('[data-gt-variant-input]'));
  const priceNodes = Array.from(section.querySelectorAll('[data-gt-price], [data-gt-sticky-price]'));
  const stickyCta = section.querySelector('.gt-pdp__sticky-cta');
  const heroCta = section.querySelector('.gt-pdp__cta-add');
  const recommendationsNode = section.querySelector('.gt-pdp__recommendations');
  const heroGrid = section.querySelector('.gt-pdp__hero-grid');
  const productInfoWrap = section.querySelector('.gt-pdp__product-info-wrap');
  const productInfo = section.querySelector('.gt-pdp__product-info');
  const desktopMedia = window.matchMedia('(min-width: 901px)');
  let relatedFallbackPromise = null;

  const setAccordionDefaults = () => {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    section.querySelectorAll('.gt-pdp__accordion-item').forEach((item) => {
      if (isMobile) {
        item.removeAttribute('open');
      } else if (!item.hasAttribute('data-keep-open')) {
        item.removeAttribute('open');
      }
    });
  };

  const getRelatedGrid = () => section.querySelector('.gt-pdp__related-grid');

  const formatRelatedMoney = (priceCents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        currency: window.Shopify?.currency?.active || 'USD',
        style: 'currency'
      }).format(priceCents / 100);
    } catch (error) {
      return `$${(priceCents / 100).toFixed(2)}`;
    }
  };

  const createRelatedCard = (productData) => {
    const variant = productData.variants?.[0] || {};
    const rawPrice = Number.parseFloat(variant.price || productData.price || '0');
    const priceCents = Math.round(rawPrice * 100);
    const imageData = productData.image || productData.images?.[0];
    const imageSrc = typeof imageData === 'string' ? imageData : imageData?.src;
    const imageAlt = (typeof imageData === 'object' && imageData?.alt) || productData.title || '';
    const card = document.createElement('a');
    const imageWrap = document.createElement('div');
    const title = document.createElement('p');
    const price = document.createElement('p');

    card.className = 'gt-pdp__related-card';
    card.href = `/products/${productData.handle}`;
    card.dataset.priceCents = String(priceCents);
    card.dataset.productHandle = productData.handle;
    card.dataset.relatedOrder = '99';

    imageWrap.className = 'gt-pdp__related-img';
    if (imageSrc) {
      const image = document.createElement('img');
      image.className = 'gt-pdp__image';
      image.loading = 'lazy';
      image.sizes = '(min-width: 901px) 25vw, 50vw';
      image.src = imageSrc;
      image.alt = imageAlt;
      imageWrap.appendChild(image);
    }

    title.className = 'gt-pdp__related-name';
    title.textContent = productData.title || '';

    price.className = 'gt-pdp__related-price';
    price.textContent = formatRelatedMoney(priceCents);

    card.append(imageWrap, title, price);
    return card;
  };

  const sortRelatedProducts = () => {
    const grid = getRelatedGrid();
    if (!grid) return [];

    const seenHandles = new Set([section.dataset.productHandle]);
    const cards = Array.from(grid.querySelectorAll('.gt-pdp__related-card')).filter((card) => {
      const handle = card.dataset.productHandle || card.getAttribute('href');
      if (!handle || seenHandles.has(handle)) {
        card.remove();
        return false;
      }
      seenHandles.add(handle);
      return true;
    });

    const sortedCards = cards.sort((a, b) => {
      const orderDiff = Number(a.dataset.relatedOrder ?? 99) - Number(b.dataset.relatedOrder ?? 99);
      if (orderDiff !== 0) return orderDiff;
      return Number(a.dataset.priceCents || 0) - Number(b.dataset.priceCents || 0);
    });
    sortedCards.forEach((card, index) => {
        if (grid.children[index] !== card) {
          grid.appendChild(card);
        }
        card.hidden = index >= 4;
      });

    return cards.filter((card) => !card.hidden);
  };

  const fillRelatedFallback = () => {
    const grid = getRelatedGrid();
    if (!grid || relatedFallbackPromise) return relatedFallbackPromise;

    const fallbackCollections = (recommendationsNode?.dataset.fallbackCollections || 'cat-furniture')
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean);

    relatedFallbackPromise = (async () => {
      for (const collectionHandle of fallbackCollections) {
        if (sortRelatedProducts().length >= 4) break;

        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=24`, {
          credentials: 'same-origin'
        });
        if (!response.ok) continue;

        const payload = await response.json();
        const products = Array.isArray(payload.products) ? payload.products : [];

        for (const productData of products) {
          const existingHandles = new Set(
            Array.from(grid.querySelectorAll('.gt-pdp__related-card'))
              .map((card) => card.dataset.productHandle || card.getAttribute('href'))
          );

          if (
            !productData.handle ||
            productData.handle === section.dataset.productHandle ||
            existingHandles.has(productData.handle)
          ) {
            continue;
          }

          grid.appendChild(createRelatedCard(productData));
          if (sortRelatedProducts().length >= 4) break;
        }
      }

      sortRelatedProducts();
    })().catch(() => {
      sortRelatedProducts();
    });

    return relatedFallbackPromise;
  };

  const ensureRelatedProducts = () => {
    if (sortRelatedProducts().length < 4) {
      fillRelatedFallback();
    }
  };

  const updateStickyCta = () => {
    if (!stickyCta || !heroCta) return;

    if (!desktopMedia.matches) {
      stickyCta.classList.add('is-visible');
      return;
    }

    const hasPassedHeroCta = heroCta.getBoundingClientRect().bottom <= 0;
    stickyCta.classList.toggle('is-visible', hasPassedHeroCta);
  };

  const resetProductInfoPin = () => {
    if (!productInfo || !productInfoWrap) return;

    productInfo.classList.remove('is-fixed', 'is-bottom');
    productInfo.style.left = '';
    productInfo.style.width = '';
    productInfo.style.removeProperty('--gt-product-info-max-height');
    productInfo.style.removeProperty('--gt-product-info-top');
    productInfoWrap.style.minHeight = '';
  };

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      section.querySelectorAll('.gt-pdp__variant-btn').forEach((label) => {
        label.classList.toggle('is-selected', label.contains(input));
      });

      priceNodes.forEach((node) => {
        node.textContent = input.dataset.price;
      });

    });
  });

  setAccordionDefaults();
  ensureRelatedProducts();

  if (recommendationsNode) {
    new MutationObserver(ensureRelatedProducts).observe(recommendationsNode, { childList: true });
  }

  if (stickyCta && heroCta) {
    new IntersectionObserver(updateStickyCta, { threshold: 0 }).observe(heroCta);
    window.addEventListener('resize', updateStickyCta, { passive: true });
    updateStickyCta();
  }

  if (productInfo && productInfoWrap && heroGrid) {
    resetProductInfoPin();
    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', resetProductInfoPin);
    }
  }

  window.addEventListener('resize', setAccordionDefaults, { passive: true });
}

document.querySelectorAll('.gt-pdp').forEach(initGardenTunnelPdp);
document.addEventListener('shopify:section:load', (event) => {
  initGardenTunnelPdp(event.target.querySelector('.gt-pdp'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-garden-tunnel-pdp-v9"] && !Shopify.designMode) return;
  try {
    
function injectGardenTunnelCompactRepair() {
  if (document.getElementById('gt-pdp-section-wildone-repair-20260523')) return;

  const style = document.createElement('style');
  style.id = 'gt-pdp-section-wildone-repair-20260523';
  style.textContent = `
    html body .shopify-section .gt-pdp .gt-pdp__hero { margin-top: 0 !important; padding: 0 40px 48px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__hero-grid { align-items: start !important; display: grid !important; gap: 20px !important; grid-template-columns: 1fr 1fr !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery { display: grid !important; gap: 8px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; min-height: 0 !important; overflow: visible !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 4 / 5 !important; height: auto !important; min-height: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { align-self: stretch !important; display: block !important; min-width: 0 !important; padding: 0 !important; position: relative !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { align-self: start !important; bottom: auto !important; left: auto !important; max-height: none !important; overflow: visible !important; padding: 10px 0 22px !important; position: sticky !important; top: calc(var(--header-height, 88px) + 10px) !important; width: auto !important; z-index: 30 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__breadcrumb, html body .shopify-section .gt-pdp .gt-pdp__eyebrow { align-items: center !important; background: #CCBCA8 !important; border-radius: 3px !important; color: #593518 !important; display: inline-flex !important; font-size: 10px !important; letter-spacing: 0.12em !important; line-height: 1.2 !important; margin: 0 0 10px !important; padding: 5px 12px !important; text-transform: uppercase !important; width: fit-content !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info h1 { font-family: Georgia, "Times New Roman", serif !important; font-size: 30px !important; font-weight: 400 !important; letter-spacing: 0 !important; line-height: 1.05 !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__title-meta-row { align-items: center !important; display: flex !important; flex-wrap: wrap !important; gap: 14px !important; justify-content: flex-start !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__lead-inline { color: rgba(89, 53, 24, 0.78) !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 14px !important; font-style: italic !important; line-height: 1.35 !important; margin: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__reviews-inline, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline * { font-size: 13px !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__price { font-family: Georgia, "Times New Roman", serif !important; font-size: 20px !important; line-height: 1 !important; margin: 0 0 22px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-label { color: rgba(89, 53, 24, 0.68) !important; display: block !important; font-size: 11px !important; letter-spacing: 0.16em !important; line-height: 1.2 !important; margin: 0 0 10px !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-options { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 0 !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn { align-items: center !important; display: flex !important; flex-direction: row !important; gap: 10px !important; justify-content: space-between !important; min-height: 46px !important; padding: 0 14px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn span, html body .shopify-section .gt-pdp .gt-pdp__variant-title { font-size: 14px !important; font-weight: 500 !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn small, html body .shopify-section .gt-pdp .gt-pdp__variant-size { color: rgba(89, 53, 24, 0.68) !important; font-size: 12px !important; line-height: 1.2 !important; margin: 0 !important; text-align: right !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 16px 0 30px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row > * { width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap { min-height: 72px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__button, html body .shopify-section .gt-pdp .shopify-payment-button__button { height: 48px !important; min-height: 48px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add { font-size: 13px !important; letter-spacing: 0.08em !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__more-options { display: block !important; font-size: 11px !important; line-height: 1.3 !important; margin: 10px auto 0 !important; text-align: center !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini { align-items: center !important; column-gap: 18px !important; display: grid !important; grid-template-columns: repeat(3, minmax(0, 1fr)) !important; margin: 0 !important; padding: 16px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item { align-items: center !important; display: grid !important; gap: 0 10px !important; grid-template-columns: 40px minmax(0, 1fr) !important; justify-content: flex-start !important; min-width: 0 !important; padding: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > svg, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > picture, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > img:not(.gt-pdp__trust-icon), html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::before, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::after { content: none !important; display: none !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-icon { display: block !important; flex: 0 0 40px !important; height: 40px !important; margin: 0 !important; object-fit: contain !important; width: 40px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-copy { display: block !important; min-width: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-title { display: block !important; font-size: 10.5px !important; letter-spacing: 0.1em !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-sub { font-size: 11px !important; line-height: 1.35 !important; overflow-wrap: normal !important; white-space: normal !important; word-break: normal !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-block { margin-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item:first-child { border-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item { padding: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item summary { font-size: 14px !important; font-weight: 500 !important; padding: 10px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features { clear: both !important; padding: 0 0 40px !important; position: relative !important; z-index: 1 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-heading { margin-left: auto !important; margin-right: auto !important; padding: 48px 0 32px !important; width: calc(100% - 80px) !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-grid { margin-left: auto !important; margin-right: auto !important; padding: 0 !important; width: calc(100% - 80px) !important; }
    @media (max-width: 900px) { html body .shopify-section .gt-pdp .gt-pdp__hero { padding: 0 0 32px !important; } html body .shopify-section .gt-pdp .gt-pdp__hero-grid { display: block !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery { grid-template-columns: 1fr !important; gap: 16px !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; } html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { max-height: none !important; overflow: visible !important; padding: 0 !important; position: relative !important; top: auto !important; } html body .shopify-section .gt-pdp .gt-pdp__features { padding: 0 0 40px !important; } html body .shopify-section .gt-pdp .gt-pdp__features-heading { padding: 32px 0 28px !important; width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__features-grid { width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini { grid-template-columns: 1fr !important; } }
    @media (max-width: 480px) { html body .shopify-section .gt-pdp .gt-pdp__buy-row, html body .shopify-section .gt-pdp .gt-pdp__variant-options { grid-template-columns: 1fr !important; } }
  `;
  document.head.appendChild(style);
}

function initGardenTunnelPdp(section) {
  if (!section || section.dataset.gtInitialized === '20260523-wildone-structure') return;
  section.dataset.gtInitialized = '20260523-wildone-structure';
  injectGardenTunnelCompactRepair();

  const variantInputs = Array.from(section.querySelectorAll('[data-gt-variant-input]'));
  const priceNodes = Array.from(section.querySelectorAll('[data-gt-price], [data-gt-sticky-price]'));
  const stickyCta = section.querySelector('.gt-pdp__sticky-cta');
  const heroCta = section.querySelector('.gt-pdp__cta-add');
  const recommendationsNode = section.querySelector('.gt-pdp__recommendations');
  const heroGrid = section.querySelector('.gt-pdp__hero-grid');
  const productInfoWrap = section.querySelector('.gt-pdp__product-info-wrap');
  const productInfo = section.querySelector('.gt-pdp__product-info');
  const desktopMedia = window.matchMedia('(min-width: 901px)');
  let relatedFallbackPromise = null;

  const setAccordionDefaults = () => {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    section.querySelectorAll('.gt-pdp__accordion-item').forEach((item) => {
      if (isMobile) {
        item.removeAttribute('open');
      } else if (!item.hasAttribute('data-keep-open')) {
        item.removeAttribute('open');
      }
    });
  };

  const getRelatedGrid = () => section.querySelector('.gt-pdp__related-grid');

  const formatRelatedMoney = (priceCents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        currency: window.Shopify?.currency?.active || 'USD',
        style: 'currency'
      }).format(priceCents / 100);
    } catch (error) {
      return `$${(priceCents / 100).toFixed(2)}`;
    }
  };

  const createRelatedCard = (productData) => {
    const variant = productData.variants?.[0] || {};
    const rawPrice = Number.parseFloat(variant.price || productData.price || '0');
    const priceCents = Math.round(rawPrice * 100);
    const imageData = productData.image || productData.images?.[0];
    const imageSrc = typeof imageData === 'string' ? imageData : imageData?.src;
    const imageAlt = (typeof imageData === 'object' && imageData?.alt) || productData.title || '';
    const card = document.createElement('a');
    const imageWrap = document.createElement('div');
    const title = document.createElement('p');
    const price = document.createElement('p');

    card.className = 'gt-pdp__related-card';
    card.href = `/products/${productData.handle}`;
    card.dataset.priceCents = String(priceCents);
    card.dataset.productHandle = productData.handle;
    card.dataset.relatedOrder = '99';

    imageWrap.className = 'gt-pdp__related-img';
    if (imageSrc) {
      const image = document.createElement('img');
      image.className = 'gt-pdp__image';
      image.loading = 'lazy';
      image.sizes = '(min-width: 901px) 25vw, 50vw';
      image.src = imageSrc;
      image.alt = imageAlt;
      imageWrap.appendChild(image);
    }

    title.className = 'gt-pdp__related-name';
    title.textContent = productData.title || '';

    price.className = 'gt-pdp__related-price';
    price.textContent = formatRelatedMoney(priceCents);

    card.append(imageWrap, title, price);
    return card;
  };

  const sortRelatedProducts = () => {
    const grid = getRelatedGrid();
    if (!grid) return [];

    const seenHandles = new Set([section.dataset.productHandle]);
    const cards = Array.from(grid.querySelectorAll('.gt-pdp__related-card')).filter((card) => {
      const handle = card.dataset.productHandle || card.getAttribute('href');
      if (!handle || seenHandles.has(handle)) {
        card.remove();
        return false;
      }
      seenHandles.add(handle);
      return true;
    });

    const sortedCards = cards.sort((a, b) => {
      const orderDiff = Number(a.dataset.relatedOrder ?? 99) - Number(b.dataset.relatedOrder ?? 99);
      if (orderDiff !== 0) return orderDiff;
      return Number(a.dataset.priceCents || 0) - Number(b.dataset.priceCents || 0);
    });
    sortedCards.forEach((card, index) => {
        if (grid.children[index] !== card) {
          grid.appendChild(card);
        }
        card.hidden = index >= 4;
      });

    return cards.filter((card) => !card.hidden);
  };

  const fillRelatedFallback = () => {
    const grid = getRelatedGrid();
    if (!grid || relatedFallbackPromise) return relatedFallbackPromise;

    const fallbackCollections = (recommendationsNode?.dataset.fallbackCollections || 'cat-furniture')
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean);

    relatedFallbackPromise = (async () => {
      for (const collectionHandle of fallbackCollections) {
        if (sortRelatedProducts().length >= 4) break;

        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=24`, {
          credentials: 'same-origin'
        });
        if (!response.ok) continue;

        const payload = await response.json();
        const products = Array.isArray(payload.products) ? payload.products : [];

        for (const productData of products) {
          const existingHandles = new Set(
            Array.from(grid.querySelectorAll('.gt-pdp__related-card'))
              .map((card) => card.dataset.productHandle || card.getAttribute('href'))
          );

          if (
            !productData.handle ||
            productData.handle === section.dataset.productHandle ||
            existingHandles.has(productData.handle)
          ) {
            continue;
          }

          grid.appendChild(createRelatedCard(productData));
          if (sortRelatedProducts().length >= 4) break;
        }
      }

      sortRelatedProducts();
    })().catch(() => {
      sortRelatedProducts();
    });

    return relatedFallbackPromise;
  };

  const ensureRelatedProducts = () => {
    if (sortRelatedProducts().length < 4) {
      fillRelatedFallback();
    }
  };

  const updateStickyCta = () => {
    if (!stickyCta || !heroCta) return;

    if (!desktopMedia.matches) {
      stickyCta.classList.add('is-visible');
      return;
    }

    const hasPassedHeroCta = heroCta.getBoundingClientRect().bottom <= 0;
    stickyCta.classList.toggle('is-visible', hasPassedHeroCta);
  };

  const resetProductInfoPin = () => {
    if (!productInfo || !productInfoWrap) return;

    productInfo.classList.remove('is-fixed', 'is-bottom');
    productInfo.style.left = '';
    productInfo.style.width = '';
    productInfo.style.removeProperty('--gt-product-info-max-height');
    productInfo.style.removeProperty('--gt-product-info-top');
    productInfoWrap.style.minHeight = '';
  };

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      section.querySelectorAll('.gt-pdp__variant-btn').forEach((label) => {
        label.classList.toggle('is-selected', label.contains(input));
      });

      priceNodes.forEach((node) => {
        node.textContent = input.dataset.price;
      });

    });
  });

  setAccordionDefaults();
  ensureRelatedProducts();

  if (recommendationsNode) {
    new MutationObserver(ensureRelatedProducts).observe(recommendationsNode, { childList: true });
  }

  if (stickyCta && heroCta) {
    new IntersectionObserver(updateStickyCta, { threshold: 0 }).observe(heroCta);
    window.addEventListener('resize', updateStickyCta, { passive: true });
    updateStickyCta();
  }

  if (productInfo && productInfoWrap && heroGrid) {
    resetProductInfoPin();
    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', resetProductInfoPin);
    }
  }

  window.addEventListener('resize', setAccordionDefaults, { passive: true });
}

document.querySelectorAll('.gt-pdp').forEach(initGardenTunnelPdp);
document.addEventListener('shopify:section:load', (event) => {
  initGardenTunnelPdp(event.target.querySelector('.gt-pdp'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-garden-tunnel-pdp"] && !Shopify.designMode) return;
  try {
    
function injectGardenTunnelCompactRepair() {
  if (document.getElementById('gt-pdp-section-wildone-repair-20260523')) return;

  const style = document.createElement('style');
  style.id = 'gt-pdp-section-wildone-repair-20260523';
  style.textContent = `
    html body .shopify-section .gt-pdp .gt-pdp__hero { margin-top: 0 !important; padding: 0 40px 48px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__hero-grid { align-items: start !important; display: grid !important; gap: 20px !important; grid-template-columns: 1fr 1fr !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery { display: grid !important; gap: 8px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; min-height: 0 !important; overflow: visible !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 4 / 5 !important; height: auto !important; min-height: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { align-self: stretch !important; display: block !important; min-width: 0 !important; padding: 0 !important; position: relative !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { align-self: start !important; bottom: auto !important; left: auto !important; max-height: none !important; overflow: visible !important; padding: 10px 0 22px !important; position: sticky !important; top: calc(var(--header-height, 88px) + 10px) !important; width: auto !important; z-index: 30 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__breadcrumb, html body .shopify-section .gt-pdp .gt-pdp__eyebrow { align-items: center !important; background: #CCBCA8 !important; border-radius: 3px !important; color: #593518 !important; display: inline-flex !important; font-size: 10px !important; letter-spacing: 0.12em !important; line-height: 1.2 !important; margin: 0 0 10px !important; padding: 5px 12px !important; text-transform: uppercase !important; width: fit-content !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info h1 { font-family: Georgia, "Times New Roman", serif !important; font-size: 30px !important; font-weight: 400 !important; letter-spacing: 0 !important; line-height: 1.05 !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__title-meta-row { align-items: center !important; display: flex !important; flex-wrap: wrap !important; gap: 14px !important; justify-content: flex-start !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__lead-inline { color: rgba(89, 53, 24, 0.78) !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 14px !important; font-style: italic !important; line-height: 1.35 !important; margin: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__reviews-inline, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline * { font-size: 13px !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__price { font-family: Georgia, "Times New Roman", serif !important; font-size: 20px !important; line-height: 1 !important; margin: 0 0 22px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-label { color: rgba(89, 53, 24, 0.68) !important; display: block !important; font-size: 11px !important; letter-spacing: 0.16em !important; line-height: 1.2 !important; margin: 0 0 10px !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-options { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 0 !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn { align-items: center !important; display: flex !important; flex-direction: row !important; gap: 10px !important; justify-content: space-between !important; min-height: 46px !important; padding: 0 14px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn span, html body .shopify-section .gt-pdp .gt-pdp__variant-title { font-size: 14px !important; font-weight: 500 !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn small, html body .shopify-section .gt-pdp .gt-pdp__variant-size { color: rgba(89, 53, 24, 0.68) !important; font-size: 12px !important; line-height: 1.2 !important; margin: 0 !important; text-align: right !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 16px 0 30px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row > * { width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap { min-height: 72px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__button, html body .shopify-section .gt-pdp .shopify-payment-button__button { height: 48px !important; min-height: 48px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add { font-size: 13px !important; letter-spacing: 0.08em !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__more-options { display: block !important; font-size: 11px !important; line-height: 1.3 !important; margin: 10px auto 0 !important; text-align: center !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini { align-items: center !important; column-gap: 18px !important; display: grid !important; grid-template-columns: repeat(3, minmax(0, 1fr)) !important; margin: 0 !important; padding: 16px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item { align-items: center !important; display: grid !important; gap: 0 10px !important; grid-template-columns: 40px minmax(0, 1fr) !important; justify-content: flex-start !important; min-width: 0 !important; padding: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > svg, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > picture, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > img:not(.gt-pdp__trust-icon), html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::before, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::after { content: none !important; display: none !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-icon { display: block !important; flex: 0 0 40px !important; height: 40px !important; margin: 0 !important; object-fit: contain !important; width: 40px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-copy { display: block !important; min-width: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-title { display: block !important; font-size: 10.5px !important; letter-spacing: 0.1em !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-sub { font-size: 11px !important; line-height: 1.35 !important; overflow-wrap: normal !important; white-space: normal !important; word-break: normal !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-block { margin-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item:first-child { border-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item { padding: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item summary { font-size: 14px !important; font-weight: 500 !important; padding: 10px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features { clear: both !important; padding: 0 0 40px !important; position: relative !important; z-index: 1 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-heading { margin-left: auto !important; margin-right: auto !important; padding: 48px 0 32px !important; width: calc(100% - 80px) !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-grid { margin-left: auto !important; margin-right: auto !important; padding: 0 !important; width: calc(100% - 80px) !important; }
    @media (max-width: 900px) { html body .shopify-section .gt-pdp .gt-pdp__hero { padding: 0 0 32px !important; } html body .shopify-section .gt-pdp .gt-pdp__hero-grid { display: block !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery { grid-template-columns: 1fr !important; gap: 16px !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; } html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { max-height: none !important; overflow: visible !important; padding: 0 !important; position: relative !important; top: auto !important; } html body .shopify-section .gt-pdp .gt-pdp__features { padding: 0 0 40px !important; } html body .shopify-section .gt-pdp .gt-pdp__features-heading { padding: 32px 0 28px !important; width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__features-grid { width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini { grid-template-columns: 1fr !important; } }
    @media (max-width: 480px) { html body .shopify-section .gt-pdp .gt-pdp__buy-row, html body .shopify-section .gt-pdp .gt-pdp__variant-options { grid-template-columns: 1fr !important; } }
  `;
  document.head.appendChild(style);
}

function initGardenTunnelPdp(section) {
  if (!section || section.dataset.gtInitialized === '20260523-wildone-structure') return;
  section.dataset.gtInitialized = '20260523-wildone-structure';
  injectGardenTunnelCompactRepair();

  const variantInputs = Array.from(section.querySelectorAll('[data-gt-variant-input]'));
  const priceNodes = Array.from(section.querySelectorAll('[data-gt-price], [data-gt-sticky-price]'));
  const stickyCta = section.querySelector('.gt-pdp__sticky-cta');
  const heroCta = section.querySelector('.gt-pdp__cta-add');
  const recommendationsNode = section.querySelector('.gt-pdp__recommendations');
  const heroGrid = section.querySelector('.gt-pdp__hero-grid');
  const productInfoWrap = section.querySelector('.gt-pdp__product-info-wrap');
  const productInfo = section.querySelector('.gt-pdp__product-info');
  const desktopMedia = window.matchMedia('(min-width: 901px)');
  let relatedFallbackPromise = null;

  const setAccordionDefaults = () => {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    section.querySelectorAll('.gt-pdp__accordion-item').forEach((item) => {
      if (isMobile) {
        item.removeAttribute('open');
      } else if (!item.hasAttribute('data-keep-open')) {
        item.removeAttribute('open');
      }
    });
  };

  const getRelatedGrid = () => section.querySelector('.gt-pdp__related-grid');

  const formatRelatedMoney = (priceCents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        currency: window.Shopify?.currency?.active || 'USD',
        style: 'currency'
      }).format(priceCents / 100);
    } catch (error) {
      return `$${(priceCents / 100).toFixed(2)}`;
    }
  };

  const createRelatedCard = (productData) => {
    const variant = productData.variants?.[0] || {};
    const rawPrice = Number.parseFloat(variant.price || productData.price || '0');
    const priceCents = Math.round(rawPrice * 100);
    const imageData = productData.image || productData.images?.[0];
    const imageSrc = typeof imageData === 'string' ? imageData : imageData?.src;
    const imageAlt = (typeof imageData === 'object' && imageData?.alt) || productData.title || '';
    const card = document.createElement('a');
    const imageWrap = document.createElement('div');
    const title = document.createElement('p');
    const price = document.createElement('p');

    card.className = 'gt-pdp__related-card';
    card.href = `/products/${productData.handle}`;
    card.dataset.priceCents = String(priceCents);
    card.dataset.productHandle = productData.handle;
    card.dataset.relatedOrder = '99';

    imageWrap.className = 'gt-pdp__related-img';
    if (imageSrc) {
      const image = document.createElement('img');
      image.className = 'gt-pdp__image';
      image.loading = 'lazy';
      image.sizes = '(min-width: 901px) 25vw, 50vw';
      image.src = imageSrc;
      image.alt = imageAlt;
      imageWrap.appendChild(image);
    }

    title.className = 'gt-pdp__related-name';
    title.textContent = productData.title || '';

    price.className = 'gt-pdp__related-price';
    price.textContent = formatRelatedMoney(priceCents);

    card.append(imageWrap, title, price);
    return card;
  };

  const sortRelatedProducts = () => {
    const grid = getRelatedGrid();
    if (!grid) return [];

    const seenHandles = new Set([section.dataset.productHandle]);
    const cards = Array.from(grid.querySelectorAll('.gt-pdp__related-card')).filter((card) => {
      const handle = card.dataset.productHandle || card.getAttribute('href');
      if (!handle || seenHandles.has(handle)) {
        card.remove();
        return false;
      }
      seenHandles.add(handle);
      return true;
    });

    const sortedCards = cards.sort((a, b) => {
      const orderDiff = Number(a.dataset.relatedOrder ?? 99) - Number(b.dataset.relatedOrder ?? 99);
      if (orderDiff !== 0) return orderDiff;
      return Number(a.dataset.priceCents || 0) - Number(b.dataset.priceCents || 0);
    });
    sortedCards.forEach((card, index) => {
        if (grid.children[index] !== card) {
          grid.appendChild(card);
        }
        card.hidden = index >= 4;
      });

    return cards.filter((card) => !card.hidden);
  };

  const fillRelatedFallback = () => {
    const grid = getRelatedGrid();
    if (!grid || relatedFallbackPromise) return relatedFallbackPromise;

    const fallbackCollections = (recommendationsNode?.dataset.fallbackCollections || 'cat-furniture')
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean);

    relatedFallbackPromise = (async () => {
      for (const collectionHandle of fallbackCollections) {
        if (sortRelatedProducts().length >= 4) break;

        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=24`, {
          credentials: 'same-origin'
        });
        if (!response.ok) continue;

        const payload = await response.json();
        const products = Array.isArray(payload.products) ? payload.products : [];

        for (const productData of products) {
          const existingHandles = new Set(
            Array.from(grid.querySelectorAll('.gt-pdp__related-card'))
              .map((card) => card.dataset.productHandle || card.getAttribute('href'))
          );

          if (
            !productData.handle ||
            productData.handle === section.dataset.productHandle ||
            existingHandles.has(productData.handle)
          ) {
            continue;
          }

          grid.appendChild(createRelatedCard(productData));
          if (sortRelatedProducts().length >= 4) break;
        }
      }

      sortRelatedProducts();
    })().catch(() => {
      sortRelatedProducts();
    });

    return relatedFallbackPromise;
  };

  const ensureRelatedProducts = () => {
    if (sortRelatedProducts().length < 4) {
      fillRelatedFallback();
    }
  };

  const updateStickyCta = () => {
    if (!stickyCta || !heroCta) return;

    if (!desktopMedia.matches) {
      stickyCta.classList.add('is-visible');
      return;
    }

    const hasPassedHeroCta = heroCta.getBoundingClientRect().bottom <= 0;
    stickyCta.classList.toggle('is-visible', hasPassedHeroCta);
  };

  const resetProductInfoPin = () => {
    if (!productInfo || !productInfoWrap) return;

    productInfo.classList.remove('is-fixed', 'is-bottom');
    productInfo.style.left = '';
    productInfo.style.width = '';
    productInfo.style.removeProperty('--gt-product-info-max-height');
    productInfo.style.removeProperty('--gt-product-info-top');
    productInfoWrap.style.minHeight = '';
  };

  variantInputs.forEach((input) => {
    input.addEventListener('change', () => {
      section.querySelectorAll('.gt-pdp__variant-btn').forEach((label) => {
        label.classList.toggle('is-selected', label.contains(input));
      });

      priceNodes.forEach((node) => {
        node.textContent = input.dataset.price;
      });

    });
  });

  setAccordionDefaults();
  ensureRelatedProducts();

  if (recommendationsNode) {
    new MutationObserver(ensureRelatedProducts).observe(recommendationsNode, { childList: true });
  }

  if (stickyCta && heroCta) {
    new IntersectionObserver(updateStickyCta, { threshold: 0 }).observe(heroCta);
    window.addEventListener('resize', updateStickyCta, { passive: true });
    updateStickyCta();
  }

  if (productInfo && productInfoWrap && heroGrid) {
    resetProductInfoPin();
    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', resetProductInfoPin);
    }
  }

  window.addEventListener('resize', setAccordionDefaults, { passive: true });
}

document.querySelectorAll('.gt-pdp').forEach(initGardenTunnelPdp);
document.addEventListener('shopify:section:load', (event) => {
  initGardenTunnelPdp(event.target.querySelector('.gt-pdp'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-prowlet-pdp-standard"] && !Shopify.designMode) return;
  try {
    
function injectProwletStandardCompactRepair() {
  if (document.getElementById('gt-pdp-section-wildone-repair-20260523')) return;

  const style = document.createElement('style');
  style.id = 'gt-pdp-section-wildone-repair-20260523';
  style.textContent = `
    html body .shopify-section .gt-pdp .gt-pdp__hero { margin-top: 0 !important; padding: 0 40px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__hero-grid { align-items: start !important; display: grid !important; gap: 20px !important; grid-template-columns: 1fr 1fr !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery { display: grid !important; gap: 8px !important; grid-template-columns: 1fr !important; min-height: 0 !important; overflow: visible !important; }
    html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; height: auto !important; min-height: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { align-self: stretch !important; display: block !important; min-width: 0 !important; padding: 15px 0 0 !important; position: relative !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { align-self: start !important; bottom: auto !important; left: auto !important; max-height: none !important; overflow: visible !important; padding: 0 0 28px !important; position: sticky !important; top: calc(var(--header-height, 88px) + 15px) !important; width: auto !important; z-index: 30 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__breadcrumb, html body .shopify-section .gt-pdp .gt-pdp__eyebrow { align-items: center !important; background: #CCBCA8 !important; border-radius: 3px !important; color: #593518 !important; display: inline-flex !important; font-size: 10px !important; letter-spacing: 0.12em !important; line-height: 1.2 !important; margin: 0 0 10px !important; padding: 5px 12px !important; text-transform: uppercase !important; width: fit-content !important; }
    html body .shopify-section .gt-pdp .gt-pdp__product-info h1 { font-family: Georgia, "Times New Roman", serif !important; font-size: 30px !important; font-weight: 400 !important; letter-spacing: 0 !important; line-height: 1.05 !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__title-meta-row { align-items: center !important; display: flex !important; flex-wrap: wrap !important; gap: 10px !important; justify-content: flex-start !important; margin: 0 0 10px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__lead-inline { color: rgba(89, 53, 24, 0.78) !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 14px !important; font-style: italic !important; line-height: 1.35 !important; margin: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__reviews-inline, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline * { font-size: 13px !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__price { font-family: Georgia, "Times New Roman", serif !important; font-size: 20px !important; line-height: 1 !important; margin: 0 0 22px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__promo-line { align-items: center !important; align-self: flex-end !important; background: #F0EBE0 !important; border-radius: 999px !important; color: #593518 !important; display: inline-flex !important; font-family: var(--font-body) !important; font-size: 11px !important; font-weight: 600 !important; height: 20px !important; letter-spacing: 0.12em !important; line-height: 1 !important; margin: 0 !important; padding: 5px 12px !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-group--photo-color { margin-top: 22px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-label { color: rgba(89, 53, 24, 0.68) !important; display: block !important; font-size: 11px !important; letter-spacing: 0.16em !important; line-height: 1.2 !important; margin: 0 0 10px !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-options { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 0 !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-options.gt-pdp__variant-options--swatches { align-items: center !important; display: flex !important; gap: 12px !important; grid-template-columns: none !important; margin: 0 !important; width: auto !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn { align-items: center !important; display: flex !important; flex-direction: row !important; gap: 10px !important; justify-content: space-between !important; min-height: 46px !important; padding: 0 14px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-swatch { align-items: center !important; display: inline-flex !important; height: 40px !important; justify-content: center !important; padding: 0 !important; width: 40px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-swatch-dot { border-radius: 50% !important; height: 32px !important; width: 32px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn span, html body .shopify-section .gt-pdp .gt-pdp__variant-title { font-size: 14px !important; font-weight: 500 !important; line-height: 1.2 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__variant-btn small, html body .shopify-section .gt-pdp .gt-pdp__variant-size { color: rgba(89, 53, 24, 0.68) !important; font-size: 12px !important; line-height: 1.2 !important; margin: 0 !important; text-align: right !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; margin: 16px 0 10px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__buy-row > * { width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap { min-height: 72px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__button, html body .shopify-section .gt-pdp .shopify-payment-button__button { height: 48px !important; min-height: 48px !important; width: 100% !important; }
    html body .shopify-section .gt-pdp .gt-pdp__cta-add { font-size: 13px !important; letter-spacing: 0.08em !important; }
    html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__more-options { display: block !important; font-size: 11px !important; line-height: 1.3 !important; margin: 10px auto 0 !important; text-align: center !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini { align-items: center !important; column-gap: 30px !important; display: grid !important; grid-template-columns: repeat(3, max-content) !important; justify-content: space-between !important; margin: 0 !important; padding: 16px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item { align-items: center !important; display: grid !important; gap: 0 14px !important; grid-template-columns: 35px max-content !important; justify-content: flex-start !important; min-width: 0 !important; padding: 0 !important; text-align: left !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:nth-child(n + 2) { grid-template-columns: 35px max-content !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > svg, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > picture, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::before, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item::after { content: none !important; display: none !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > img, html body .shopify-section .gt-pdp .gt-pdp__trust-icon { display: block !important; flex: 0 0 35px !important; height: 35px !important; margin: 0 !important; object-fit: contain !important; width: 35px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:first-child > img, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:first-child .gt-pdp__trust-icon { flex-basis: 35px !important; height: 35px !important; width: 35px !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-copy { display: block !important; min-width: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-title { display: block !important; font-size: 10.5px !important; letter-spacing: 0.1em !important; line-height: 1.2 !important; text-transform: uppercase !important; }
    html body .shopify-section .gt-pdp .gt-pdp__trust-sub { font-size: 11px !important; line-height: 1.35 !important; overflow-wrap: normal !important; white-space: normal !important; word-break: normal !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-block { margin-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item:first-child { border-top: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item { padding: 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__accordion-item summary { font-size: 14px !important; font-weight: 500 !important; padding: 10px 0 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features { clear: both !important; padding: 0 0 100px !important; position: relative !important; z-index: 1 !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-heading { margin-left: auto !important; margin-right: auto !important; padding: 40px 0 32px !important; width: calc(100% - 80px) !important; }
    html body .shopify-section .gt-pdp .gt-pdp__features-grid { margin-left: auto !important; margin-right: auto !important; padding: 0 !important; width: calc(100% - 80px) !important; }
    @media (max-width: 900px) { html body .shopify-section .gt-pdp .gt-pdp__hero { padding: 0 !important; } html body .shopify-section .gt-pdp .gt-pdp__hero-grid { display: block !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery { grid-template-columns: 1fr !important; gap: 16px !important; } html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; } html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { padding: 32px 24px 32px !important; } html body .shopify-section .gt-pdp .gt-pdp__product-info, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-fixed, html body .shopify-section .gt-pdp .gt-pdp__product-info.is-bottom { max-height: none !important; overflow: visible !important; padding: 0 !important; position: relative !important; top: auto !important; } html body .shopify-section .gt-pdp .gt-pdp__features { padding: 0 0 40px !important; } html body .shopify-section .gt-pdp .gt-pdp__features-heading { padding: 20px 0 28px !important; width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__features-grid { width: calc(100% - 40px) !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini { grid-template-columns: 1fr !important; justify-content: stretch !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item { grid-template-columns: 40px minmax(0, 1fr) !important; } html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:nth-child(n + 2) { grid-template-columns: 40px minmax(0, 1fr) !important; } }
    @media (max-width: 480px) { html body .shopify-section .gt-pdp .gt-pdp__buy-row, html body .shopify-section .gt-pdp .gt-pdp__variant-options { grid-template-columns: 1fr !important; } }
    @media (max-width: 900px) {
      html body .shopify-section .gt-pdp .gt-pdp__hero { padding: 0 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__hero-grid { display: flex !important; flex-direction: column !important; gap: 0 !important; grid-template-columns: none !important; position: relative !important; }
      html body .shopify-section .gt-pdp .gt-pdp__gallery { display: flex !important; gap: 0 !important; grid-template-columns: none !important; margin: 0 !important; order: 2 !important; overflow-x: auto !important; overflow-y: hidden !important; padding: 0 !important; position: relative !important; scroll-snap-type: x mandatory !important; scrollbar-width: none !important; width: 100% !important; -webkit-overflow-scrolling: touch !important; }
      html body .shopify-section .gt-pdp .gt-pdp__gallery-frame, html body .shopify-section .gt-pdp .gt-pdp__gallery-img { aspect-ratio: 1 / 1 !important; flex: 0 0 100% !important; min-height: 0 !important; position: relative !important; scroll-snap-align: start !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__gallery-arrow { align-items: center !important; background: transparent !important; border: 0 !important; border-radius: 0 !important; color: rgba(44, 24, 16, 0.42) !important; display: flex !important; font-family: Georgia, "Times New Roman", serif !important; font-size: 34px !important; font-weight: 400 !important; height: 52px !important; justify-content: center !important; line-height: 1 !important; padding: 0 !important; position: absolute !important; text-shadow: 0 1px 3px rgba(250, 247, 242, 0.8) !important; top: 50% !important; transform: translateY(-50%) !important; width: 36px !important; z-index: 6 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__gallery-arrow--prev { left: 8px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__gallery-arrow--next { right: 8px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__product-info-wrap { order: 1 !important; padding: 8px 24px 8px !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__mobile-purchase-wrap { order: 3 !important; padding: 18px 24px 0 !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__breadcrumb, html body .shopify-section .gt-pdp .gt-pdp__eyebrow { margin: 0 0 6px !important; padding: 5px 12px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__title-meta-row { align-items: center !important; display: flex !important; flex-wrap: nowrap !important; gap: 6px !important; margin: 0 0 8px !important; overflow: visible !important; }
      html body .shopify-section .gt-pdp .gt-pdp__lead-inline { flex: 1 1 auto !important; font-size: 14.5px !important; line-height: 1.25 !important; min-width: 0 !important; white-space: nowrap !important; }
      html body .shopify-section .gt-pdp .gt-pdp__price-row { align-items: center !important; display: flex !important; gap: 10px !important; justify-content: flex-start !important; margin: 0 0 10px !important; min-height: 30px !important; white-space: nowrap !important; }
      html body .shopify-section .gt-pdp .gt-pdp__reviews-inline { align-items: center !important; display: inline-flex !important; flex: 0 0 auto !important; gap: 4px !important; height: 30px !important; justify-content: flex-start !important; line-height: 1 !important; min-height: 30px !important; white-space: nowrap !important; }
      html body .shopify-section .gt-pdp .gt-pdp__reviews-inline .jdgm-prev-badge, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline .jdgm-prev-badge__stars, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline .jdgm-prev-badge__text { align-items: center !important; display: inline-flex !important; gap: 4px !important; height: 30px !important; line-height: 30px !important; min-height: 30px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__reviews-inline, html body .shopify-section .gt-pdp .gt-pdp__reviews-inline * { font-size: 13px !important; line-height: 1 !important; margin-bottom: 0 !important; margin-top: 0 !important; vertical-align: middle !important; }
      html body .shopify-section .gt-pdp .gt-pdp__price { align-items: center !important; display: inline-flex !important; line-height: 1 !important; margin: 0 !important; min-height: 30px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__promo-line { align-self: flex-end !important; margin: 0 !important; }
      html body #MainContent .shopify-section .gt-pdp .gt-pdp__price-row { align-items: flex-start !important; min-height: 56px !important; }
      html body #MainContent .shopify-section .gt-pdp .gt-pdp__price { min-height: 56px !important; padding-bottom: 26px !important; position: relative !important; }
      html body #MainContent .shopify-section .gt-pdp .gt-pdp__promo-line { align-self: flex-start !important; left: 0 !important; position: absolute !important; top: 36px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__buy-row, html body .shopify-section .gt-pdp .gt-pdp__variant-options { display: grid !important; gap: 12px !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__variant-options.gt-pdp__variant-options--swatches { align-items: center !important; display: flex !important; gap: 12px !important; grid-template-columns: none !important; width: auto !important; }
      html body .shopify-section .gt-pdp .gt-pdp__variant-swatch { align-items: center !important; display: inline-flex !important; height: 40px !important; justify-content: center !important; padding: 0 !important; width: 40px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__variant-swatch-dot { border-radius: 50% !important; height: 32px !important; width: 32px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__variant-options--photo-swatches .gt-pdp__variant-swatch { height: 48px !important; width: 48px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__variant-options--photo-swatches .gt-pdp__variant-swatch-dot { height: 40px !important; width: 40px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__cta-add, html body .shopify-section .gt-pdp .product-form__submit, html body .shopify-section .gt-pdp button[name='add'], html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap, html body .shopify-section .gt-pdp .shopify-payment-button, html body .shopify-section .gt-pdp .shopify-payment-button__button { height: 50px !important; min-height: 50px !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap, html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button { height: auto !important; min-height: 72px !important; overflow: visible !important; }
      html body .shopify-section .gt-pdp .gt-pdp__variant-btn { height: 50px !important; min-height: 50px !important; padding: 0 12px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__variant-btn:not(.is-selected):not(.is-disabled) { border: 1px solid rgba(89, 53, 24, 0.28) !important; }
      html body .shopify-section .gt-pdp .gt-pdp__shop-pay-wrap .shopify-payment-button__more-options { margin: 8px auto 11px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__trust-mini { align-items: start !important; display: grid !important; gap: 0 !important; grid-template-columns: repeat(3, max-content) !important; justify-content: space-between !important; margin: 4px 0 0 !important; padding: 18px 0 20px !important; width: 100% !important; }
      html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:nth-child(n + 2) { align-items: center !important; display: flex !important; flex-direction: column !important; gap: 8px !important; grid-template-columns: none !important; justify-content: flex-start !important; min-width: 0 !important; padding: 0 !important; text-align: center !important; width: auto !important; }
      html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item > img, html body .shopify-section .gt-pdp .gt-pdp__trust-icon { flex: 0 0 35px !important; height: 35px !important; margin: 0 auto !important; object-fit: contain !important; width: 35px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:first-child > img, html body .shopify-section .gt-pdp .gt-pdp__trust-mini-item:first-child .gt-pdp__trust-icon { flex: 0 0 35px !important; height: 35px !important; margin: 0 auto !important; max-height: 35px !important; max-width: 35px !important; transform: none !important; width: 35px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__trust-title { font-size: 9.5px !important; font-weight: 650 !important; letter-spacing: 0.04em !important; line-height: 1.15 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__trust-sub { font-size: 10px !important; letter-spacing: 0 !important; line-height: 1.2 !important; white-space: nowrap !important; }
      html body .shopify-section .gt-pdp .gt-pdp__mobile-purchase-wrap { padding-bottom: 0 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__accordion-block { margin-bottom: 0 !important; padding-bottom: 0 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__accordion-item:last-child { margin-bottom: 0 !important; padding-bottom: 0 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__ugc { margin: 20px 0 0 !important; padding-top: 0 !important; padding-bottom: 28px !important; }
      html body .shopify-section .gt-pdp .gt-pdp__ugc .gt-pdp__section-title { margin-top: 0 !important; }
      html body .shopify-section .gt-pdp .gt-pdp__features-heading { padding: 20px 0 24px !important; }
    }
    @media (max-width: 480px) {
      html body .shopify-section .gt-pdp .gt-pdp__buy-row,
      html body .shopify-section .gt-pdp .gt-pdp__variant-options { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
      html body .shopify-section .gt-pdp .gt-pdp__variant-options.gt-pdp__variant-options--swatches { display: flex !important; grid-template-columns: none !important; }
    }
  `;
  document.head.appendChild(style);
}

function initProwletStandardPdp(section) {
  if (!section || section.dataset.gtInitialized === '20260704-sticky-video-io') return;
  section.dataset.gtInitialized = '20260704-sticky-video-io';
  injectProwletStandardCompactRepair();

  const optionInputs = Array.from(section.querySelectorAll('[data-gt-option-input]'));
  const variantIdInput = section.querySelector('[data-gt-product-variant-id]');
  const variantDataNode = section.querySelector('[data-gt-variants]');
  let variants = [];
  if (variantDataNode) {
    try {
      variants = JSON.parse(variantDataNode.textContent || '[]');
    } catch (error) {
      variants = [];
    }
  }
  const priceNodes = Array.from(section.querySelectorAll('[data-gt-price], [data-gt-sticky-price]'));
  const comparePriceNodes = Array.from(section.querySelectorAll('[data-gt-compare-price], [data-gt-sticky-compare-price]'));
  const variantChoiceSelector = '.gt-pdp__variant-btn, .gt-pdp__variant-swatch';
  const stickyCta = section.querySelector('.gt-pdp__sticky-cta');
  const heroCta = section.querySelector('.gt-pdp__cta-add');
  const stickySentinel = section.querySelector('[data-gt-sticky-sentinel]');
  const recommendationsNode = section.querySelector('.gt-pdp__recommendations');
  const heroGrid = section.querySelector('.gt-pdp__hero-grid');
  const productInfoWrap = section.querySelector('.gt-pdp__product-info-wrap');
  const productInfo = section.querySelector('.gt-pdp__product-info');
  const desktopMedia = window.matchMedia('(min-width: 901px)');
  let heroCtaTriggerBottom = heroCta ? window.scrollY + heroCta.getBoundingClientRect().bottom : 0;
  const captureHeroCtaTrigger = () => {
    if (!heroCta || window.scrollY > 8) return;
    heroCtaTriggerBottom = window.scrollY + heroCta.getBoundingClientRect().bottom;
  };
  const setAccordionDefaults = () => {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    section.querySelectorAll('.gt-pdp__accordion-item').forEach((item) => {
      if (isMobile) {
        item.removeAttribute('open');
      } else if (!item.hasAttribute('data-keep-open')) {
        item.removeAttribute('open');
      }
    });
  };

  const getRelatedGrid = () => section.querySelector('.gt-pdp__related-grid');

  const formatRelatedMoney = (priceCents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        currency: window.Shopify?.currency?.active || 'USD',
        style: 'currency'
      }).format(priceCents / 100);
    } catch (error) {
      return `$${(priceCents / 100).toFixed(2)}`;
    }
  };

  const MONA_LISA_HANDLE = 'mona-lisa-cat-scratcher-bed';

  const normalizeMonaLisaRelatedCard = (card) => {
    if (card.dataset.productHandle !== MONA_LISA_HANDLE) return;
    card.dataset.priceCents = '15900';
    const price = card.querySelector('.gt-pdp__related-price');
    if (price && !price.textContent.includes('Full Set')) {
      price.textContent = `Full Set — ${formatRelatedMoney(15900)}`;
    }
  };

  const sortRelatedProducts = () => {
    const grid = getRelatedGrid();
    if (!grid) return [];

    const seenHandles = new Set([section.dataset.productHandle]);
    const cards = Array.from(grid.querySelectorAll('.gt-pdp__related-card')).filter((card) => {
      const handle = card.dataset.productHandle || card.getAttribute('href');
      if (!handle || seenHandles.has(handle)) {
        card.remove();
        return false;
      }
      seenHandles.add(handle);
      return true;
    });
    cards.forEach(normalizeMonaLisaRelatedCard);

    const sortedCards = cards.sort((a, b) => {
      const orderDiff = Number(a.dataset.relatedOrder ?? 99) - Number(b.dataset.relatedOrder ?? 99);
      if (orderDiff !== 0) return orderDiff;
      return Number(a.dataset.priceCents || 0) - Number(b.dataset.priceCents || 0);
    });
    sortedCards.forEach((card, index) => {
        if (grid.children[index] !== card) {
          grid.appendChild(card);
        }
        card.hidden = index >= 4;
      });

    return cards.filter((card) => !card.hidden);
  };

  const ensureRelatedProducts = () => {
    sortRelatedProducts();
  };

  const updateStickyCta = (entry) => {
    if (!stickyCta || !heroCta) return;

    const maybeEntry = Array.isArray(entry) ? entry[0] : entry;
    const sentinelEntry = maybeEntry && 'isIntersecting' in maybeEntry ? maybeEntry : null;
    const passedHeroCta = sentinelEntry
      ? !sentinelEntry.isIntersecting && sentinelEntry.boundingClientRect.bottom <= 0
      : heroCta.getBoundingClientRect().bottom <= 0;
    const footer = document.querySelector('.shopify-section-group-footer-group, footer');
    const footerHasEnteredViewport = desktopMedia.matches
      && footer
      && footer.getBoundingClientRect().top < window.innerHeight;
    stickyCta.classList.toggle('is-visible', passedHeroCta && !footerHasEnteredViewport);
  };

  const resetProductInfoPin = () => {
    if (!productInfo || !productInfoWrap) return;

    productInfo.classList.remove('is-fixed', 'is-bottom');
    productInfo.style.left = '';
    productInfo.style.width = '';
    productInfo.style.removeProperty('--gt-product-info-max-height');
    productInfo.style.removeProperty('--gt-product-info-top');
    productInfoWrap.style.minHeight = '';
  };

  const lockMobileGallery = () => {
    if (!window.matchMedia('(max-width: 900px)').matches) return;

    if (heroGrid) {
      heroGrid.style.setProperty('display', 'flex', 'important');
      heroGrid.style.setProperty('flex-direction', 'column', 'important');
      heroGrid.style.setProperty('gap', '0', 'important');
      heroGrid.style.setProperty('grid-template-columns', 'none', 'important');
      heroGrid.style.setProperty('position', 'relative', 'important');
    }

    if (productInfoWrap) {
      productInfoWrap.style.setProperty('order', '1', 'important');
      productInfoWrap.style.setProperty('padding', '8px 24px 8px', 'important');
      productInfoWrap.style.setProperty('width', '100%', 'important');
    }

    const price = section.querySelector('.gt-pdp__price');
    const reviews = section.querySelector('.gt-pdp__reviews-inline');
    if (price && reviews) {
      let priceRow = section.querySelector('.gt-pdp__price-row');
      if (!priceRow) {
        priceRow = document.createElement('div');
        priceRow.className = 'gt-pdp__price-row';
        price.insertAdjacentElement('beforebegin', priceRow);
      }
      if (price.parentElement !== priceRow) priceRow.appendChild(price);
      if (reviews.parentElement !== priceRow) priceRow.appendChild(reviews);
    }

    const gallery = section.querySelector('.gt-pdp__gallery');
    if (gallery) {
      gallery.style.setProperty('display', 'flex', 'important');
      gallery.style.setProperty('gap', '0', 'important');
      gallery.style.setProperty('grid-template-columns', 'none', 'important');
      gallery.style.setProperty('order', '2', 'important');
      gallery.style.setProperty('overflow-x', 'auto', 'important');
      gallery.style.setProperty('overflow-y', 'hidden', 'important');
      gallery.style.setProperty('padding', '0', 'important');
      gallery.style.setProperty('position', 'relative', 'important');
      gallery.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
      gallery.style.setProperty('width', '100%', 'important');
      gallery.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
    }

    if (heroGrid && productInfo && gallery) {
      let purchaseWrap = section.querySelector('.gt-pdp__mobile-purchase-wrap');
      if (!purchaseWrap) {
        purchaseWrap = document.createElement('div');
        purchaseWrap.className = 'gt-pdp__mobile-purchase-wrap';
        gallery.insertAdjacentElement('afterend', purchaseWrap);
      } else if (purchaseWrap.previousElementSibling !== gallery) {
        gallery.insertAdjacentElement('afterend', purchaseWrap);
      }

      ['.gt-pdp__form', '.gt-pdp__trust-mini', '.gt-pdp__accordion-block'].forEach((selector) => {
        const node = section.querySelector(selector);
        if (node && node.parentElement !== purchaseWrap) purchaseWrap.appendChild(node);
      });

      purchaseWrap.style.setProperty('order', '3', 'important');
      purchaseWrap.style.setProperty('padding', '18px 24px 0', 'important');
      purchaseWrap.style.setProperty('width', '100%', 'important');
    }

    section.querySelectorAll('.gt-pdp__gallery-frame, .gt-pdp__gallery-img').forEach((frame) => {
      frame.style.setProperty('aspect-ratio', '1 / 1', 'important');
      frame.style.setProperty('flex', '0 0 100%', 'important');
      frame.style.setProperty('min-height', '0', 'important');
      frame.style.setProperty('position', 'relative', 'important');
      frame.style.setProperty('scroll-snap-align', 'start', 'important');
      frame.style.setProperty('width', '100%', 'important');
    });

    if (heroGrid && gallery) {
      gallery.querySelectorAll('.gt-pdp__gallery-arrow').forEach((button) => button.remove());

      const buildLoopingGallery = () => {
        const loopVersion = '20260606-v36';
        const getFrames = () => Array.from(gallery.children)
          .filter((frame) => frame.matches('.gt-pdp__gallery-frame, .gt-pdp__gallery-img'));
        const getLoopMetrics = () => {
          const frames = getFrames();
          const originalCount = frames.filter((frame) => !frame.classList.contains('gt-pdp__gallery-clone')).length;
          const width = gallery.clientWidth || frames[0]?.clientWidth || 0;
          if (!width || originalCount < 2) return null;

          const lastIndex = frames.length - 1;
          const hasLeadingClone = frames[0]?.classList.contains('gt-pdp__gallery-clone');
          const hasTrailingClone = frames[lastIndex]?.classList.contains('gt-pdp__gallery-clone');
          return {
            width,
            lastIndex,
            firstOriginalIndex: hasLeadingClone ? 1 : 0,
            lastOriginalIndex: hasTrailingClone ? lastIndex - 1 : lastIndex,
            hasLeadingClone,
            hasTrailingClone
          };
        };
        const resetToFirstOriginal = () => {
          if (gallery.dataset.gtLoopUserInteracted === 'true') return;
          const metrics = getLoopMetrics();
          if (!metrics) return;
          gallery.scrollTo({ left: metrics.firstOriginalIndex * metrics.width, behavior: 'auto' });
        };

        if (gallery.dataset.gtLoopInteractionReady !== loopVersion) {
          gallery.dataset.gtLoopInteractionReady = loopVersion;
          ['touchstart', 'pointerdown', 'mousedown'].forEach((eventName) => {
            gallery.addEventListener(eventName, () => {
              gallery.dataset.gtLoopUserInteracted = 'true';
            }, { passive: true });
          });
        }

        if (gallery.dataset.gtMobileLoopReady !== loopVersion) {
          gallery.querySelectorAll('.gt-pdp__gallery-clone').forEach((clone) => clone.remove());

          const originals = Array.from(gallery.children)
            .filter((frame) => frame.matches('.gt-pdp__gallery-frame, .gt-pdp__gallery-img') && !frame.classList.contains('gt-pdp__gallery-clone'));

          if (originals.length > 1) {
            const firstClone = originals[0].cloneNode(true);
            const lastClone = originals[originals.length - 1].cloneNode(true);

            firstClone.classList.add('gt-pdp__gallery-clone');
            lastClone.classList.add('gt-pdp__gallery-clone');
            firstClone.setAttribute('aria-hidden', 'true');
            lastClone.setAttribute('aria-hidden', 'true');
            firstClone.dataset.gtClone = 'first';
            lastClone.dataset.gtClone = 'last';

            gallery.insertBefore(lastClone, originals[0]);
            gallery.appendChild(firstClone);
            gallery.dataset.gtMobileLoopReady = loopVersion;
            gallery.dataset.gtMobileFinalLoopReady = loopVersion;
            gallery.dataset.gtRouteLoopReady = loopVersion;
            resetToFirstOriginal();
            requestAnimationFrame(resetToFirstOriginal);
          }
        }

        if (gallery.dataset.gtLoopScrollReady !== loopVersion) {
          gallery.dataset.gtLoopScrollReady = loopVersion;
          let loopTimer = null;
          gallery.addEventListener('scroll', () => {
            window.clearTimeout(loopTimer);
            loopTimer = window.setTimeout(() => {
              const metrics = getLoopMetrics();
              if (!metrics) return;

              const index = Math.round(gallery.scrollLeft / metrics.width);
              const userInteracted = gallery.dataset.gtLoopUserInteracted === 'true';
              if (metrics.hasLeadingClone && index <= 0) {
                gallery.scrollTo({
                  left: (userInteracted ? metrics.lastOriginalIndex : metrics.firstOriginalIndex) * metrics.width,
                  behavior: 'auto'
                });
              } else if (metrics.hasTrailingClone && index >= metrics.lastIndex) {
                gallery.scrollTo({ left: metrics.firstOriginalIndex * metrics.width, behavior: 'auto' });
              }
            }, 90);
          }, { passive: true });
        }
      };

      buildLoopingGallery();

      const makeArrow = (modifier, label, text, direction) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `gt-pdp__gallery-arrow gt-pdp__gallery-arrow--${modifier}`;
        button.setAttribute('aria-label', label);
        button.textContent = text;
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          gallery.dataset.gtLoopUserInteracted = 'true';
          const width = gallery.clientWidth || 1;
          const currentIndex = Math.round(gallery.scrollLeft / width);
          gallery.scrollTo({
            left: (currentIndex + direction) * width,
            behavior: 'smooth'
          });
        });
        return button;
      };

      Array.from(gallery.children)
        .filter((frame) => frame.matches('.gt-pdp__gallery-frame, .gt-pdp__gallery-img'))
        .forEach((frame) => {
          frame.style.setProperty('position', 'relative', 'important');
          frame.appendChild(makeArrow('prev', 'Previous product image', '‹', -1));
          frame.appendChild(makeArrow('next', 'Next product image', '›', 1));
          frame.dataset.gtMobileArrowsReady = '20260604-v33';
        });
      heroGrid.dataset.gtMobileArrowsReady = '20260604-v33';
    }
  };

  const getUgcVideos = () => Array.from(section.querySelectorAll('video.gt-pdp__ugc-video'));

  const prepareUgcVideos = () => {
    getUgcVideos().forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'none');
    });
  };

  const playUgcVideos = () => {
    getUgcVideos().forEach((video) => {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    });
  };

  const pauseUgcVideos = () => {
    getUgcVideos().forEach((video) => {
      video.pause();
    });
  };


  const initUgcVideoPlayback = () => {
    if (section.querySelector('[data-gt-ugc-carousel]')) return;
    const ugcVideos = getUgcVideos();
    if (!ugcVideos.length) return;

    prepareUgcVideos();
    pauseUgcVideos();

    const ugcRow = section.querySelector('.gt-pdp__ugc-grid') || section.querySelector('.gt-pdp__ugc');
    if (!ugcRow || !('IntersectionObserver' in window)) {
      playUgcVideos();
      return;
    }

    new IntersectionObserver((entries) => {
      const isVisible = entries.some((entry) => entry.isIntersecting);
      if (isVisible) {
        playUgcVideos();
      } else {
        pauseUgcVideos();
      }
    }, {
      rootMargin: '120px 0px',
      threshold: 0.12
    }).observe(ugcRow);
  };

  const lazyLoadReviewImages = () => {
    section.querySelectorAll('.gt-pdp__judgeme img').forEach((image) => {
      image.loading = 'lazy';
      image.decoding = 'async';
    });
  };

  const syncVariantMedia = (input, behavior = 'smooth') => {
    if (!input || !input.dataset.gtVariantMedia) return;
    const gallery = section.querySelector('.gt-pdp__gallery');
    if (!gallery) return;

    const targetFrame = Array.from(gallery.querySelectorAll('[data-media-id]'))
      .find((frame) => frame.dataset.mediaId === input.dataset.gtVariantMedia && !frame.classList.contains('gt-pdp__gallery-clone'));
    if (!targetFrame) return;

    if (window.matchMedia('(max-width: 900px)').matches) {
      gallery.dataset.gtLoopUserInteracted = 'true';
      gallery.scrollTo({
        left: targetFrame.offsetLeft,
        behavior
      });
      return;
    }

    targetFrame.scrollIntoView({
      block: 'start',
      inline: 'nearest',
      behavior
    });
  };

  const updateOptionLabel = (input) => {
    if (!input) return;
    const group = input.closest('[data-gt-option-group]');
    const optionLabel = group?.querySelector('[data-gt-option-label]');
    if (!optionLabel) return;
    optionLabel.textContent = input.dataset.optionValue || input.value || '';
  };

  const syncPriceDisplay = (input) => {
    if (!input) return;

    priceNodes.forEach((node) => {
      node.textContent = input.dataset.price || '';
    });

    const priceCents = Number(input.dataset.priceCents || 0);
    const comparePriceCents = Number(input.dataset.comparePriceCents || 0);
    const shouldShowComparePrice = comparePriceCents > priceCents && Boolean(input.dataset.comparePrice);

    comparePriceNodes.forEach((node) => {
      node.textContent = shouldShowComparePrice ? input.dataset.comparePrice : '';
      node.hidden = !shouldShowComparePrice;
    });
  };

  const getSelectedOptionValues = () => Array.from(section.querySelectorAll('[data-gt-option-group]')).map((group) => {
    const checked = group.querySelector('[data-gt-option-input]:checked');
    return checked?.dataset.optionValue || checked?.value || '';
  });

  const findSelectedVariant = () => {
    const selectedOptions = getSelectedOptionValues();
    return variants.find((variant) => variant.options.every((value, index) => value === selectedOptions[index]));
  };

  const decorateInputWithVariant=(i,v)=>{
    if(!i||!v)return;
    i.dataset.title=v.options.join(' / ');
    i.dataset.price=v.priceFormatted||'';
    i.dataset.priceCents=String(v.price||0);
    i.dataset.comparePrice=v.comparePriceFormatted||'';
    i.dataset.comparePriceCents=String(v.comparePrice||0);
    const f=section.querySelectorAll('.gt-pdp__gallery>[data-media-id]:not(.gt-pdp__gallery-clone)');
    i.dataset.gtVariantMedia=i.closest('.gt-pdp__variant-group--photo-color')?f[i.value==='Meadow Cream'?f.length-1:0]?.dataset.mediaId||'':v.featuredMediaId||'';
  };

  const updateOptionAvailability = () => {
    const selectedOptions = getSelectedOptionValues();
    optionInputs.forEach((input) => {
      const optionIndex = Number(input.dataset.optionPosition || 1) - 1;
      const candidateOptions = [...selectedOptions];
      candidateOptions[optionIndex] = input.dataset.optionValue || input.value;
      const canSelect = variants.some((variant) => variant.available && variant.options.every((value, index) => value === candidateOptions[index]));
      input.disabled = !canSelect;
      input.closest(variantChoiceSelector)?.classList.toggle('is-disabled', !canSelect);
    });
  };

  const syncSelectedVariant = (input, { syncMedia = true, updateUrl = true } = {}) => {
    const variant = findSelectedVariant();
    if (!variant) {
      if (heroCta) heroCta.disabled = true;
      return;
    }

    if (variantIdInput) variantIdInput.value = variant.id;
    decorateInputWithVariant(input, variant);
    syncPriceDisplay(input);
    if (heroCta) heroCta.disabled = !variant.available;
    if (syncMedia) syncVariantMedia(input);
    updateOptionAvailability();

    if (updateUrl && window.history?.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  };

  optionInputs.forEach((input) => {
    input.addEventListener('change', () => {
      const group = input.closest('[data-gt-option-group]');
      group?.querySelectorAll(variantChoiceSelector).forEach((label) => {
        label.classList.toggle('is-selected', label.contains(input));
      });

      updateOptionLabel(input);
      section.dataset.gtVariantMediaUserInteracted = 'true';
      syncSelectedVariant(input);
    });
  });

  section.querySelectorAll(variantChoiceSelector).forEach((label) => {
    if (label.dataset.gtVariantClickReady === 'true') return;
    label.dataset.gtVariantClickReady = 'true';

    label.addEventListener('click', (event) => {
      const input = label.querySelector('[data-gt-option-input]');
      if (!input || input.disabled) return;

      event.preventDefault();
      event.stopPropagation();

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      label.closest('[data-gt-option-group]')?.querySelectorAll(variantChoiceSelector).forEach((option) => {
        option.classList.toggle('is-selected', option === label);
      });
    }, true);
  });

  const resetInitialGalleryToFirstMedia = () => {
    if (section.dataset.gtVariantMediaUserInteracted === 'true') return;

    const gallery = section.querySelector('.gt-pdp__gallery');
    if (!gallery) return;

    const firstFrame = Array.from(gallery.querySelectorAll('.gt-pdp__gallery-frame, .gt-pdp__gallery-img'))
      .find((frame) => !frame.classList.contains('gt-pdp__gallery-clone'));
    if (!firstFrame) return;

    if (window.matchMedia('(max-width: 900px)').matches) {
      if (gallery.dataset.gtLoopUserInteracted === 'true') return;
      gallery.scrollTo({
        left: firstFrame.offsetLeft,
        behavior: 'auto'
      });
      return;
    }
  };

  setAccordionDefaults();
  lockMobileGallery();
  initUgcVideoPlayback();
  lazyLoadReviewImages();
  const initialOptionInput = section.querySelector('[data-gt-option-input]:checked');
  optionInputs.filter((input) => input.checked).forEach(updateOptionLabel);
  if (initialOptionInput) syncSelectedVariant(initialOptionInput, { syncMedia: false, updateUrl: false });
  requestAnimationFrame(resetInitialGalleryToFirstMedia);
  window.addEventListener('load', lazyLoadReviewImages, { once: true });
  ensureRelatedProducts();

  if (recommendationsNode) {
    new MutationObserver(ensureRelatedProducts).observe(recommendationsNode, { childList: true });
  }

  if (stickyCta && heroCta) {
    const stickyTrigger = heroCta;
    captureHeroCtaTrigger();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => updateStickyCta(entries[0]), { threshold: 0 }).observe(stickyTrigger);
    }
    window.addEventListener('scroll', updateStickyCta, { passive: true });
    window.addEventListener('resize', () => {
      captureHeroCtaTrigger();
      updateStickyCta();
    }, { passive: true });
    updateStickyCta();
  }

  if (productInfo && productInfoWrap && heroGrid) {
    resetProductInfoPin();
    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', resetProductInfoPin);
    }
  }

  window.addEventListener('resize', setAccordionDefaults, { passive: true });
  window.addEventListener('resize', lockMobileGallery, { passive: true });
}

document.querySelectorAll('.gt-pdp').forEach(initProwletStandardPdp);
document.addEventListener('shopify:section:load', (event) => {
  initProwletStandardPdp(event.target.querySelector('.gt-pdp'));
});

  } catch(e) { console.error(e); }
})();
})();
